var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientAuthBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440.52-14.777H-7.273V476.26H1440.52V-14.777Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.104 684.951c136.666 0 247.456-97.723 247.456-218.271 0-120.547-110.79-218.27-247.456-218.27s-247.456 97.723-247.456 218.27c0 120.548 110.79 218.271 247.456 218.271Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-6.736 333.069-4.319 567.167H1440.53V303.52s-406.52 30.088-569.738 138.724c-80.3 53.453-313.952-7.289-364.736-11.668-50.785-4.38-363.915-112.1-512.792-97.507Z",
    fill: "#7F8C71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.06 294.645s-26.5-25.729-20.99-67.971c5.51-42.242 20.44-81.789 23.81-88.681 3.37-6.893 12.59-8.819 17.02 3.51s14.88 55.184 4.14 98.53c-10.74 43.347-16.24 48.69-17.36 55.009-1.12 6.32 10.52 388.06 11.3 448.439.78 60.378-1.44 142.544-1.44 142.544l-10.11-.613s6.98-103.179 3.08-209.855c-3.89-106.676-9.45-380.912-9.45-380.912Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.223 234.199s-3.368-37.223-.276-57.266c2.291-14.903 6.98-4.77 26.342 16.977 19.363 21.748 59.201 82.349 65.471 99.313 16.64 44.997 10.78 81.27 10.78 81.27s-52.38-14.444-72.276-51.836c-19.895-37.391-24.604-52.677-30.041-88.458Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.76 335.542c8.56-23.971 18.86-51.169 30.92-68.254 12.06-17.086 67.93-60.446 71.87-58.54 3.93 1.907-11.72 30.991-15.98 44.109-4.27 13.117-10.32 46.122-22.42 64.312-12.1 18.191-44.87 42.923-59.18 49.855-14.32 6.933-33.78 32.608-25.97 20.683 7.82-11.924 20.76-52.165 20.76-52.165Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.888 539.528s2.776 21.108 10.779 23.257c8.004 2.149 25.203-14.613 34.283-30.762 9.08-16.149 34.83-86.909 38.92-102.27 4.1-15.361 11.77-49.586 3.05-50.455-8.72-.869-58.985 31.497-73.032 72.384-14.047 40.888-19.235 49.896-14 87.846Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.91 370.801s49.94 33.066 66.69 52.449c16.76 19.382 43.49 66.064 43.32 107.235-.16 41.171-29.45 8.239-47.11-6.185s-53.43-84.612-58.11-102.014c-4.67-17.402-4.79-51.485-4.79-51.485Z",
    fill: "#244045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.847 723.81s-12.801-22.906 14.592-55.871c27.394-32.965 94.461-78.824 132.451-86.235 37.98-7.411-27.2 74.412-43.67 92.71-16.46 18.298-88.302 73.576-103.373 49.396Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.03 579.85s63.53 43.192 78.67 76.076c15.14 32.884-3.97 36.273-21.93 30.647-17.96-5.625-64.93-39.675-74.91-60.142-9.99-20.468-24.21-55.743-11.19-57.616 13.01-1.873 29.36 11.035 29.36 11.035Z",
    fill: "#23363E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.003 848.164s-22.489 43.603 29.892 44.337c52.382.734 105.965-71.225 117.695-88.883 11.73-17.658 19.37-33.134 15.71-37.728-3.65-4.595-32.1-22.024-67.78-4.097-35.685 17.928-63.334 37.958-78.028 57.684-14.693 19.726-17.489 28.687-17.489 28.687Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.99 902.284c-28.97-26.221-77.84-62.514-100.69-72.916-22.85-10.403-31.5 6.204-18.63 46.129a117.191 117.191 0 0 0 13.82 29.178l105.5-2.391ZM1153.32 802.6a224.297 224.297 0 0 0 93.9-24.395c18.78-9.675 36.83-22.401 46.52-38.402 25.84-42.579-32.16-37.357-69.48-20.925-29.15 12.8-56.12 25.52-56.12 25.52s32.34-71.245 0-49.249c-32.33 21.997-53.34 30.863-68.82 50.63-15.48 19.767-27.09 62.17 14.74 59.051 15.31-1.111 28.58-1.805 39.26-2.23Z",
    fill: "#283B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.84 363.392c-2.29-7.681-13.37-8.274-16.46-.883-7.15 17.106-17.15 47.719-18.11 86.909-1.51 61.639 9.54 74.372 17.72 85.508 8.19 11.137 13.87 15.031 17.59 14.546 3.71-.485 6.79-2.426 16.51-16.742 9.73-14.316 27.05-44.465 5.9-97.568-12.15-30.465-18.51-56.14-23.15-71.77Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.38 733.052s-24.49-46.318-18.69-102.155c5.8-55.838 30.83-85.252 30.83-85.252s27.44 30.883 33.01 75.456c5.58 44.573-7.24 106.824-12.86 118.405-5.62 11.581-17.14 19.396-24.71 6.454l-7.58-12.908Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.97 904.391c-.62-5.465-.82-10.97-.59-16.465 1.56-37.095 8.89-106.279 20.89-114.161 11.99-7.883 6.66-22.044 26.38 4.797 19.73 26.84 33.18 58.438 34.36 93.781.33 9.479.63 20.75.52 32.338l-81.56-.29Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.344 834.285.316 68.685 39.211-.161 126.53-118.446v-17.894l-166.057 67.816Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m808.978 834.714-44.775 69.817 57.077-2.237 114.916-120.736v-17.894l-127.218 71.05Z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.54 766.131s11.9 134.898 9.87 137.162c-2.04 2.264-57.839 1.132-57.839 1.132H915.93l56.531-162.258 18.75-27.683 29.209 41.185-2.88 10.462Z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.06 783.109s71.23 117.9 69.19 120.151c-2.03 2.25-57.83 1.131-57.83 1.131h-53.64l56.55-162.224 18.75-27.683-33.01 68.625h-.01Z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.133 773.585s-44.088 123.175-46.122 125.439a52.633 52.633 0 0 0-4.083 5.389h-73.381l115.508-153.694 11.514-16.25-.525 28.707-2.911 10.409Z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.09 808.004s52.07 92.38 72.89 96.389h64.72s-55.79-54.571-68.81-83.541c-13.01-28.97-74.68-71.973-74.68-71.973h-33.53l39.41 59.125Z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.8 819.416s69.08 80.967 89.9 84.976h99.94s-59.69-53.331-82.73-83.541c-19.89-26.099-111.37-71.973-111.37-71.973l-26.49-3.698 30.75 74.236Z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.373 734.588 764.956 859.225l-52.308 45.314h51.54s106.022-72.236 132.237-98.511c26.214-26.275 60.081-75.604 60.081-75.604l-41.211-15.772-14.922 19.936Z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.97 756.699s41.1 60.338 54 86.175c12.9 25.837 29.21 61.51 29.21 61.51l-76.8-1.131-6.41-146.554Z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.344 764.92s59.522-42.774 91.915-55.972c32.392-13.198 82.382-18.635 102.236-15.914 19.854 2.722 42.808 14.148 42.808 14.148l-50.697 27.286s-6.805-4.305-43.017-4.716c-36.212-.411-107.484 47.584-107.484 47.584l-35.445 20.67-.316-33.086Z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.664 797.999s59.206-44.385 91.625-57.583c32.42-13.198 82.382-18.635 102.237-15.913 19.854 2.722 42.808 14.148 42.808 14.148l-50.697 27.299s-6.805-4.305-43.017-4.716c-36.212-.411-107.485 47.585-107.485 47.585l-35.471 20.642v-31.462Z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.092 515.799s21 13.312 37.431 27.763c16.432 14.452 59.806 63.902 68.477 74.17 8.671 10.267 61.133 78.333 61.133 78.333s-1.348-.519 14.148.235c15.495.755 60.237 3.571 28.296-7.842-10.288-3.671-23.284-27.764-47.935-50.966-24.651-23.203-56.592-57.428-75.321-73.435-18.73-16.008-49.296-34.609-53.898-36.516-4.601-1.906-34.191-17.065-32.331-11.742Z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.883 543.645s77.396 87.084 89.301 100.861c11.904 13.778 46.742 49.801 55.837 56.774 9.095 6.973 42.283-4.965 42.283-4.965s-46.487-50.724-67.688-72.761c-21.202-22.037-89.948-77.154-119.733-79.909Z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.987 504.393s21 13.312 37.432 27.764c16.432 14.451 59.799 63.895 68.476 74.162 8.678 10.268 61.167 78.353 61.167 78.353s5.935 10.645 21.458 11.406c15.522.762 20.541 4.945 18.257-4.183-2.283-9.129-20.541-42.593-45.192-65.795-24.652-23.203-56.593-57.435-75.322-73.435-18.729-16.001-49.302-34.609-53.897-36.509-4.595-1.9-34.205-17.092-32.379-11.763Z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.767 661.847s2.742-74.163 19.632-106.494c16.891-32.332 24.161-42.943 35.611-52.085 11.45-9.142 17.77-25.487 17.77-25.487s-5.02 23.203-8.21 27.387c-3.2 4.184-21.46 35.37-21.91 54.766-.46 19.396-5.94 69.602-4.11 76.069 1.82 6.468 3.19 23.958 3.19 30.041 0 6.084-2.28 27.009-5.48 29.644-3.19 2.634-28.927 2.021-28.927 2.021s-9.095-13.508-7.566-35.862Z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.67 648.542s28.3-57.434 37.44-74.169c9.13-16.735 29.22-44.466 42.44-57.812 13.23-13.346 29.64-27.002 29.64-27.002s-25.06 47.921-28.74 58.963c-3.68 11.042-15.07 46.022-21.46 61.982-6.39 15.96-21.91 52.489-34.23 61.618-12.33 9.129-36.52 23.58-36.52 23.58s-4.09-22.819 11.43-47.16Z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.227 700.267s33.013-28.525 91.293-25.527c58.28 2.998 126.73 43.556 145.95 56.552 19.21 12.996 31.83 22.516 46.25 33.524a2164.46 2164.46 0 0 1 25.22 19.538s-5.39 9.007-47.45-15.011c-42.06-24.017-72.67-31.098-99.71-39.075-27.03-7.977-56.45-12.976-56.45-12.976l-87.1-5.504-18.003-11.521Z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.36 708.272s43.84-17.517 91.29 3.503 115.92 63.552 157.96 76.063c42.04 12.511 131.54 55.043 131.54 55.043s-33.01-7.506-50.45-10.005c-17.43-2.5-92.49-25.022-92.49-25.022l-77.48-18.514-94.7-30.526-55.45-24.018-10.22-26.524Z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.25 723.824s90.69 19.538 145.95 64.05c55.26 44.513 105.71 98.585 105.71 98.585l28.83 25.022s-40.84-15.017-69.07-30.028c-28.23-15.01-97.64-45.037-97.64-45.037s-54.92-46.541-65.13-53.042c-10.21-6.501-33.63-17.018-33.63-17.018l-15.02-42.532Z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.664 824.88s30.863-7.802 81.331-43.279c50.468-35.478 124.53-97.238 175.166-90.016 50.636 7.223 35.64 11.791 35.64 11.791s-139.022 84.793-164.286 94.65c-25.264 9.856-87.031 30.795-87.031 30.795s-36.481 12.801-40.82 13.111V824.88Z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.422 698.266s-8.873-2.775-32.897 25.75c-24.025 28.525-66.065 85.562-92.495 131.61-26.43 46.049-31.233 52.55-31.233 52.55h27.622s52.328-58.081 83.824-94.111c31.496-36.031 51.317-64.556 55.521-81.069 4.204-16.512 14.181-38.846-10.342-34.73Z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.77 902.968s-29.966-80.603-29.966-100.619c0-20.016-3.005-68.557 0-87.583 3.005-19.026 6.01-24.523 17.416-20.521 11.41 4.002 18.02 29.562 18.02 29.562s25.83 66.024 26.42 96.045c.6 30.021 4.72 83.103 4.72 83.103l-36.61.013Z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.36 440.054c-12.18-9.189-52.46-49.296-105.66-44.923-53.21 4.372-78.93 10.348-78.93 10.348l-27.96 9.789s-20.53 17.86-29.91 22.334c-9.38 4.473-40.96 19.74-40.96 19.74s-2.29-8.038 17.73-20.212 36.27-20.339 53.04-28.579c16.76-8.239 45.13-13.939 71.12-16.843 25.98-2.903 72.38-14.383 127.07 25.433 4.85 3.539 9.4 6.825 13.66 9.857l.8 13.056Z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.68 404.035s-6.96 9.601-9.78 18.541c-2.83 8.94-4 17.456-12.7 26.376-8.71 8.92-20.69 15.623-20.69 15.623s9.17-25.203 15.09-36.953c5.92-11.75 19.69-23.378 28.08-23.587Z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.19 414.02s-5.18 9.432-7.17 18.304c-1.98 8.873-2.69 17.335-9.25 26.053-6.56 8.718-15.65 15.165-15.65 15.165s10.22-24.759 14.55-36.38c4.32-11.622 11.05-23.109 17.52-23.142Z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.82 499.062s-5.18 9.433-7.17 18.305c-1.99 8.873-2.69 17.335-9.25 26.053-6.55 8.718-15.65 15.165-15.65 15.165s10.23-24.759 14.55-36.38c4.33-11.622 11.04-23.109 17.52-23.143Z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.94 401.145s-5.18 9.432-7.17 18.298c-1.98 8.866-2.69 17.334-9.25 26.059-6.56 8.725-15.65 15.159-15.65 15.159s10.22-24.753 14.55-36.381c4.32-11.628 11.05-23.102 17.52-23.135Z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.15 397.555s-5.93 11.284-8.19 21.895c-2.26 10.611-3.06 20.758-10.56 31.18-7.49 10.422-17.98 18.103-17.98 18.103s11.69-29.644 16.63-43.495c4.94-13.852 12.64-27.67 20.1-27.683Z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.48 471.926s-5.93 11.285-8.18 21.902c-2.26 10.618-3.07 20.757-10.57 31.18-7.5 10.422-17.97 18.123-17.97 18.123s11.68-29.644 16.62-43.495c4.94-13.852 12.64-27.697 20.1-27.71Z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.85 476.098s-7.25 10.49-10.78 20.75c-3.54 10.261-5.55 20.212-14.25 29.678-8.7 9.465-20.04 15.798-20.04 15.798s15.18-27.993 21.76-41.177c6.58-13.185 15.9-25.932 23.31-25.049Z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.29 487.114s-7.24 10.489-10.78 20.75c-3.54 10.261-5.55 20.212-14.25 29.677-8.69 9.466-20.03 15.799-20.03 15.799s15.18-27.993 21.76-41.178c6.58-13.184 15.9-25.931 23.3-25.048Z",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.23 393.931s-8.49 9.513-13.24 19.268c-4.76 9.756-8.01 19.39-17.8 27.69-9.8 8.3-21.83 13.205-21.83 13.205s18.51-25.904 26.66-38.173c8.16-12.268 18.97-23.782 26.21-21.99Z",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.96 457.199s-3.37 12.282-3.37 23.136c0 10.853 1.42 20.932-3.69 32.708-5.12 11.777-13.72 21.512-13.72 21.512s5.12-31.429 7-46.042c1.88-14.612 6.49-29.717 13.78-31.314Z",
    fill: "url(#R)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.37 392.252s-2.7-2.574-20.67-11.851c-17.96-9.277-37.54-21.471-37.54-21.471s8.02 11.022 13.12 14.754c5.1 3.732 31.52 16.169 31.52 16.169l13.57 2.399Z",
    fill: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.46 477.783s-2.69-2.574-20.66-11.844-37.54-21.478-37.54-21.478 8.02 11.029 13.12 14.761c5.1 3.732 31.52 16.169 31.52 16.169l13.56 2.392Z",
    fill: "url(#T)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.04 478.401s-3.07-2.143-22.18-8.671c-19.1-6.528-40.3-15.691-40.3-15.691s9.56 9.722 15.15 12.659c5.6 2.938 33.56 11.312 33.56 11.312l13.77.391Z",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.5 397.658a90.274 90.274 0 0 0-28.34-23.244c-17.93-9.277-29.86-10.105-29.86-10.105s8.01 11.028 13.11 14.761c5.1 3.732 31.52 16.169 31.52 16.169l13.57 2.419Z",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.4 402.42a90.082 90.082 0 0 0-32.06-17.746c-19.31-5.888-31.19-4.521-31.19-4.521s9.87 9.399 15.56 12.127c5.69 2.729 33.92 10.193 33.92 10.193l13.77-.053Z",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.68 390.198s-12.6-11.453-22.1-17.301c-9.5-5.848-18.97-14.512-25.91-16.957a109.567 109.567 0 0 1-14.33-6.522s10.78 7.532 13.63 11.13c2.85 3.597 2.49 2.809 7.75 11.278 5.26 8.468 15.17 12.645 15.17 12.645s14.37 5.68 25.79 5.727Z",
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.77 447.261s-15.79-6.346-26.74-8.536c-10.94-2.189-22.83-7.006-30.19-6.878-5.26-.004-10.51-.382-15.71-1.132 0 0 12.73 3.315 16.65 5.693 3.92 2.378 3.32 1.765 11.2 7.875 7.87 6.111 18.62 6.583 18.62 6.583s15.39.323 26.17-3.605Z",
    fill: "url(#Y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.38 461.081s-15.79-6.347-26.74-8.536c-10.95-2.19-22.83-7.007-30.19-6.879a110.06 110.06 0 0 1-15.71-1.139s12.73 3.315 16.65 5.7c3.92 2.385 3.32 1.765 11.2 7.876 7.87 6.11 18.62 6.582 18.62 6.582s15.45.296 26.17-3.604Z",
    fill: "url(#Z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.72 466.448s-15.79-6.353-26.73-8.536c-10.94-2.183-22.84-7.014-30.21-6.886-5.25-.003-10.5-.381-15.69-1.131 0 0 12.72 3.314 16.64 5.699 3.93 2.385 3.32 1.759 11.19 7.876 7.88 6.117 18.63 6.582 18.63 6.582s15.46.317 26.17-3.604Z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.1 410.336s-23.74.896-33.88 6.306c-10.15 5.41-27.92 16.29-27.92 16.29s7.89 1.745 18.06-1.657c10.17-3.402 24.98-11.541 30.11-13.69 5.13-2.149 13.63-7.249 13.63-7.249Z",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.52 389.479s-15.59 1.024-26.76-10.78c-11.16-11.803-12.59-21.188-17.09-27.494-4.5-6.306-2.65-7.593.89-5.679 3.53 1.913 7.9.673 13.31 13.898 5.42 13.225 21.09 25.231 21.09 25.231l8.56 4.824Z",
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.35 491.37s-12.49 9.385-28.3 5.632c-15.8-3.752-22.13-10.833-29.35-13.642-7.22-2.81-6.38-4.905-2.37-5.235 4.01-.33 6.98-3.766 18.75 4.332 11.78 8.098 31.46 9.573 31.46 9.573l9.81-.66Z",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.67 482.444s-12.48 9.391-28.3 5.639c-15.81-3.753-22.13-10.834-29.34-13.65-7.22-2.816-6.39-4.904-2.38-5.235 4.01-.33 6.98-3.766 18.76 4.339 11.77 8.105 31.45 9.567 31.45 9.567l9.81-.66Z",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.83 389.91s-3.37-9.87-14.23-18.029c-10.86-8.158-32.23-28.666-32.23-28.666a26.831 26.831 0 0 0 8.18 18.466c8.45 8.146 18.33 18.568 18.33 18.568l19.95 9.661Z",
    fill: "url(#af)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.36 430.32s-18.58-21.276-26.8-44.513c-8.22-23.236-6.49-33.928-7.66-40.719-1.17-6.791 8.55 6.259 10.36 17.166 1.82 10.908 9.18 24.833 14.2 35.323 5.02 10.49 9.9 32.743 9.9 32.743Z",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.27 418.197s-12.85-16.304-17.65-24.442c-4.81-8.139-.46-13.805-9.17-24.766-8.71-10.962-16.51-20.751-14.7-23.163 1.8-2.411 19.45 13.077 22.18 20.69 2.72 7.613 10.13 22.132 11.91 28.155 1.77 6.023 7.43 23.526 7.43 23.526Z",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.39 295.098s-5.05 19.214-.07 32.042c4.98 12.827 27.49 29.111 48.65 39.123 21.17 10.011 24.66 16.169 24.66 16.169l-7.18-27.474-47.03-60.177-12.98-4.453-6.05 4.77Z",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.15 480.673s-29.39-92.178-41.56-113.44c-12.17-21.263-27.53-46.366-36.82-56.471-17.2-18.716-28.93-18.265-29.68-26.464-.76-8.199 2.48-20.663-13.58-25.999-16.05-5.335-14.6 5.235-24.43 9.54-9.82 4.305-6.65 6.111-6.65 6.111s12.29-.62 13.67.761c1.39 1.381 7.04 5.39 5.78 10.78-1.27 5.389-1.94 14.532-1.94 14.532s3.64-12.424 7.76-6.003c4.11 6.42 7.17 1.347 7.17 1.347s-1.69 14.512 2.54 22.179c4.23 7.667 22.91 27.104 31.71 35.357s15.22 6.663 21.75 22.906c6.52 16.243 19.7 119.295 19.7 119.295s30.79 1.671 44.58-14.431Z",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.36 448.584s-3.57-.856-12.8 0-60.93 12.497-69.6 19.376c-8.68 6.879-24.18 5.875-38.94 8.448-14.77 2.574-28.93 14.007-28.93 14.007s-19.2 9.472-29.1 12.006c-9.91 2.533-17.26 8.475-32.38 17.166l-15.13 8.691s4.09-8.503 16.95-18.595c12.85-10.092 29.28-7.956 35.45-11.365 6.17-3.409 22.15-10.955 26.27-16.607 4.13-5.653 25.02-11.218 31.78-13.057 6.77-1.839 22.91-3.079 31.22-9.432 8.3-6.353 67.37-16.978 67.37-16.978l17.84-2.189v8.529Z",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.53 112.289c-16.38-5.497-40.14-14.99-76.55-9.775-36.42 5.214-72.23 24.846-72.23 24.846l-.15-1.933s37.55-22.105 67.37-25.231c29.82-3.126 52.14-1.294 63.33 1.947 4.78 1.388 10.63 2.695 17.4 5.262l.83 4.884Z",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.59 33.46c-23.88 1.348-64.57 6.421-64.57 6.421l-30.32 6.199s55.32-5.936 67.46-7.054c6.39-.586 16.28-1.846 27.35-2.082l.08-3.483Z",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.85 124.25c-12.98 2.654-42.96 8.381-59.29 19.275-19.29 12.868-26.88 19.962-26.88 19.962s24.93-17.22 37.26-22.623c12.33-5.403 32.46-9.378 49.14-13.474l-.23-3.14Z",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.58 322.869c-10.44-4.043-21.3-8.833-31.75-16.843-10.45-8.011-31.7-28.006-31.7-28.006s20.21 23.465 36.59 34.359c16.38 10.894 29.39 14.337 35.1 18.696 2.48 1.9 6.58 4.716 10.71 7.323v-4.716c-7.25-4.703-14.66-9.149-18.95-10.813Z",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.76 98.656s-9.74-6.144-16.84-12.187c-7.1-6.043-24.93-9.325-24.93-9.325s7.57 5.047 11.21 8.947c3.63 3.901 15.84 8.759 19.53 10.106 3.7 1.348 11.03 2.46 11.03 2.46Z",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.55 101.289s-9.74-6.144-16.84-12.187c-7.1-6.044-24.93-9.325-24.93-9.325s7.57 5.046 11.21 8.947c3.63 3.901 15.83 8.759 19.53 10.106 3.7 1.347 11.03 2.459 11.03 2.459Z",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.24 102.648s-8.31 14.438-16.17 24.746c-7.87 10.308-13.78 37.883-13.78 37.883s6.74-11.177 11.74-16.324c5.01-5.147 12.13-23.654 14.06-29.253 1.92-5.598 4.15-17.052 4.15-17.052Z",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 106.145s-6.18 11.81-12.04 20.211c-5.86 8.401-10.26 30.991-10.26 30.991s5.04-9.142 8.76-13.353c3.72-4.211 9-19.343 10.45-23.917 1.45-4.575 3.09-13.932 3.09-13.932Z",
    fill: "url(#as)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.69 104.544a176.29 176.29 0 0 1-16.84-12.18c-7.11-6.064-24.93-9.325-24.93-9.325s7.57 5.04 11.21 8.94c3.63 3.901 15.83 8.792 19.53 10.106 3.7 1.314 11.03 2.459 11.03 2.459Z",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.96 108.741a170.82 170.82 0 0 1-16.58-9.25c-6.99-4.609-24.68-6.839-24.68-6.839s7.46 3.814 11.01 6.812 15.64 6.602 19.28 7.552c3.63.95 10.97 1.725 10.97 1.725Z",
    fill: "url(#au)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.24 113.053s-8.09-2.89-13.94-5.808c-5.86-2.917-20.89-4.042-20.89-4.042s6.28 2.385 9.25 4.298c2.97 1.914 13.18 4.043 16.26 4.642 3.08.6 9.32.91 9.32.91Z",
    fill: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.52 109.468s-7.02 11.331-7.86 15.151c-.84 3.82.67 14.573-4.14 21.647-4.81 7.074-15.04 12.47-15.04 12.47s8-8.421 8.96-13.272c.97-4.851.21-12.268 3.23-17.82 3.01-5.551 9.92-18.87 14.85-18.176Z",
    fill: "url(#aw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.37 112.582s-8.44 10.948-10.03 20.852c-1.59 9.903-9.68 20.002-13.28 21.525-3.6 1.522-9.67 2.25-9.67 2.25s6.34-1.435 9.7-9.23c3.36-7.795 2.76-14.209 6.25-18.952 3.49-4.743 11.9-14.687 17.03-16.445Z",
    fill: "url(#ax)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.47 118.477s-6.29 16.89-10.51 24.59c-4.23 7.701-13.25 13.299-15.82 14.896-2.58 1.597-.59-.795 3.43-7.121 4.01-6.326 5.33-14.269 8.61-18.318 3.29-4.049 6.64-4.178 8.28-6.886 1.65-2.708 6.01-7.161 6.01-7.161Z",
    fill: "url(#ay)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.99 116.326s-10.6-4.898-17.45-7.182c-6.84-2.284-16.79-3.065-18.86-3.726-2.08-.66 3.21 5.276 11.11 6.104 5 .569 9.91 1.757 14.62 3.537l10.58 1.267Z",
    fill: "url(#az)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.54 101.375s-1.49.344-1.2 9.035c.29 8.691-1.57 23.674-5.84 30.869-4.27 7.196-11.08 18.379-12.05 20.677-.98 2.297-1.98-17.854 1.3-24.618 3.29-6.764 7.82-11.271 9.44-16.014 1.61-4.743 4.03-20.535 8.35-19.949Z",
    fill: "url(#aA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.44 105.891s-1.65-8.698-6.91-14.903-16.29-16.169-24.02-19.8l-7.74-3.645s5.8 10.065 12.47 15.886c6.68 5.821 13.59 12.356 17.78 14.89 4.18 2.532 8.42 7.572 8.42 7.572Z",
    fill: "url(#aB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.77 109.117s-3.37.6-5.68 8.287c-2.32 7.687-4.25 14.653-12.27 19.72-8.02 5.066-22.23 11.251-25.29 15.495-3.06 4.244-1.85-.411 1.18-4.716 3.03-4.305 13.36-11.77 17.47-14.31 4.1-2.54 10.41-14.316 14.18-18.46 3.78-4.143 10.41-6.016 10.41-6.016Z",
    fill: "url(#aC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.05 102.271a116.265 116.265 0 0 0-5.82 17.14c-1.95 8.307-9.13 16.546-13.8 20.764-4.66 4.217-14.14 17.186-14.91 18.52-.76 1.334 6.43-22.428 9.75-27.521 3.32-5.094 14.37-16.574 16.22-19.996 1.85-3.423 6.41-10.948 8.56-8.907Z",
    fill: "url(#aD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.75 101.457a34.955 34.955 0 0 0-3.11 6.023c-1.75 4.136-5.55 19.645-7.83 24.368-2.28 4.723-9.43 16.957-14.31 21.094-4.89 4.136-6.94 7.087-6.94 7.087s8.34-13.474 9.58-21.511c1.25-8.038 5.39-20.171 8.05-24.389 2.65-4.217 10.75-14.977 14.56-12.672Z",
    fill: "url(#aE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.64 99.698a128.86 128.86 0 0 0-11.54-11.614c-5.68-4.844-15.8-12.76-24.62-16.46-8.83-3.698-9.93-5.948-9.93-5.948s6.97 7.128 11.38 11.864c4.4 4.736 14.14 12.329 18.4 13.562 4.25 1.233 14.1 8.212 14.1 8.212l2.21.384Z",
    fill: "url(#aF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.06 101.567a42.785 42.785 0 0 0-10.78-15.057c-7.45-6.488-21.38-14.593-28.75-20.212l-7.38-5.646s17.15 19.707 21.25 23.041c4.09 3.335 12.76 7.25 15.67 9.5 2.92 2.25 9.99 8.374 9.99 8.374Z",
    fill: "url(#aG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.24 124.082s-7.92 6.913-11.87 11.07c-3.95 4.156-4.15 5.975-11.54 8.084a77.808 77.808 0 0 1-14.74 2.574s7.99-3.409 13.67-8.435c5.68-5.026 20.74-15.55 24.48-13.293Z",
    fill: "url(#aH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.32 129.586s-5.43 12.437-4.94 18.864c.5 6.427 3.94 15.94-1.2 20.339-5.13 4.4-16.16 14.586-16.16 14.586s4.04-10.415 8.95-16.539c4.91-6.124 2.22-9.082 1.83-14.539-.39-5.457 3.88-22.664 11.52-22.711Z",
    fill: "url(#aI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.73 149.387s-2.15 14.215-.88 20.649c1.27 6.434.22 16.358-2.12 19.41-2.35 3.052-8.76 14.148-8.76 14.148s-1.54.141-.4-4.332c1.15-4.474 4.86-11.581 3.05-17.086-1.82-5.504-4.17-16.843-1.54-21.457 2.63-4.615 13.6-15.934 13.6-15.934l-2.95 4.602Z",
    fill: "url(#aJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.57 150.476s2.85 21.141 2.47 26.847c-.39 5.707-7.61 17.295-7.61 17.295s-14.83 14.673-15.1 16.229c-.28 1.557-1.19-4.042 1.78-8.239 2.97-4.197 11.68-13.953 11.58-17.436-.1-3.483-1.04-13.663.27-18.365 1.32-4.703 3.9-17.382 6.61-16.331Z",
    fill: "url(#aK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.72 159.242s4.04 18.864-.06 24.045c-4.1 5.181-24.7 25.635-24.7 25.635s7.32-9.627 8.22-13.42c.9-3.793 8.34-20.212 11.11-23.284 2.77-3.072 5.43-12.976 5.43-12.976Z",
    fill: "url(#aL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.99 161.457s-13.6 19.807-19.53 23.533c-5.93 3.726-15.92 6.602-20.79 8.145-4.88 1.543-4.91 1.348 1.09-4.716 6.01-6.063 10-9.432 16-13.259 6.01-3.826 23.23-13.703 23.23-13.703Z",
    fill: "url(#aM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.71 159.241s-18.52-.499-26.99 4.446c-8.48 4.945-14.73 10.551-19.41 11.851-4.68 1.3-8.83 7.107-3.67 5.666 5.15-1.442 22.23-6.495 26.58-9.735 4.35-3.241 23.49-12.228 23.49-12.228Z",
    fill: "url(#aN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.33 115.671c-11.86-1.664-32.44-1.044-37.24-2.87-4.81-1.826-7.18-1.583-7.18-1.583s33.55 9.694 40.26 11.453c6.71 1.758 16.03-5.329 4.16-7Z",
    fill: "url(#aO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.98 128.345s-12.85-7.97-24.55-9.715c-11.7-1.745-23.24.674-28.3.869-5.05.195-14.18-2.405-14.18-2.405s19.89 5.74 41.5 7.411c21.6 1.67 25.53 3.84 25.53 3.84Z",
    fill: "url(#aP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.68 132.79a64.99 64.99 0 0 0-27.53-6.818c-15.92-.357-28.7 2.5-33.8 3.113-5.1.613-6.74.613-6.74.613s13.72 3.24 23.73 2.87c10.01-.371 27.47-.721 27.47-.721l16.87.943Z",
    fill: "url(#aQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.92 140.863s-14.45-3.449-28.21-3.766c-13.77-.317-33.25 1.92-33.25 1.92s22.71 5.686 31.07 4.642c8.36-1.044 30.39-2.796 30.39-2.796Z",
    fill: "url(#aR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.57 150.477s-17-2.977-34.73-.774c-17.74 2.203-25.71 6.238-25.71 6.238s16.52-.108 23.1-.498c6.58-.391 37.34-4.966 37.34-4.966Z",
    fill: "url(#aS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.79 284.257s-7.6-10.523-12.71-15.333c-5.12-4.811-19.79-16.729-19.79-16.729s4.21 16.055 8.68 20.468c4.46 4.413 23.82 11.594 23.82 11.594Z",
    fill: "url(#aT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.46 289.344c.31-5.951.15-11.917-.5-17.84-1.09-8.496-5.85-22.536-8.72-25.891-2.87-3.355-2.85.114-2.18 4.123.66 4.009 1.94 12.942 4.46 20.703 2.53 7.762 6.94 18.905 6.94 18.905Z",
    fill: "url(#aU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.94 308.84s-6.12-2.6-9.87 2.567c-3.75 5.168-12.66 8.705-16.62 8.92-3.96.216-10.11-2.459-10.11-2.459s12.22-3.773 14.77-6.117c2.55-2.345 17.63-7.384 21.83-2.911Z",
    fill: "url(#aV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.84 301.269s-8.42-.283-11.57 1.065c-3.15 1.347-8.09 1.953-12.98 2.553-4.9.6-11.05-.337-13.94-2.338-2.9-2.001-7.81-6.218-7.81-6.218s9.95 3.611 15.71 2.93c5.76-.68 9.16-5.234 18.47-2.903 9.31 2.331 12.12 4.911 12.12 4.911Z",
    fill: "url(#aW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.95 290.749s-3.13-2.492-9.43-.492c-6.3 2.001-13.02 4.353-20.6 2.372-7.57-1.981-16.73-11.453-16.73-11.453s15.86 3.544 22.1 4.177c6.23.633 21.37.357 24.66 5.396Z",
    fill: "url(#aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.23 319.788s-9.43-2.621-16.11 1.482c-6.69 4.103-8.26 10.2-14.07 10.995-5.81.795-11.68 1.415-11.68 1.415s8.18-5.053 9.38-8.327c1.21-3.275 8.32-10.78 14.15-11.858 5.83-1.078 16.58 4.029 18.33 6.293Z",
    fill: "url(#aY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.94 308.841s-4.71-9.971-5.15-15.058c-.44-5.087 1.93-13.474 3.7-18.763a39.333 39.333 0 0 0 1.95-9.958c0 .001 2.28 19.868 2.2 23.938-.08 4.069-2.54 21.558-2.54 21.558l-.16-1.717Z",
    fill: "url(#aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.09 297.602a27.666 27.666 0 0 1-2.69-17.847c1.26-6.794 2.05-13.67 2.35-20.575a35.72 35.72 0 0 1 4.98 16.553 53.225 53.225 0 0 1-2.11 16.358l-2.53 5.511Z",
    fill: "url(#ba)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.23 318.111s-4.4-.91-6.18-8.651c-1.77-7.741-3.09-14.101-1.85-20.245 1.24-6.144 2.02-15.442 2.02-15.442s4.96 14.506 4.79 21c-.16 6.495-1.01 16.843-.43 18.19.57 1.348 1.65 5.148 1.65 5.148Z",
    fill: "url(#bb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.45 327.791s-6.06-3.868-8.84-10.652c-2.77-6.784-7.89-19.032-7.97-24.456-.14-4.156-.53-8.3-1.17-12.41 0 0 8.76 14.189 11.59 18.48 2.84 4.292 5.09 11.817 5.17 15.806.08 3.988 1.22 13.232 1.22 13.232Z",
    fill: "url(#bc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.19 62.408c-7.42-4.11-14.5-8.132-20.76-10.416-8.57-3.126-43.07-13.178-52.54-17.698-9.48-4.52-19.95-8.94-29.84-11.453-9.88-2.513-16.35-1.435-16.35-1.435s22.58 9.924 29.17 10.543c6.59.62 19.77 5.531 19.77 5.531s24.2 9.035 31.92 11.023c5.36 1.347 24.82 10.981 38.61 19.072l.02-5.167Z",
    fill: "#202A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.648 822.204s18.918-39.035 41.865-58.364c22.947-19.329 35.033-30.189 53.945-45.887 18.911-15.697 22.946-24.556 37.054-33.416 14.107-8.859 21.336-11.271 31.402-24.152 10.065-12.882 16.405-24.557 25.311-31.8l8.907-7.249s-13.69 14.896-16.506 20.131c-2.816 5.234-11.272 25.358-16.102 30.593-4.831 5.235-42.673 40.254-55.555 53.944-12.881 13.69-28.181 27.778-42.673 41.461-14.491 13.683-36.225 42.673-39.85 49.518l-3.106 5.221h-24.692Z",
    fill: "url(#bd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.841 523.75s8.806 18.029 4.346 29.765c-4.46 11.736-7.903 32.594-6.32 47.261 1.584 14.667-5.928 40.753-14.821 53.001-8.893 12.248-34.582 33.201-43.671 45.456-9.088 12.255-25.298 33.591-37.546 40.706-12.248 7.114-41.898 51.377-41.898 51.377l-20.212 30.991-34.992-.088s30.768-52.509 71.05-81.418c40.281-28.909 52.65-57.266 82.968-77.525 30.317-20.258 27.177-41.494 27.42-56.511.242-15.017-4.891-20.211 3.409-37.97s10.267-13.259 12.248-23.688c1.981-10.429-1.981-21.357-1.981-21.357Z",
    fill: "url(#be)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.692 724.555a131.117 131.117 0 0 0 25.689-28.458c11.857-17.786 36.381-35.174 36.381-35.174s29.643-10.672 47.422-20.151c17.78-9.479 28.061-11.069 28.061-11.069s-6.165-1.186-17.901 0-25.177 12.645-36.246 14.619c-11.069 1.974-28.808 3.659-46.554 19.868-17.745 16.21-35.707 35.707-44.061 46.049-8.354 10.341-13.723 18.662-29.529 30.128-15.805 11.467-33.908 39.857-33.908 39.857l-30.741 41.232h28.713s22.907-41.569 33.565-53.823c10.658-12.255 39.109-43.078 39.109-43.078Z",
    fill: "url(#bf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.508 820.869s42.188-61.874 64.515-73.718c22.327-11.844 78.905-21.37 96.887-24.254 17.981-2.883 35.087-6.858 47.834-6.858h40.14s-30.378 4.662-34.158 9.344c-3.779 4.683-61.86 14.782-61.86 14.782s-52.874 17.981-62.535 24.995c-9.661 7.013-33.342 25.001-37.728 36.845a146.371 146.371 0 0 1-8.334 18.864h-44.761Z",
    fill: "url(#bg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.946 731.468s26.315-25.001 41.224-28.511c14.909-3.51 56.141-25.15 67.547-28.579 11.406-3.429 31.826-2.56 44.202-1.685 12.376.876 58.432 10.968 62.818 10.968 4.385 0-61.403-3.072-72.809 0-11.406 3.073-45.617 12.72-58.775 21.054-13.158 8.334-41.218 24.119-41.218 24.119L585.175 760l-50.036 62.292h-27.178s28.451-46.177 41.164-60.21c12.713-14.034 33.821-30.614 33.821-30.614Z",
    fill: "url(#bh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.462 729.244s57.037-21.707 70.194-27.09c13.158-5.383 17.645-8.974 28.714-10.47 11.069-1.495 30.209-2.095 37.385-2.095 7.175 0 38.287 4.19 50.845 2.991 12.558-1.199 11.069-2.991 11.069-2.991s-15.853 2.991-25.426 0c-9.574-2.991-30.593-8.947-66.415-8.576-35.821.37-57.751 4.823-74.21 11.109-16.459 6.286-29.838 10.961-41.514 20.515-11.675 9.553-30.627 16.169-37.297 23.64a46.24 46.24 0 0 1-14.619 10.82s35.646-12.167 41.231-13.474c5.585-1.307 20.043-4.379 20.043-4.379Z",
    fill: "url(#bi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.102 529.09s40.167 25.372 49.444 58.229c9.278 32.857 6.798 46.19 6.798 46.19s-24.692-14.148-34.36-28.97C7.114 589.718-5.101 529.09-5.101 529.09Z",
    fill: "url(#bj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.095 628.572 42.855 50.801l-1.792-65.735h-5.727l13.34 643.453 4.42.053Z",
    fill: "url(#bk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.204 117.392s-.674 27.083-37.816 48.952-50.4 16.641-60.405 18.864c-10.005 2.223-23.66 4.79-24.793 9.216-1.131 4.426-1.4-9.836-1.4-9.836s6.467 6.326 18.115-6.064c11.649-12.389 31.955-39.493 51.122-49.376 19.167-9.884 46.493-18.419 55.177-11.756Z",
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.296 627.527s-9.823 45.988-37.728 66.2a217.382 217.382 0 0 1-23.17 14.875l.755-36.892c10.631-14.182 60.143-44.183 60.143-44.183Z",
    fill: "url(#bm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.514 37.354S69.81 7.53 78.004-18.389l-39.407-.162c-6.164 12-11.513 24.732-12.665 31.705C23.634 27 33.1 61.877 37.992 60.146c4.89-1.732 15.522-22.792 15.522-22.792Z",
    fill: "url(#bn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.071 66.473s-15.226 52.549-32.843 78.925c-8.759 13.097-14.822 22.004-17.281 23.89l.047-4.52c1.698-8.038 4.265-24.604 1.725-38.968-2.54-14.364-7.856-49.046-.809-55.245 7.047-6.198 49.296-14.606 49.296-14.606s2.54 1.826-.135 10.524Z",
    fill: "url(#bo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.878-15.555c-9.607 6.583-20.454 16.6-31.665 31.833C59.83 38.511 43.148 72.075 42.528 74.96c-.479 2.378-10.315 9.088 3.018 2.944 7.801-3.59 21.559-.276 41.966-9.877 20.406-9.6 36.953-27.73 46.924-49.35a150.781 150.781 0 0 0 10.483-33.53l-37.041-.7Z",
    fill: "url(#bp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.529 630.713s14.754 25.305 17.84 55.609c3.085 30.304-9.628 72.397-13.717 75.227-4.09 2.829-9.776-6.4-13.05-22.428-3.274-16.028-10.301-55.521-4.204-78.825 6.097-23.304 7.41-35.882 7.41-35.882l5.72 6.299Z",
    fill: "url(#bq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.295 627.53s16.109 9.903 26.329 26.591c10.22 16.688 43.118 31.375 66.267 32.231 11.487.431 19.571-.108 24.799-.755a3.892 3.892 0 0 0 3.282-2.612 3.9 3.9 0 0 0-.984-4.078c-9.385-8.974-29.112-27.157-43.933-36.158-22.267-13.528-45.025-15.408-54.309-14.956-9.283.451-17.078-.802-19.921-5.39-2.844-4.588-1.53 5.127-1.53 5.127Z",
    fill: "url(#br)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.836 622.382s1.274 1.199-4.15 6.138c-5.423 4.938-11.716 12.605-38.556 13.939-7.546.37-13.65.862-19.12 1.037l-1.213-34.016c9.055 3.827 19.167 8.651 32.803 12.996 27.286 8.685 30.317-4.204 30.317-4.204s.034 2.399-.08 4.11Z",
    fill: "url(#bs)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.988 348.22a19.97 19.97 0 0 1 22.703 8.005 19.97 19.97 0 0 1 3.087 7.968 56.84 56.84 0 0 1-1.718 24.463c-6.616 22.583-38.26 66.954-48.198 79.296-4.042 5.033-7.135 8.941-9.358 11.811a2.471 2.471 0 0 1-4.433-1.57v-.148c.741-18.763 3.41-65.91 11.85-83.777 10.646-22.536 13.192-41.204 24.753-45.59.451-.169.883-.317 1.314-.458Z",
    fill: "url(#bt)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.942 485.522c2.971.545 2.655-.539 1.031-3.046-8.024-12.342-28.1-44.916-33.214-53.331-6.683-11.002-13.063-19.854-21.43-26.598v53.675c6.581 5.005 12.914 9.593 18.19 13.602 10.031 7.66 27.548 14.249 35.423 15.698Z",
    fill: "url(#bu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.409 490.871c2.802-1.111 1.947-1.859-.795-3.112-11.885-5.43-41.77-21.027-54.45-27.232v34.488c6.064.498 11.77.903 16.776 1.347 12.665 1.159 31.03-2.54 38.469-5.491Z",
    fill: "url(#bv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 587.145c.633 2.911 1.522 2.21 3.247-.235 8.475-12.046 31.274-42.835 37.19-50.724 7.74-10.308 12.975-17.962 16.074-28.162 3.099-10.2 7.276-28.572 4.345-40.173-2.93-11.602-23.91-5.06-36.01 13.346-12.1 18.406-18.547 48.575-23.782 67.681-3.308 12.1-2.749 30.553-1.064 38.267Z",
    fill: "url(#bw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.054 91.587s-.714-47.833-12.585-73.435c-11.87-25.6-29.293-36.326-53.224-45.36-23.93-9.035-25.217-4.717-32.62-13.522-7.405-8.806-2.103 10.173 3.61 26.275 5.713 16.101 19.397 44.68 32.588 54.308C-5.986 49.48 30.9 81.697 36.43 87.168c3.921 3.833 6.623 4.42 6.623 4.42Z",
    fill: "url(#bx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.256 188.629s-.708-47.834-12.585-73.435C20.764 95.96 7.573 82.896-7.977 74.879l.674 72.047c16.27 13.407 38.705 33.106 42.923 37.277 3.94 3.84 6.636 4.426 6.636 4.426Z",
    fill: "url(#by)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.868 640.82s-40.18-25.399-49.451-58.256c-9.27-32.857-6.797-46.169-6.797-46.169s24.698 14.148 34.359 28.969c9.661 14.822 21.889 75.456 21.889 75.456Z",
    fill: "url(#bz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.656 541.312 6.36 358.922h5.498l-7.438-358.868-4.42-.054Z",
    fill: "url(#bA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.453 542.357s9.816-45.988 37.728-66.2c27.912-20.211 41.413-22.63 41.413-22.63s-4.655 27.757-15.273 41.939c-10.617 14.182-63.868 46.891-63.868 46.891Z",
    fill: "url(#bB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.21 539.151s-14.748-25.312-17.84-55.616c-3.092-30.303 9.628-72.397 13.717-75.2 4.089-2.802 9.776 6.4 13.043 22.435 3.268 16.034 10.308 55.514 4.211 78.825-6.097 23.31-7.411 35.882-7.411 35.882l-5.72-6.326Z",
    fill: "url(#bC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.451 542.357s-16.108-9.904-26.335-26.592c-10.227-16.687-43.084-31.368-66.267-32.23-11.487-.425-19.571.108-24.799.754a3.903 3.903 0 0 0-3.378 4.797 3.906 3.906 0 0 0 1.087 1.894c9.385 8.98 29.111 27.157 43.926 36.165 22.273 13.521 45.031 15.401 54.315 14.949 9.284-.451 17.079.809 19.915 5.39 2.837 4.581 1.536-5.127 1.536-5.127Z",
    fill: "url(#bD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.919 547.506s-1.273-1.199 4.157-6.137c5.43-4.939 11.709-12.599 38.556-13.933 26.848-1.334 35.525-4.096 61.881 10.692s35.62 22.441 29.691 22.367c-5.929-.074-24.294 7.566-44.728 6.892-18.864-.633-32.042-11.264-59.287-19.948-27.245-8.685-30.317 4.21-30.317 4.21s-.074-2.452.047-4.143Z",
    fill: "url(#bE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.756 821.665a19.968 19.968 0 0 1-16.569-2.053 19.969 19.969 0 0 1-9.228-13.914 56.884 56.884 0 0 1 1.718-24.469c6.623-22.583 38.261-66.954 48.205-79.297a906.594 906.594 0 0 0 9.358-11.81 2.473 2.473 0 0 1 4.426 1.577v.141c-.741 18.763-3.409 65.917-11.851 83.783-10.644 22.53-13.184 41.198-24.752 45.591a26.35 26.35 0 0 1-1.307.451Z",
    fill: "url(#bF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.792 684.365c-2.964-.546-2.654.539-1.024 3.045 8.018 12.342 28.101 44.916 33.208 53.338 6.683 11.002 11.837 18.702 20.211 25.446 8.375 6.744 23.978 17.618 35.977 19.423 11.999 1.806 13.946-19.787 1.347-37.863-12.598-18.075-38.402-35.565-54.274-47.678-10.052-7.667-27.562-14.263-35.445-15.711Z",
    fill: "url(#bG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.332 679.012c-2.796 1.112-1.941 1.86.795 3.113 13.474 6.171 48.204 23.027 57.104 27.42 11.641 5.747 20.211 9.52 30.923 10.78 10.712 1.259 29.832 2.176 40.935-2.648 11.103-4.824.977-24.072-19.538-32.662-20.514-8.59-51.768-9.695-71.784-11.507-12.632-1.139-30.998 2.56-38.435 5.504Z",
    fill: "url(#bH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.022 582.739c-.634-2.91-1.53-2.203-3.248.236-8.482 12.033-31.247 42.842-37.196 50.724-7.734 10.315-12.969 17.962-16.068 28.162-3.099 10.2-7.283 28.579-4.352 40.173 2.931 11.595 23.917 5.06 36.01-13.346 12.093-18.406 18.548-48.575 23.782-67.681 3.315-12.094 2.749-30.554 1.072-38.268Z",
    fill: "url(#bI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.492 472.184s47.436 12.234 73.435 33.133c25.999 20.899 34.447 36.138 31.058 47.995-3.388 11.858-15.246 23.715-42.356 10.167-27.11-13.549-37.836-38.968-46.304-53.082-8.469-14.115-15.833-38.213-15.833-38.213Z",
    fill: "url(#bJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.889 476.771s-14.149 6.138-41.569-5.807-60.547-33.747-60.547-58.364c0-24.618 19.781-18.972 29.065-18.568 9.283.404 43.185 11.305 55.291 27.851 12.107 16.547 21.364 36.361 21.364 42.377 0 6.016-3.604 12.511-3.604 12.511Z",
    fill: "url(#bK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.492 475.835s22.725-3.786 44.809-13.879c22.084-10.092 56.168-25.244 53.641-42.289-2.526-17.045-24.611-30.923-44.802-20.211s-29.03 19.537-37.236 32.816c-8.206 13.279-16.412 43.563-16.412 43.563Z",
    fill: "url(#bL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.941 471.186s-28.761-37.317-31.092-62.19c-2.331-24.874-.377-54.275 24.099-58.304 17.705-2.917 30.587 6.993 32.965 30.203 2.439 23.769.458 49.087-7.317 68.523-7.774 19.437-13.137 25.844-13.137 25.844l-5.518-4.076Z",
    fill: "url(#bM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.393 542.169s1.26 14.667 20.117 10.901 36.044-11.319 51.128-20.117c15.085-8.799 31.853-35.202 31.853-35.202s15.927-25.567 2.931-25.567c-12.996 0-18.022 2.937-30.593 2.694-12.572-.242-41.488 7.748-53.224 20.744-11.736 12.996-25.143 24.759-22.212 46.547Z",
    fill: "url(#bN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.233 472.184s7.323 2.796 12.747 20.413c5.423 17.618 18.46 55.177 18.008 68.389-.451 13.212-1.812 34.252-17.638 37.182-15.825 2.931-33.47-.977-37.99-20.548-4.521-19.571 3.617-53.816 8.596-68.005 4.979-14.188 8.139-34.737 16.277-37.431Z",
    fill: "url(#bO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.148 561.125s47.437 12.235 73.435 33.127c25.999 20.891 34.448 36.144 31.059 48.002-3.389 11.857-15.246 23.715-42.35 10.166-27.104-13.548-37.836-38.968-46.305-53.082-8.468-14.114-15.839-38.213-15.839-38.213Z",
    fill: "url(#bP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.513 565.716s-14.148 6.131-41.575-5.814c-27.426-11.945-60.54-33.74-60.54-58.357 0-24.618 19.781-18.972 29.065-18.568 9.283.405 43.185 11.298 55.291 27.852 12.107 16.553 21.391 36.347 21.391 42.41 0 6.063-3.632 12.477-3.632 12.477Z",
    fill: "url(#bQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.148 564.779s22.718-3.786 44.809-13.885c22.091-10.099 56.168-25.244 53.641-42.282-2.526-17.039-24.61-30.924-44.808-20.212s-29.031 19.538-37.23 32.817c-8.199 13.279-16.412 43.562-16.412 43.562Z",
    fill: "url(#bR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.573 560.131s-28.768-37.317-31.099-62.19c-2.331-24.874-.377-54.281 24.099-58.304 17.712-2.917 30.587 6.994 32.972 30.203 2.432 23.762.458 49.087-7.317 68.524-7.775 19.436-13.144 25.843-13.144 25.843l-5.511-4.076Z",
    fill: "url(#bS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.018 631.111s1.26 14.666 20.117 10.894c18.857-3.773 36.044-11.312 51.128-20.111 15.085-8.799 31.853-35.208 31.853-35.208s15.92-25.561 2.931-25.561-18.022 2.937-30.593 2.695c-12.572-.243-41.488 7.754-53.224 20.744-11.736 12.989-25.143 24.752-22.212 46.547Z",
    fill: "url(#bT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.858 561.125s7.317 2.796 12.747 20.414c5.43 17.617 18.46 55.177 18.008 68.388-.451 13.212-1.812 34.245-17.638 37.183-15.825 2.937-33.47-.977-37.99-20.549-4.521-19.571 3.617-53.823 8.589-68.045 4.972-14.222 8.146-34.703 16.284-37.391Z",
    fill: "url(#bU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.671 289.463s-15.859-15.395-12.564-40.673c3.294-25.278 12.214-48.938 14.235-53.062 2.021-4.123 7.532-5.281 10.18 2.102 2.648 7.384 8.907 33.013 2.479 58.957-6.427 25.945-9.715 29.139-10.388 32.918-.674 3.78 6.292 232.216 6.737 268.341.444 36.125-.863 85.292-.863 85.292l-6.063-.364s4.17-61.739 1.846-125.573c-2.324-63.835-5.599-227.938-5.599-227.938Z",
    fill: "url(#bV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.138 253.298s-2.021-22.274-.169-34.272c1.348-8.92 4.177-2.857 15.765 10.159 11.588 13.016 35.424 49.276 39.177 59.422 9.957 26.949 6.427 48.636 6.427 48.636s-31.341-8.644-43.246-30.991c-11.904-22.348-14.72-31.544-17.954-52.954Z",
    fill: "url(#bW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.464 313.941c5.12-14.343 11.305-30.62 18.507-40.84 7.202-10.221 40.645-36.172 43.003-35.033 2.358 1.138-7.014 18.56-9.567 26.396-2.553 7.835-6.171 27.622-13.414 38.482-7.242 10.861-26.847 25.682-35.41 29.832-8.563 4.151-20.212 19.538-15.549 12.377 4.662-7.162 12.43-31.214 12.43-31.214Z",
    fill: "url(#bX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.321 436.012s1.658 12.625 6.434 13.912c4.777 1.287 15.085-8.758 20.515-18.406 5.43-9.647 20.838-52.017 23.29-61.193 2.452-9.176 7.034-29.644 1.826-30.196-5.208-.553-35.282 18.864-43.69 43.313-8.408 24.449-11.508 29.852-8.375 52.57Z",
    fill: "url(#bY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.969 335.043s29.886 19.787 39.924 31.382c10.038 11.594 26.026 39.533 25.925 64.171-.101 24.638-17.625 4.925-28.195-3.705-10.571-8.631-31.975-50.63-34.771-61.039-2.796-10.409-2.883-30.809-2.883-30.809Z",
    fill: "#244045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.571 546.271s-7.653-13.703 8.759-33.43c16.411-19.726 56.524-47.16 79.249-51.586 22.724-4.426-16.27 44.526-26.12 55.474-9.85 10.947-52.867 44.013-61.888 29.542Z",
    fill: "url(#bZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.975 460.131s38.018 25.844 47.08 45.523c9.061 19.679-2.372 21.707-13.124 18.339-10.753-3.369-38.854-23.742-44.829-35.99-5.976-12.248-14.485-33.356-6.697-34.474 7.788-1.119 17.57 6.602 17.57 6.602Z",
    fill: "#23363E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.48 620.688s-13.475 26.086 17.887 26.531c31.361.445 63.41-42.626 70.43-53.224 7.02-10.597 11.588-19.827 9.432-22.583-2.156-2.755-19.214-13.177-40.564-2.452-21.351 10.726-37.917 22.718-46.689 34.521-8.772 11.804-10.496 17.207-10.496 17.207Z",
    fill: "url(#ca)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.92 668.396s23.789 28.525 52.193 37.56c28.403 9.034 38.038.835 24.368-12.437-13.67-13.272-28.97-25.177-28.97-25.177s19.019.418 1.684-15.273c-17.334-15.691-46.58-37.405-60.257-43.63-13.676-6.225-18.864 3.712-11.143 27.623 7.721 23.91 22.125 31.334 22.125 31.334ZM759.276 593.427a134.353 134.353 0 0 0 56.208-14.586c11.237-5.794 22.037-13.407 27.838-22.961 15.455-25.486-19.255-22.36-41.582-12.524-17.436 7.68-33.578 15.266-33.578 15.266s19.342-42.626 0-29.468c-19.342 13.158-31.921 18.467-41.184 30.317-9.264 11.851-16.217 37.203 8.819 35.337 9.156-.715 17.092-1.146 23.479-1.381Z",
    fill: "#283B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.117 330.606c-1.347-4.601-8.004-4.951-9.856-.532a145.814 145.814 0 0 0-10.834 52.011c-.903 36.886 5.707 44.506 10.611 51.169 4.905 6.663 8.287 8.994 10.517 8.704 2.23-.29 4.042-1.455 9.883-10.018 5.841-8.563 16.17-26.625 3.531-58.384-7.27-18.238-11.07-33.599-13.852-42.95Z",
    fill: "url(#cb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.472 551.804s-14.66-27.717-11.191-61.126c3.47-33.41 18.426-51.014 18.426-51.014s16.419 18.48 19.754 45.173c3.335 26.692-4.339 63.922-7.701 70.854-3.362 6.933-10.254 11.608-14.822 3.861l-4.466-7.748Z",
    fill: "url(#cc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.522 693.146c-8.037-9.31-18.965-26.47-18.028-48.669.936-22.199 5.315-63.599 12.504-68.315 7.189-4.716 3.988-13.184 15.799 2.877 11.81 16.062 19.847 34.966 20.561 56.114.715 21.148 1.348 57.266-10.927 61.887-12.275 4.622-19.909-3.894-19.909-3.894Z",
    fill: "url(#cd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.273 452.248s-15.859-15.394-12.565-40.672c3.295-25.278 12.235-48.946 14.256-53.069 2.021-4.123 7.532-5.275 10.18 2.102 2.648 7.377 8.906 33.012 2.472 58.957-6.434 25.945-9.708 29.138-10.382 32.918-.673 3.779 6.293 232.223 6.738 268.341.444 36.118-.863 85.299-.863 85.299l-6.063-.371s4.17-61.739 1.839-125.573c-2.331-63.835-5.612-227.932-5.612-227.932Z",
    fill: "url(#ce)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.708 416.074s-2.021-22.273-.168-34.272c1.347-8.913 4.177-2.85 15.765 10.167 11.588 13.016 35.424 49.275 39.176 59.421 9.958 26.929 6.421 48.622 6.421 48.622s-31.341-8.643-43.246-30.991c-11.905-22.347-14.694-31.536-17.948-52.947Z",
    fill: "url(#cf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.026 476.719c5.12-14.344 11.305-30.621 18.507-40.841 7.202-10.22 40.645-36.172 43.003-35.033 2.358 1.138-7.013 18.554-9.566 26.396-2.554 7.842-6.172 27.622-13.414 38.483-7.243 10.86-26.848 25.682-35.411 29.825-8.562 4.143-20.211 19.538-15.549 12.383 4.662-7.155 12.43-31.213 12.43-31.213Z",
    fill: "url(#cg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.886 598.782s1.657 12.632 6.434 13.919c4.776 1.287 15.078-8.758 20.514-18.406 5.437-9.647 20.838-52.024 23.291-61.2 2.452-9.176 7.033-29.644 1.819-30.189-5.215-.546-35.276 18.864-43.691 43.313-8.414 24.449-11.5 29.859-8.367 52.563Z",
    fill: "url(#ch)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.531 497.816s29.886 19.787 39.925 31.389c10.038 11.601 26.025 39.533 25.924 64.164-.101 24.632-17.624 4.932-28.195-3.698-10.57-8.631-31.974-50.63-34.77-61.046-2.796-10.415-2.884-30.809-2.884-30.809Z",
    fill: "#244045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.142 709.055s-7.654-13.71 8.758-33.436c16.412-19.727 56.525-47.161 79.249-51.587 22.725-4.426-16.277 44.526-26.127 55.481-9.849 10.954-52.859 44.013-61.88 29.542Z",
    fill: "url(#ci)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.546 622.912s38.017 25.844 47.079 45.523c9.061 19.68-2.372 21.707-13.124 18.339-10.753-3.369-38.853-23.742-44.829-35.99-5.976-12.248-14.485-33.356-6.697-34.474 7.788-1.118 17.571 6.602 17.571 6.602Z",
    fill: "#23363E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.042 783.468s-13.474 26.093 17.887 26.531c31.362.438 63.41-42.619 70.43-53.19 7.021-10.571 11.582-19.821 9.432-22.576-2.149-2.756-19.214-13.178-40.564-2.452-21.35 10.725-37.917 22.71-46.688 34.514-8.772 11.803-10.497 17.173-10.497 17.173Z",
    fill: "url(#cj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.484 831.173s23.789 28.525 52.193 37.566c28.404 9.041 38.038.836 24.362-12.437-13.677-13.272-28.97-25.176-28.97-25.176s19.019.417 1.684-15.274c-17.334-15.69-46.574-37.411-60.25-43.636-13.677-6.225-18.864 3.719-11.15 27.622 7.714 23.904 22.131 31.335 22.131 31.335ZM626.839 756.201a134.123 134.123 0 0 0 56.194-14.6c11.238-5.787 22.037-13.406 27.831-22.96 15.496-25.48-19.248-22.354-41.575-12.524-17.435 7.68-33.578 15.273-33.578 15.273s19.343-42.633 0-29.468c-19.342 13.164-31.914 18.466-41.177 30.317-9.264 11.851-16.203 37.155 8.832 35.309a688.874 688.874 0 0 1 23.473-1.347Z",
    fill: "#283B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.687 493.384c-1.347-4.595-8.003-4.952-9.856-.525a145.75 145.75 0 0 0-10.833 52.004c-.903 36.886 5.706 44.505 10.604 51.168 4.898 6.664 8.293 8.995 10.523 8.705 2.23-.29 4.043-1.449 9.884-10.018 5.841-8.57 16.169-26.619 3.53-58.384-7.269-18.231-11.076-33.626-13.852-42.95Z",
    fill: "url(#ck)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.035 714.585s-14.653-27.717-11.183-61.133c3.469-33.416 18.453-51.034 18.453-51.034s16.418 18.48 19.753 45.139c3.335 26.659-4.339 63.929-7.7 70.855-3.362 6.925-10.254 11.608-14.822 3.86l-4.501-7.687Z",
    fill: "url(#cl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.085 855.932c-8.037-9.311-18.965-26.471-18.029-48.67.937-22.199 5.316-63.598 12.505-68.314 7.188-4.716 3.988-13.192 15.791 2.87 11.804 16.061 19.848 34.965 20.569 56.113.721 21.148 1.347 57.266-10.928 61.888s-19.908-3.887-19.908-3.887Z",
    fill: "url(#cm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.41 212.876s-26.51-25.722-21-67.971c5.5-42.248 20.45-81.782 23.81-88.674 3.37-6.892 12.6-8.82 17.02 3.51 4.42 12.329 14.88 55.184 4.14 98.531-10.75 43.347-16.23 48.689-17.35 55.009-1.12 6.319 10.52 388.06 11.3 448.438.78 60.379-1.44 142.538-1.44 142.538l-10.11-.606s6.97-103.18 3.09-209.856c-3.89-106.676-9.46-380.919-9.46-380.919Z",
    fill: "url(#cn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.57 152.429s-3.37-37.216-.28-57.266c2.29-14.902 6.98-4.77 26.34 16.978 19.35 21.747 59.2 82.348 65.47 99.306 16.64 45.004 10.74 81.277 10.74 81.277s-52.38-14.445-72.27-51.836c-19.88-37.391-24.6-52.678-30-88.459Z",
    fill: "url(#co)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.11 253.776c8.56-23.971 18.86-51.169 30.92-68.254 12.05-17.085 67.93-60.446 71.87-58.539 3.94 1.906-11.72 30.991-15.99 44.108-4.26 13.117-10.31 46.122-22.41 64.313-12.1 18.19-44.87 42.922-59.18 49.855-14.32 6.932-33.78 32.621-25.98 20.69 7.8-11.932 20.77-52.173 20.77-52.173Z",
    fill: "url(#cp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.23 457.766s2.79 21.1 10.78 23.256c8 2.156 25.21-14.619 34.29-30.762 9.08-16.142 34.82-86.909 38.91-102.27 4.09-15.36 11.77-49.585 3.05-50.461-8.71-.876-58.96 31.496-73.01 72.391-14.06 40.894-19.28 49.922-14.02 87.846Z",
    fill: "url(#cq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.25 289.039s49.95 33.066 66.7 52.449c16.75 19.383 43.49 66.064 43.32 107.235-.18 41.171-29.45 8.24-47.11-6.185-17.66-14.424-53.44-84.612-58.11-102.014-4.68-17.402-4.8-51.485-4.8-51.485Z",
    fill: "#244045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.19 642.045s-12.8-22.907 14.6-55.871c27.4-32.965 94.45-78.825 132.44-86.236 37.98-7.411-27.2 74.412-43.66 92.71-16.46 18.298-88.3 73.576-103.38 49.397Z",
    fill: "url(#cr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.38 498.088s63.53 43.192 78.66 76.076c15.14 32.884-3.96 36.273-21.92 30.648-17.97-5.626-64.93-39.675-74.91-60.143-9.99-20.467-24.22-55.743-11.2-57.616 13.01-1.873 29.37 11.035 29.37 11.035Z",
    fill: "#23363E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.35 766.402s-22.48 43.603 29.89 44.337c52.38.735 105.98-71.225 117.71-88.883 11.73-17.658 19.36-33.133 15.7-37.728-3.66-4.595-32.1-22.024-67.78-4.096-35.68 17.927-63.33 37.95-78.03 57.683-14.69 19.733-17.49 28.687-17.49 28.687Z",
    fill: "url(#cs)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.96 846.13s28.18 33.801 65.42 53.493l71.61.613c-1.51-3.591-4.52-7.687-9.09-12.127-22.85-22.178-48.38-42.073-48.38-42.073s31.78.674 2.81-25.52c-28.96-26.195-77.84-62.521-100.69-72.917-22.85-10.395-31.49 6.205-18.63 46.13 12.86 39.924 36.95 52.401 36.95 52.401ZM1339.63 720.839a224.348 224.348 0 0 0 93.91-24.395c2.62-1.348 5.21-2.754 7.78-4.218v-64.838a155.02 155.02 0 0 0-30.74 9.755c-29.14 12.801-56.11 25.521-56.11 25.521s32.34-71.246 0-49.249c-32.34 21.997-53.34 30.856-68.82 50.623-15.48 19.767-27.1 62.17 14.73 59.058 15.34-1.139 28.6-1.833 39.25-2.257Z",
    fill: "#283B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.18 281.63c-2.29-7.68-13.38-8.273-16.46-.883-7.16 17.106-17.15 47.72-18.11 86.91-1.51 61.645 9.54 74.378 17.72 85.514 8.19 11.137 13.86 15.031 17.58 14.546 3.72-.485 6.79-2.426 16.52-16.742s27.06-44.465 5.9-97.567c-12.15-30.473-18.5-56.148-23.15-71.778Z",
    fill: "url(#ct)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.73 651.289s-24.49-46.318-18.69-102.155c5.79-55.838 30.83-85.259 30.83-85.259s27.44 30.89 33.01 75.456c5.58 44.566-7.25 106.831-12.86 118.412-5.61 11.582-17.14 19.397-24.71 6.455l-7.58-12.909Z",
    fill: "url(#cu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.86 887.502c-13.43-15.563-31.66-44.236-30.13-81.338 1.54-37.101 8.88-106.278 20.89-114.161 12-7.882 6.66-22.044 26.39 4.797 19.74 26.841 33.17 58.438 34.36 93.781 1.19 35.343 2.23 95.668-18.26 103.422-20.48 7.755-33.25-6.501-33.25-6.501Z",
    fill: "url(#cv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.712 370.66s-11.365-11.029-9.007-29.145c2.358-18.116 8.758-35.074 10.213-38.031 1.456-2.958 5.39-3.78 7.297 1.509 1.906 5.289 6.38 23.661 1.778 42.249-4.601 18.587-6.966 20.885-7.411 23.58-.444 2.695 4.514 166.407 4.844 192.312.331 25.904-.613 61.126-.613 61.126l-4.332-.263s2.992-44.243 1.348-89.995-4.117-163.342-4.117-163.342Z",
    fill: "url(#cw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.46 344.743s-1.442-15.96-.122-24.563c.984-6.387 2.998-2.021 11.298 7.283 8.301 9.304 25.393 35.316 28.081 42.592 7.135 19.295 4.608 34.851 4.608 34.851s-22.468-6.198-30.991-22.232c-8.522-16.035-10.557-22.59-12.874-37.931Z",
    fill: "url(#cx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.009 388.175c3.672-10.28 8.085-21.942 13.259-29.273 5.174-7.33 29.131-25.924 30.822-25.102 1.691.822-5.026 13.299-6.858 18.918-1.833 5.619-4.42 19.78-9.607 27.575-5.188 7.795-19.242 18.413-25.386 21.377-6.144 2.964-14.485 13.993-11.137 8.873 3.349-5.12 8.907-22.368 8.907-22.368Z",
    fill: "url(#cy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.325 475.681s1.192 9.054 4.615 9.977c3.422.923 10.779-6.272 14.7-13.191 3.921-6.919 14.936-37.283 16.688-43.859 1.752-6.575 5.046-21.262 1.307-21.64-3.739-.377-25.284 13.508-31.307 31.045-6.023 17.537-8.247 21.397-6.003 37.668Z",
    fill: "url(#cz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.508 403.32s21.417 14.148 28.613 22.496c7.195 8.347 18.648 28.296 18.574 45.987-.074 17.692-12.626 3.531-20.212-2.654-7.586-6.185-22.906-36.286-24.927-43.744-2.021-7.458-2.048-22.085-2.048-22.085Z",
    fill: "#244045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.578 554.712s-5.49-9.823 6.259-23.964c11.75-14.142 40.504-33.821 56.794-36.974 16.291-3.153-11.662 31.914-18.722 39.749-7.061 7.836-37.87 31.557-44.331 21.189Z",
    fill: "url(#cA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.565 492.975s27.245 18.494 33.74 32.642c6.495 14.148-1.698 15.556-9.432 13.144-7.734-2.412-27.845-17.018-32.123-25.797-4.278-8.778-10.382-23.903-4.804-24.705 5.579-.801 12.619 4.716 12.619 4.716Z",
    fill: "#23363E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.786 608.043s-9.641 18.696 12.8 19.012c22.442.317 45.449-30.546 50.475-38.118 5.026-7.573 8.307-14.209 6.737-16.17-1.57-1.96-13.771-9.432-29.071-1.758s-27.171 16.277-33.456 24.739c-6.286 8.462-7.485 12.295-7.485 12.295Z",
    fill: "url(#cB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.386 642.229s17.052 20.447 37.405 26.949c20.353 6.501 27.265.599 17.463-8.914-9.803-9.513-20.744-18.042-20.744-18.042s13.629.297 1.206-10.948c-12.424-11.244-33.383-26.834-43.158-31.294-9.776-4.46-13.475 2.695-7.984 19.78 5.491 17.086 15.812 22.469 15.812 22.469ZM879.842 588.501a96.159 96.159 0 0 0 40.274-10.463c8.085-4.15 15.792-9.607 19.949-16.452 11.083-18.264-13.798-16.027-29.798-8.98a1201.956 1201.956 0 0 0-24.066 10.947s13.865-30.553 0-21.121c-13.865 9.433-22.906 13.232-29.515 21.714-6.609 8.482-11.622 26.659 6.319 25.325a482.85 482.85 0 0 1 16.837-.97Z",
    fill: "#283B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.331 400.149a3.782 3.782 0 0 0-3.4-2.616 3.785 3.785 0 0 0-3.66 2.238 104.347 104.347 0 0 0-7.761 37.27c-.674 26.437 4.089 31.894 7.599 36.671 3.51 4.776 5.942 6.447 7.539 6.238 1.597-.209 2.91-1.044 7.081-7.182 4.17-6.137 11.601-19.079 2.533-41.837-5.215-13.07-7.936-24.079-9.931-30.782Z",
    fill: "url(#cC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.14 558.675s-10.503-19.861-8.017-43.791c2.486-23.93 13.218-36.556 13.218-36.556s11.77 13.245 14.148 32.372c2.378 19.127-3.106 45.813-5.517 50.778-2.412 4.965-7.344 8.32-10.591 2.769l-3.241-5.572Z",
    fill: "url(#cD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.618 659.975c-5.76-6.677-13.589-18.972-12.922-34.885.667-15.914 3.813-45.577 8.967-48.959 5.154-3.382 2.857-9.432 11.319 2.061 8.462 11.494 14.222 25.063 14.741 40.214.518 15.152.95 41.036-7.836 44.358-8.785 3.321-14.269-2.789-14.269-2.789Z",
    fill: "url(#cE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.112-14.745s-2.884 51.364-6.172 67.77c-3.287 16.404-3.281 117.67-3.281 117.67l4.225 87.664s11.715 96.099 15.495 131.26c3.78 35.161 8.435 96.341 11.716 135.477 3.281 39.137 7.034 182.126 7.034 182.126l-36.098 1.873s9.823-147.2 4.224-238.61c-5.599-91.41-16.843-169.702-18.756-220.803-1.914-51.102 0-146.257 0-146.257L182.603-6.276v-8.658l8.509.189Z",
    fill: "url(#cF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.05-14.746s-25.702 28.336-29.832 97.44c-5.114 85.615 0 138.926 0 138.926l.755 107.39 1.502 34.549 4.878 90.87 1.529 122.785 1.88 124.637 33.045-2.25s2.251-73.974 0-119.409c-2.25-45.436-9.539-125.412-10.59-156.976-1.051-31.563-11.595-211.728-17.598-242.544-6.003-30.816-1.502-78.097-1.132-90.494.371-12.396 3.005-69.446 10.894-82.213a4476.577 4476.577 0 0 0 13.886-22.617l-9.217-.094Z",
    fill: "url(#cG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.4 720.022s-4.346-26.794 43.454-49.249c47.8-22.455 49.39-19.537 62.892-21.821 13.501-2.284 39.345-6.171 50.912-4.238 11.568 1.934 25.46 2.311 25.46 2.311s3.086 3.086-14.269 7.714-47.834 2.318-67.116 11.574c-19.281 9.257-45.139 25.844-45.139 25.844s-33.173 24.496-43.205 27.865c-10.032 3.369-9.021 10.901-12.989 0Z",
    fill: "url(#cH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.647 674.795s18.904-16.843 39.749-30.607c20.845-13.764 32.399-27.622 35.485-29.563 3.085-1.94 31.631-20.44 38.961-21.983 7.33-1.543-5.787-6.562-28.93 0-23.142 6.562-30.856 3.086-52.839 25.844-21.983 22.758-35.875 29.313-34.717 38.954a749.47 749.47 0 0 0 2.291 17.355Z",
    fill: "url(#cI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.273 766.212s3.47-32.789 41.656-56.315c38.186-23.527 75.605-29.698 91.033-30.082 15.428-.384 64.003 0 64.003 0s3.085 2.554-3.47 5.134c-6.555 2.58-23.142 3.369-37.802 7.593s-37.796 14.653-54.767 22.367c-16.97 7.714-46.284 25.844-59.785 33.942-13.501 8.098-37.054 23.533-37.054 23.533l-3.814-6.172Z",
    fill: "url(#cJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.476 806.325s-1.542-31.24 40.113-52.846c41.656-21.606 79.458-18.514 88.324-17.355 8.867 1.159 63.646 15.428 73.287 20.057 9.641 4.628 37.055 26.618 43.974 28.545 6.919 1.927.384 6.555-8.085 3.853-8.469-2.701-42.04-26.227-68.652-25.836-26.611.39-54.773-4.636-84.47.768-29.697 5.403-64.798 43.582-70.201 45.138-5.403 1.557-15.287 5.922-14.29-2.324Z",
    fill: "url(#cK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.078 618.872s44.35 24.025 56.7 25.319c12.349 1.293 35.1 9.007 52.071 7.464 16.971-1.543 49.37 14.66 59.402 17.746 10.031 3.086 14.963 11.568 14.963 11.568s-7.256-17.739-19.989-27.771c-12.734-10.031-28.539-19.672-54.383-26.612-25.843-6.939-38.563-7.323-59.024-7.714-20.461-.39-50.529-3.86-49.74 0Z",
    fill: "url(#cL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.634 651.653s46.285 30.856 68.659 39.749c22.374 8.893 54.025 15.442 69.042 20.421 15.017 4.978 34.359 8.724 50.913 23.458 16.553 14.735 20.056 16.271 20.056 16.271s-10.779-16.372-18.864-25.541c-8.084-9.169-44.357-46.971-64.798-53.897-20.44-6.926-57.859-14.653-72.903-15.037-15.044-.384-39.749-5.276-48.595-8.038-8.846-2.762-3.51 2.614-3.51 2.614Z",
    fill: "url(#cM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.011 686.755s14.741 17.355 29.785 23.917c15.044 6.562 25.453 9.081 42.444 15.34 16.991 6.259 68.659 20.528 99.899 40.585 31.24 20.056 42.444 19.672 47.834 28.929 5.389 9.257 19.261 25.851 19.261 25.851s-9.641-19.289-16.587-30.473c-6.946-11.183-16.587-18.864-27.386-33.941-10.8-15.078-54.47-40.113-75.638-46.285-21.168-6.171-55.501-13.117-69.77-12.342-14.27.775-19.673.384-29.704-4.245-10.032-4.628-22.927-13.891-20.138-7.336Z",
    fill: "url(#cN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.567 729.187s8.455 7.303 18.501 9.998c10.045 2.695 37.815-2.695 54.395 8.084 16.58 10.78 75.214 47.443 91.033 56.316 15.819 8.873 64.003 38.186 74.823 43.59 10.819 5.403 11.19.768 23.917 13.885l12.726 13.11s-.768-13.11-16.971-33.173c-16.203-20.064-37.411-43.583-55.157-58.614-17.746-15.03-74.439-50.111-113.784-51.283-39.345-1.172-60.587 1.543-70.982-1.927-10.396-3.469-23.762-3.847-18.501.014Z",
    fill: "url(#cO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.375 761.585s4.655 4.244 16.998 5.787c12.342 1.543 41.272 13.474 48.602 18.898 7.33 5.423 17.355 15.812 28.154 22.758 10.8 6.946 44.54 23.526 44.54 23.526s18.715 15.812 30.674 21.599c11.958 5.788 37.054 21.6 53.223 28.93 16.17 7.33 32.642 13.474 45.813 13.885 13.171.411 18.19-3.47 12.801-8.489-5.39-5.019-41.272-34.71-53.999-42.444-12.726-7.734-48.217-47.834-99.898-59.401-51.681-11.568-39.749-19.673-76.757-23.143-37.007-3.469-44.007-8.077-50.151-1.906Z",
    fill: "url(#cP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.961 838.375s20.885-33.43 44.856-44.735 49.417-21.862 91.511-21.256c42.093.607 56.848 2.082 76.022 12.895 19.174 10.813 25.069 15.044 25.069 15.044s-10.813 3.638-25.069-4.231c-14.256-7.869-35.889-13.272-54.079-6.878-18.191 6.393-53.581 22.61-73.247 26.544-19.666 3.935-38.833 16.715-58.498 22.617-19.666 5.901-26.565 0-26.565 0Z",
    fill: "url(#cQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.243 686.965s34.42 70.787 40.322 82.584c5.902 11.797 20.649 59.961 28.512 78.151 7.862 18.19 15.239 59.482 15.239 59.482s7.869 11.312 6.885-7.37c-.983-18.682-20.649-82.086-34.413-115.488-13.764-33.403-27.036-60.466-36.872-77.181-9.837-16.715-20.555-41.73-24.53-53.062-3.975-11.332-9.136 15.347-9.136 15.347l13.993 17.537Z",
    fill: "url(#cR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.47 490.043s-2.695 1.543 5.39 8.482c8.085 6.939 10.779 36.259 10.779 54.773 0 18.514-4.628 52.456 0 72.903 4.629 20.447 11.77 31.826 11.77 31.826l8.368 10.887s.673-31.529 4.163-55.83-.774-48.211-5.787-65.573c-5.012-17.362-15.428-46.668-25.069-52.072l-9.614-5.396Z",
    fill: "url(#cS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.273 328.984s72.653 3.463 89.186 11.15 41.905 11.918 43.057 17.685c1.152 5.767 4.224 17.301-2.695 19.605-6.919 2.305-17.294 1.537-29.98-4.998-12.686-6.536-45.368-24.254-65.741-24.989-20.373-.734-33.827-1.536-33.827-1.536v-16.917Z",
    fill: "url(#cT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.231 449.055s7.505 2.849 21.02-9.938 20.528-15.327 23.957-21.262a73.998 73.998 0 0 1 7.977-10.968s-9.755 6.791-12.733 6.023c-2.978-.768-13.111-2.756-19.376 3.072-6.266 5.828-21.815 25.379-20.845 33.073Z",
    fill: "url(#cU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.715 461.613s7.505 2.85 21.02-9.937c13.515-12.787 20.528-15.327 23.964-21.263a73.486 73.486 0 0 1 7.977-10.968s-9.762 6.785-12.74 6.017c-2.978-.768-13.11-2.756-19.376 3.072-6.266 5.827-21.815 25.392-20.845 33.079Z",
    fill: "url(#cV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.534 440.27s8.004.579 17.281-15.556c9.277-16.136 15.26-20.576 16.843-27.245a73.864 73.864 0 0 1 4.487-12.801s-7.411 9.304-10.47 9.432c-3.058.128-13.346 1.125-17.671 8.502-4.325 7.377-13.609 30.58-10.47 37.668Z",
    fill: "url(#cW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.046 362.867s-12.848 13.677-13.084 25.864c-.235 12.188-1.583 19.329-.195 25.062 1.388 5.734-.081-3.577 2.695-8.003 2.776-4.427 9.856-15.206 12.996-23.143 3.139-7.936 1.516-19.625-2.412-19.78Z",
    fill: "url(#cX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.285 325.091s25.528-18.864 66.462-4.103c40.935 14.761 50.428 24.381 65.587 32.452 15.158 8.072 35.147 16.486 42.868 18.238 7.721 1.752 10.503-1.395 14.728 2.985 4.224 4.379 17.516 12.45 24.563 17.011 7.047 4.561 15.785 1.239 20.697 3.779 4.911 2.54 11.224 10.308 21.047 14.148 9.822 3.841 10.873 5.201 17.516 7.324 6.643 2.122 9.473-2.924 23.506 5.558l1.038-2.082s-8.597-5.019-19.06-4.305c-10.462.714-24.988-9.809-30.317-12.248-5.329-2.439-9.553-9.533-15.145-10.968-5.592-1.435-10.355 3.092-19.383-2.783-9.028-5.874-19.1-11.352-23.863-17.085-4.763-5.733-11.359 1.112-27.413-6.919-16.055-8.031-32.446-14.95-44.465-22.664a235.896 235.896 0 0 0-31.625-16.91c-5.868-2.439-25.783-11.75-40.908-13.185-15.125-1.435-32.035 1.388-41.77 5.707-9.735 4.318-27.232 17.516-44.425 22.448-17.193 4.931-41.063 14.235-56.376 13.474-15.314-.761-70.181 21.882-103.672 40.49-33.49 18.608-37.108 19.794-37.108 19.794s-45.004 19.477-56.06 23.277c-11.055 3.8-60.344 7.849-60.344 7.849l-9.379 12.504.378 9.803s26.221-.587 40.234-4.326c14.013-3.739 35.761-11.197 59.799-24.57 24.038-13.373 45.813-22.799 65.054-33.329 19.241-10.53 74.425-45.604 92.973-47.739 18.547-2.136 22.091-1.705 34.44-4.656 12.349-2.951 40.423-11.83 49.087-16.297 8.664-4.467 21.336-12.672 21.336-12.672Z",
    fill: "#28221F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.828 417.989s22.738-24.146 54.618-33.531c31.88-9.385 148.992-55.137 186.161-51.114 37.169 4.022 36.341-4.716 65.526 6.555 29.185 11.271 23.998 22.616 57.609 25.049 33.612 2.432 56.181-3.551 74.109 1.468 17.928 5.019 26.632 13.825 26.632 13.825l-1.226 1.314s-14-13.953-31.402-14.263c-17.402-.31-29.644.155-45.813.627-16.169.471-32.608 2.694-52.206-6.508-19.598-9.203-21.478-19.201-53.385-20.3-31.907-1.098-23.014-1.94-45.644-1.569-22.63.37-57.475 13.71-80.792 28.377-23.318 14.666-102.183 36.677-118.648 52.044-16.466 15.368-34.811 46.594-34.811 46.594l-.728-48.568Z",
    fill: "url(#cY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.177 193.405c6.984 0 12.646-5.662 12.646-12.646 0-6.984-5.662-12.646-12.646-12.646-6.984 0-12.646 5.662-12.646 12.646 0 6.984 5.662 12.646 12.646 12.646ZM336.857 230.804c9.577 0 17.341-7.764 17.341-17.341 0-9.578-7.764-17.342-17.341-17.342-9.577 0-17.341 7.764-17.341 17.342 0 9.577 7.764 17.341 17.341 17.341Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.912 239.187c9.577 0 17.341-7.764 17.341-17.342 0-9.577-7.764-17.341-17.341-17.341-9.578 0-17.342 7.764-17.342 17.341 0 9.578 7.764 17.342 17.342 17.342ZM346.568 276.531c9.577 0 17.341-7.764 17.341-17.342 0-9.577-7.764-17.341-17.341-17.341-9.577 0-17.341 7.764-17.341 17.341 0 9.578 7.764 17.342 17.341 17.342ZM375.876 179.448c8.592 0 15.556-6.965 15.556-15.556s-6.964-15.556-15.556-15.556c-8.591 0-15.556 6.965-15.556 15.556s6.965 15.556 15.556 15.556ZM282.135 167.454c8.886 0 16.089-7.203 16.089-16.088 0-8.886-7.203-16.089-16.089-16.089-8.885 0-16.088 7.203-16.088 16.089 0 8.885 7.203 16.088 16.088 16.088Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.721 166.888c8.885 0 16.088-7.203 16.088-16.089 0-8.885-7.203-16.088-16.088-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.886 7.203 16.089 16.088 16.089ZM347.648 94.402c6.192 0 11.211-5.02 11.211-11.21 0-6.192-5.019-11.211-11.211-11.211-6.191 0-11.21 5.019-11.21 11.21 0 6.192 5.019 11.21 11.21 11.21Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.679 100.488c6.192 0 11.211-5.02 11.211-11.211 0-6.191-5.019-11.21-11.211-11.21-6.191 0-11.21 5.019-11.21 11.21 0 6.192 5.019 11.211 11.21 11.211Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.179 111.839c6.192 0 11.211-5.019 11.211-11.21 0-6.192-5.019-11.211-11.211-11.211-6.191 0-11.21 5.02-11.21 11.211 0 6.191 5.019 11.21 11.21 11.21Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.562 40.54a67.778 67.778 0 0 0 18.319 15.784c11.291 6.502 31.152 15.442 51.202 20.454 20.05 5.013 25.116 19.06 25.116 19.06l4.635 6.299s-3.954-12.127-9.277-16.681c-5.322-4.555-16.499-10.45-24.119-12.882-7.619-2.432-22.825-4.756-31.166-9.755-8.34-5-30.721-22.28-30.721-22.28h-3.989Z",
    fill: "url(#cZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.195 77.64s5.808-9.345 12.195-10.84c6.386-1.496 12.126-1.24 18.601-.054 6.474 1.185-3.847.242-8.287 3.415a39.853 39.853 0 0 1-14.929 6.064c-3.868.58-7.58 1.415-7.58 1.415Z",
    fill: "url(#da)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.367 81.293s5.808-9.345 12.194-10.84c6.387-1.496 12.127-1.24 18.602-.061 6.474 1.179-3.847.25-8.287 3.416a39.698 39.698 0 0 1-14.93 6.063c-3.867.586-7.579 1.422-7.579 1.422Z",
    fill: "url(#db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.18 83.713s7.411-8.152 13.939-8.482c6.528-.33 12.127.957 18.305 3.28 6.178 2.325-3.827-.45-8.759 1.874a39.693 39.693 0 0 1-15.771 3.274c-3.915-.108-7.714.054-7.714.054Z",
    fill: "url(#dc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.875 90.814s7.411-8.151 13.932-8.482c6.522-.33 12.127.957 18.312 3.281 6.185 2.325-3.827-.451-8.758 1.88a39.807 39.807 0 0 1-15.779 3.281c-3.907-.114-7.707.04-7.707.04Z",
    fill: "url(#dd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.227 79.46s-4.433 11.71-1.603 18.306c2.829 6.595 6.791 11.379 12.039 16.169 5.248 4.79-2.284-3.503-2.385-9.607a43.867 43.867 0 0 0-4.379-17.268c-1.994-3.793-3.672-7.6-3.672-7.6Z",
    fill: "url(#de)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.626 72.48s-4.433 11.716-1.604 18.312c2.83 6.596 6.791 11.379 12.033 16.169 5.241 4.79-2.284-3.503-2.378-9.614a43.834 43.834 0 0 0-4.38-17.26c-1.98-3.793-3.671-7.606-3.671-7.606Z",
    fill: "url(#df)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.548 67.55s-4.434 11.717-1.604 18.312c2.83 6.596 6.791 11.38 12.033 16.17 5.241 4.79-2.284-3.504-2.379-9.614a43.78 43.78 0 0 0-4.379-17.261 135.052 135.052 0 0 1-3.671-7.606Z",
    fill: "url(#dg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.629 68.34s-7.93-5.512-16.567-3.787a54.85 54.85 0 0 0-15.273 5.632s8.758 3.416 14.33 2.15l17.51-3.996Z",
    fill: "url(#dh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.56 64.794s-7.93-5.517-16.567-3.786a54.934 54.934 0 0 0-15.266 5.619s8.798 3.409 14.336 2.15l17.497-3.983Z",
    fill: "url(#di)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.315 219.647s-2.917 18.534 3.746 28.734c6.663 10.2 9.581 16.843 13.953 20.825 4.372 3.981-2.082-2.911-2.291-8.119-.209-5.207-.417-18.116-2.29-26.45s-9.789-17.072-13.118-14.99Z",
    fill: "url(#dj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.125 278.449s4.487-15.846 12.72-20.603c8.233-4.756 16.223-6.737 25.601-7.666 9.378-.93-5.208 1.926-10.106 8.306-4.898 6.381-13.178 12.404-18.284 14.822-5.107 2.419-9.931 5.141-9.931 5.141Z",
    fill: "url(#dk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.422 274.995s4.487-15.846 12.713-20.602c8.226-4.757 16.23-6.737 25.601-7.66 9.371-.923-5.208 1.92-10.106 8.3-4.898 6.38-13.178 12.41-18.284 14.821-5.107 2.412-9.924 5.141-9.924 5.141Z",
    fill: "url(#dl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.953 264.214s4.487-15.846 12.72-20.603c8.233-4.756 16.223-6.737 25.601-7.66s-5.208 1.92-10.106 8.301c-4.898 6.38-13.178 12.409-18.291 14.821-5.114 2.412-9.924 5.141-9.924 5.141Z",
    fill: "url(#dm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.805 341.49s14.188-18.244 29.145-25.149c14.956-6.906 93.646-3.551 148.601-28.458 54.955-24.907 72.546-45.368 100.384-51.748 27.838-6.38 81.593 5.504 102.357 16.277 20.764 10.773 62.494 29.118 115.286 33.059 52.793 3.941 63.411 4.204 63.411 4.204s-38.342-7.411-56.249-7.781c-17.907-.371-90.756-19.976-106.346-30.385-15.59-10.409-23.526-18.696-49.774-22.064-26.248-3.369-42.666-11.453-79.653-5.39-36.987 6.064-67.965 33.686-92.104 43.394-24.139 9.708-43.893 15.253-77.929 18.042-34.036 2.789-71.575 6.151-84.82 14.822-13.246 8.671-10.174 11.911-10.174 11.911l-2.135 29.266Z",
    fill: "url(#dn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6 194.149s-11.695 4.554-19.322 6.818c-7.626 2.263-17.516 6.279-27.305 5.639-9.79-.64-34.36-11.332-43.354-14.115-9.19-2.836-19.605-6.919-37.405-1.084-12.591 4.129-34.076 4.931-41.096 2.742-7.021-2.19-.566-5.202-.566-5.202s20.279 3.969 30.445 1.092 32.399-9.574 57.859 2.452c25.459 12.026 33.16 14.323 44.081 11.251 11.224-3.146 36.663-9.593 36.663-9.593Z",
    fill: "url(#do)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.349 189.43s16.445-6.737 23.176-17.597c6.73-10.861 14.087-23.991 17.718-27.623 3.632-3.631-6.501.755-9.277 3.692-2.775 2.938-15.165 9.19-19.888 15.698-4.722 6.508-16.856 28.309-11.729 25.83Z",
    fill: "url(#dp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.24 193.32s16.445-6.738 23.175-17.605c6.731-10.867 14.088-23.991 17.719-27.622 3.631-3.631-6.501.755-9.277 3.692-2.776 2.937-15.165 9.223-19.888 15.704-4.723 6.481-16.856 28.31-11.729 25.831Z",
    fill: "url(#dq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 188.493s13.273-5.578 18.959-13.918c5.686-8.341 11.925-18.433 14.923-21.27 2.998-2.836-5.195.762-7.492 3.052-2.297 2.291-12.336 7.411-16.291 12.39-3.954 4.979-14.255 21.768-10.099 19.746Z",
    fill: "url(#dr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.536 189.91s13.919-3.712 20.683-11.19c6.764-7.479 14.336-16.634 17.692-19.033 3.355-2.398-5.249.04-7.836 2.021-2.587 1.981-13.225 5.626-17.826 10.045-4.602 4.42-17.099 19.592-12.713 18.157Z",
    fill: "url(#ds)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.187 193.716s15.132-3.954 22.354-12.43c7.222-8.475 15.28-18.864 18.898-21.559 3.618-2.695-5.74-.074-8.529 2.122-2.79 2.197-14.33 6.185-19.255 11.177-4.925 4.993-18.238 22.24-13.468 20.69Z",
    fill: "url(#dt)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.57 201.476s15.132-3.962 22.347-12.431c7.216-8.468 15.28-18.864 18.864-21.558 3.585-2.695-5.74-.081-8.522 2.115s-14.337 6.185-19.262 11.177c-4.924 4.992-18.19 22.246-13.427 20.697Z",
    fill: "url(#du)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.938 203.74s15.131-3.955 22.36-12.43c7.229-8.476 15.28-18.864 18.864-21.559 3.584-2.695-5.74-.074-8.522 2.122-2.783 2.196-14.33 6.185-19.262 11.177-4.931 4.992-18.156 22.239-13.44 20.69Z",
    fill: "url(#dv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.11 226.661s-4.642 16.243 3.274 26.443c7.917 10.2 11.454 16.506 13.535 20.212 2.082 3.705 0-3.989 0-11.689 0-7.701-1.873-18.117-4.999-22.907-3.126-4.79-11.332-14.107-11.81-12.059Z",
    fill: "url(#dw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.045 366.382s-4.635 16.243 3.274 26.45c7.91 10.206 11.453 16.499 13.535 20.211 2.082 3.712 0-3.981 0-11.689 0-7.707-1.873-18.116-4.992-22.906-3.119-4.79-11.366-14.108-11.817-12.066Z",
    fill: "url(#dx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.296 375.059s16.243 4.642 26.45-3.268a148.23 148.23 0 0 1 20.211-13.542c3.719-2.081-3.981 0-11.689 0-7.707 0-18.116 1.88-22.906 4.999-4.79 3.12-14.108 11.339-12.066 11.811Z",
    fill: "url(#dy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.51 365.518s-4.642 16.244 3.267 26.45c7.91 10.207 11.453 16.5 13.542 20.212 2.088 3.712 0-3.982 0-11.689s-1.88-18.116-4.999-22.906c-3.119-4.79-11.339-14.108-11.81-12.067Z",
    fill: "url(#dz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.858 367.516s-4.85 13.049 3.423 21.249c8.273 8.199 11.979 13.252 14.148 16.243 2.169 2.991 0-3.2 0-9.392 0-6.191-1.961-14.552-5.228-18.399-3.268-3.847-11.844-11.339-12.343-9.701Z",
    fill: "url(#dA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.015 374.89s-4.851 13.05 3.422 21.249c8.273 8.199 11.972 13.252 14.148 16.244 2.176 2.991 0-3.201 0-9.385 0-6.185-1.96-14.552-5.221-18.399-3.261-3.847-11.858-11.346-12.349-9.709Z",
    fill: "url(#dB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.054 236.666s1.725 14.438 9.762 21.061a137.597 137.597 0 0 1 14.546 13.615c2.418 2.601-1.152-3.281-3.369-9.627-2.216-6.346-6.454-14.512-9.843-17.752-3.389-3.241-11.379-9.089-11.096-7.297Z",
    fill: "url(#dC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.297 241.698s1.724 14.438 9.755 21.06a138.682 138.682 0 0 1 14.552 13.616c2.412 2.601-1.158-3.281-3.368-9.627-2.21-6.347-6.448-14.512-9.843-17.759-3.396-3.248-11.386-9.082-11.096-7.29Z",
    fill: "url(#dD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.848 238.263s10.914 9.58 21.336 9.109c6.642-.344 13.3-.209 19.922.404 3.537.323-3.052-1.671-8.954-4.898-5.902-3.227-14.498-6.481-19.187-6.629-4.689-.148-14.526.869-13.117 2.014Z",
    fill: "url(#dE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.586 239.844s1.725 14.438 9.755 21.06a137.635 137.635 0 0 1 14.552 13.623c2.412 2.594-1.158-3.288-3.368-9.634-2.21-6.347-6.448-14.512-9.843-17.753-3.396-3.24-11.386-9.081-11.096-7.296Z",
    fill: "url(#dF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.002 49.446c8.886 0 16.089-7.203 16.089-16.088 0-8.885-7.203-16.088-16.089-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.885 7.203 16.088 16.088 16.088Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.565 65.25c8.885 0 16.088-7.202 16.088-16.087 0-8.886-7.203-16.089-16.088-16.089-8.885 0-16.088 7.203-16.088 16.089 0 8.885 7.203 16.088 16.088 16.088Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.299 77.653c8.886 0 16.089-7.203 16.089-16.088 0-8.885-7.203-16.088-16.089-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.885 7.203 16.088 16.088 16.088ZM175.62 31.688c8.885 0 16.088-7.203 16.088-16.088 0-8.885-7.203-16.088-16.088-16.088-8.886 0-16.089 7.203-16.089 16.088 0 8.885 7.203 16.088 16.089 16.088ZM218.487 166.888c8.885 0 16.088-7.203 16.088-16.089 0-8.885-7.203-16.088-16.088-16.088-8.886 0-16.089 7.203-16.089 16.088 0 8.886 7.203 16.089 16.089 16.089ZM316.893 361.02c8.885 0 16.088-7.203 16.088-16.088 0-8.885-7.203-16.088-16.088-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.885 7.203 16.088 16.088 16.088ZM415.473 342.223c9.853 0 17.84-7.987 17.84-17.84s-7.987-17.84-17.84-17.84-17.84 7.987-17.84 17.84 7.987 17.84 17.84 17.84ZM371.91 315.457c9.853 0 17.84-7.987 17.84-17.84 0-9.852-7.987-17.84-17.84-17.84-9.852 0-17.84 7.988-17.84 17.84 0 9.853 7.988 17.84 17.84 17.84ZM643.081 424.579c8.885 0 16.088-7.203 16.088-16.088 0-8.886-7.203-16.089-16.088-16.089-8.886 0-16.089 7.203-16.089 16.089 0 8.885 7.203 16.088 16.089 16.088ZM617.682 501.814c10.344 0 18.73-8.385 18.73-18.729s-8.386-18.73-18.73-18.73c-10.343 0-18.729 8.386-18.729 18.73 0 10.344 8.386 18.729 18.729 18.729ZM1375.24 212.134c10.34 0 18.73-8.385 18.73-18.729s-8.39-18.729-18.73-18.729c-10.35 0-18.73 8.385-18.73 18.729s8.38 18.729 18.73 18.729ZM1341.8 60.637c16.07 0 29.1-13.028 29.1-29.098s-13.03-29.098-29.1-29.098-29.1 13.028-29.1 29.098 13.03 29.098 29.1 29.098Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.15 40.633c16.07 0 29.1-13.028 29.1-29.098s-13.03-29.098-29.1-29.098-29.1 13.028-29.1 29.098 13.03 29.098 29.1 29.098ZM1263.91 494.68c16.07 0 29.1-13.028 29.1-29.098s-13.03-29.098-29.1-29.098-29.1 13.028-29.1 29.098 13.03 29.098 29.1 29.098ZM692.409 510.259c10.344 0 18.729-8.385 18.729-18.729s-8.385-18.729-18.729-18.729-18.729 8.385-18.729 18.729 8.385 18.729 18.729 18.729ZM570.198 484.935c10.344 0 18.729-8.385 18.729-18.729s-8.385-18.729-18.729-18.729-18.729 8.385-18.729 18.729 8.385 18.729 18.729 18.729ZM712.916 440.665c8.886 0 16.089-7.203 16.089-16.088 0-8.886-7.203-16.089-16.089-16.089-8.885 0-16.088 7.203-16.088 16.089 0 8.885 7.203 16.088 16.088 16.088ZM255.963 167.454c8.886 0 16.089-7.203 16.089-16.088 0-8.886-7.203-16.089-16.089-16.089-8.885 0-16.088 7.203-16.088 16.089 0 8.885 7.203 16.088 16.088 16.088ZM266.049 98.626c8.886 0 16.089-7.203 16.089-16.089 0-8.885-7.203-16.088-16.089-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.886 7.203 16.089 16.088 16.089Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.409 80.337c8.885 0 16.088-7.203 16.088-16.088 0-8.886-7.203-16.089-16.088-16.089-8.886 0-16.089 7.203-16.089 16.089 0 8.885 7.203 16.088 16.089 16.088ZM201.088 59.31c8.886 0 16.089-7.204 16.089-16.089 0-8.885-7.203-16.088-16.089-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.886 7.203 16.089 16.088 16.089Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.713 30.872c8.886 0 16.089-7.203 16.089-16.088 0-8.886-7.203-16.089-16.089-16.089-8.885 0-16.088 7.203-16.088 16.089 0 8.885 7.203 16.088 16.088 16.088ZM292.291 79.438c8.886 0 16.089-7.203 16.089-16.088 0-8.885-7.203-16.088-16.089-16.088-8.885 0-16.088 7.203-16.088 16.088 0 8.885 7.203 16.088 16.088 16.088ZM288.659 424.505c8.885 0 16.088-7.203 16.088-16.089 0-8.885-7.203-16.088-16.088-16.088-8.886 0-16.089 7.203-16.089 16.088 0 8.886 7.203 16.089 16.089 16.089ZM329.961 62.988c6.191 0 11.21-5.02 11.21-11.211 0-6.191-5.019-11.21-11.21-11.21-6.192 0-11.211 5.019-11.211 11.21 0 6.191 5.019 11.21 11.211 11.21ZM260.039 34.222c6.191 0 11.21-5.02 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.019-11.211 11.21 0 6.192 5.019 11.211 11.211 11.211Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.57 41.476c6.191 0 11.211-5.02 11.211-11.21 0-6.192-5.02-11.211-11.211-11.211-6.191 0-11.211 5.019-11.211 11.21 0 6.192 5.02 11.21 11.211 11.21ZM238.414 26.808c6.191 0 11.21-5.02 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.019-11.211 11.21 0 6.192 5.019 11.211 11.211 11.211Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.39 9.105c6.192 0 11.211-5.02 11.211-11.21 0-6.192-5.019-11.211-11.211-11.211-6.191 0-11.21 5.019-11.21 11.21 0 6.192 5.019 11.21 11.21 11.21ZM225.664 9.105c6.191 0 11.21-5.02 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.019-11.211 11.21 0 6.192 5.019 11.21 11.211 11.21ZM177.359 82.574c6.192 0 11.211-5.02 11.211-11.211 0-6.192-5.019-11.21-11.211-11.21-6.191 0-11.211 5.018-11.211 11.21 0 6.191 5.02 11.21 11.211 11.21ZM148.711 74.628c6.191 0 11.21-5.019 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.02-11.211 11.21 0 6.192 5.019 11.211 11.211 11.211ZM201.086 97.757c6.191 0 11.21-5.019 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.02-11.211 11.21 0 6.192 5.019 11.211 11.211 11.211Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.492 111.839c6.191 0 11.21-5.019 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.02-11.211 11.211 0 6.191 5.019 11.21 11.211 11.21ZM320.359 84.788c6.192 0 11.211-5.019 11.211-11.21 0-6.192-5.019-11.21-11.211-11.21-6.191 0-11.211 5.018-11.211 11.21 0 6.191 5.02 11.21 11.211 11.21ZM356.492 66.027c6.191 0 11.21-5.02 11.21-11.21 0-6.192-5.019-11.212-11.21-11.212-6.192 0-11.211 5.02-11.211 11.211 0 6.192 5.019 11.21 11.211 11.21Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.265 74.628c6.192 0 11.211-5.019 11.211-11.21 0-6.192-5.019-11.211-11.211-11.211-6.191 0-11.21 5.02-11.21 11.21 0 6.192 5.019 11.211 11.21 11.211ZM399.383 82.312c6.191 0 11.21-5.02 11.21-11.21 0-6.192-5.019-11.211-11.21-11.211-6.192 0-11.211 5.019-11.211 11.21 0 6.192 5.019 11.21 11.211 11.21ZM468.786 170.115c6.984 0 12.646-5.661 12.646-12.645s-5.662-12.646-12.646-12.646c-6.984 0-12.645 5.662-12.645 12.646 0 6.984 5.661 12.645 12.645 12.645ZM458.646 227.948c6.984 0 12.645-5.662 12.645-12.646 0-6.984-5.661-12.646-12.645-12.646S446 208.318 446 215.302c0 6.984 5.662 12.646 12.646 12.646ZM401.068 226.108c6.984 0 12.645-5.662 12.645-12.646 0-6.984-5.661-12.646-12.645-12.646s-12.646 5.662-12.646 12.646c0 6.984 5.662 12.646 12.646 12.646ZM306.748 224.695c9.577 0 17.341-7.764 17.341-17.342 0-9.577-7.764-17.341-17.341-17.341-9.578 0-17.342 7.764-17.342 17.341 0 9.578 7.764 17.342 17.342 17.342ZM272.013 232.644c9.578 0 17.342-7.764 17.342-17.342 0-9.577-7.764-17.341-17.342-17.341-9.577 0-17.341 7.764-17.341 17.341 0 9.578 7.764 17.342 17.341 17.342ZM481.435 244.858c6.984 0 12.645-5.662 12.645-12.646 0-6.984-5.661-12.646-12.645-12.646s-12.646 5.662-12.646 12.646c0 6.984 5.662 12.646 12.646 12.646ZM483.943 273.416c6.984 0 12.645-5.661 12.645-12.645s-5.661-12.646-12.645-12.646-12.646 5.662-12.646 12.646c0 6.984 5.662 12.645 12.646 12.645ZM448.661 278.448c6.984 0 12.646-5.662 12.646-12.646 0-6.984-5.662-12.646-12.646-12.646-6.984 0-12.645 5.662-12.645 12.646 0 6.984 5.661 12.646 12.645 12.646ZM511.052 314.494c6.984 0 12.646-5.661 12.646-12.645s-5.662-12.646-12.646-12.646c-6.984 0-12.646 5.662-12.646 12.646 0 6.984 5.662 12.645 12.646 12.645ZM556.013 309.698c6.984 0 12.645-5.662 12.645-12.646 0-6.984-5.661-12.646-12.645-12.646s-12.646 5.662-12.646 12.646c0 6.984 5.662 12.646 12.646 12.646ZM416.302 148.658c6.984 0 12.646-5.661 12.646-12.645s-5.662-12.646-12.646-12.646c-6.984 0-12.646 5.662-12.646 12.646 0 6.984 5.662 12.645 12.646 12.645ZM390.708 142.674c6.984 0 12.646-5.662 12.646-12.646 0-6.984-5.662-12.645-12.646-12.645-6.984 0-12.646 5.661-12.646 12.645s5.662 12.646 12.646 12.646ZM362.966 139.104c6.984 0 12.646-5.662 12.646-12.646 0-6.984-5.662-12.646-12.646-12.646-6.984 0-12.646 5.662-12.646 12.646 0 6.984 5.662 12.646 12.646 12.646ZM302.901 114.809c8.885 0 16.088-7.203 16.088-16.088 0-8.885-7.203-16.088-16.088-16.088-8.886 0-16.089 7.203-16.089 16.088 0 8.885 7.203 16.088 16.089 16.088Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.971 123.333c8.885 0 16.088-7.203 16.088-16.088 0-8.886-7.203-16.089-16.088-16.089-8.885 0-16.088 7.203-16.088 16.089 0 8.885 7.203 16.088 16.088 16.088Z",
    fill: "#B07450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.289-4.25s7.95.519 12.046 7.856c4.096 7.336 6.01 17.94 7.283 20.022 1.273 2.082-5.329-6.986-6.427-7.41-1.098-.425-12.08-13.266-12.491-16.843l-.411-3.625Z",
    fill: "url(#dG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.68-13.324s7.943.518 12.046 7.855c4.103 7.337 6.003 17.941 7.276 20.03 1.273 2.088-5.329-6.993-6.421-7.411-1.091-.418-12.086-13.259-12.497-16.843l-.404-3.631Z",
    fill: "url(#dH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.961-14.652a10.29 10.29 0 0 1 8.085 5.639c2.694 5.335 3.88 13.09 4.716 14.606.835 1.516-3.537-5.073-4.272-5.39-.734-.317-8.051-9.587-8.287-12.214l-.242-2.641Z",
    fill: "url(#dI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.516-14.879a10.287 10.287 0 0 1 8.084 5.64c2.695 5.335 3.881 13.09 4.716 14.612.836 1.523-3.537-5.073-4.271-5.39-.734-.316-8.044-9.6-8.28-12.241l-.249-2.62Z",
    fill: "url(#dJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.883 13.652s9.129 6.145 10.395 12.572c1.267 6.427.802 12.127-.613 18.594-1.415 6.468-.101-3.853-3.112-8.4a39.793 39.793 0 0 1-5.525-15.14 123.741 123.741 0 0 0-1.145-7.626Z",
    fill: "url(#dK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.153 131.27s-11.79-6.603-13.912-15.044c-2.122-8.442-2.021-16.237-.863-25.17 1.159-8.934 3.174 3.368 9.702 8.118 5.457 3.955 2.109 16.843 2.998 22.03a169.909 169.909 0 0 0 2.075 10.066Z",
    fill: "url(#dL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.414 121.293s-11.924 1.152-18.783 7.02c-7.781 6.663-6.104 9.345-6.104 9.345s10.173-3.74 14.148-6.327c3.975-2.587 10.739-10.038 10.739-10.038Z",
    fill: "url(#dM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.938 117.129s-11.932 1.152-18.783 7.027c-7.782 6.663-6.104 9.358-6.104 9.358s10.173-3.733 14.148-6.327c3.975-2.593 10.739-10.058 10.739-10.058Z",
    fill: "url(#dN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.486 114.906s-11.925 1.152-18.777 7.027c-7.781 6.656-6.104 9.338-6.104 9.338s10.173-3.733 14.115-6.326c3.941-2.594 10.766-10.039 10.766-10.039Z",
    fill: "url(#dO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.206 119.605s-15.125.344-23.452 5.895c-9.432 6.3-7.121 9.17-7.121 9.17s12.706-3.12 17.55-5.505c4.844-2.384 13.023-9.56 13.023-9.56Z",
    fill: "url(#dP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.088 123.082s-15.044-1.583-24.011 2.864c-10.18 5.046-8.233 8.192-8.233 8.192s13.003-1.482 18.11-3.227c5.107-1.745 14.134-7.829 14.134-7.829Z",
    fill: "url(#dQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.148 46.53s13.704 5.458 21.714 7.19c8.011 1.73 17.517 3.368 24.625 5.793 7.107 2.426 19.389 9.325 24.503 14.04 5.113 4.717 16.721 14.735 22.414 18.34 5.693 3.603-9.506-8.719-12.538-11.508-3.031-2.79-17.429-16.17-30.202-21.66-12.774-5.49-22.28-6.259-27.576-7.707-5.295-1.449-18.345-4.514-18.345-4.514l-4.595.027Z",
    fill: "url(#dR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.914 225.392s28.128-21.41 39.453-23.964c11.325-2.553 38.267-11.769 70.107-15.616 33.146-4.009 36.118-7.337 58.162-21.364 22.044-14.027 55.52-19.767 74.331-19.127 18.81.64 42.72 8.604 53.897 14.344l-1.597 8.084s-35.269-13.824-57.34-11.271c-22.071 2.553-40.888 6.064-52.361 14.027-11.473 7.963-29.859 17.516-45.698 21.997-15.839 4.48-18.062 7.336-33.841 11.453-15.778 4.116-45.354 4.143-58.31 10.2-12.956 6.057-45.469 37.324-45.469 37.324l-1.334-26.087Z",
    fill: "url(#dS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.833 253.527s-10.355 13.562-5.423 24.927c4.931 11.366 9.614 12.464 11.089 17.941 1.475 5.477 0 6.96 0 6.96s4.682-4.225 5.673-19.619c.99-15.394-1.974-25.251-3.207-31.166-1.233-5.915-8.132.957-8.132.957Z",
    fill: "url(#dT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.554 409.616s15.536-.674 23.425 6.211c7.89 6.886 10.349 11.346 13.064 16.028 2.715 4.682-6.165 0-12.801 0s-15.778-6.825-19.969-9.701c-4.19-2.877-8.873-12.673-3.719-12.538Z",
    fill: "url(#dU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.094 171.242s17.126 6.279 24.826 7.923c7.701 1.644 22.179 0 26.275 7.377s12.572 29.239 19.127 40.989c6.555 11.749 11.204 26.51 21.592 34.979 10.389 8.469 30.318 19.127 38.254 24.597 7.936 5.471 24.867 16.392 29.239 20.764 4.373 4.373 15.455 14.014 20.299 17.254 4.844 3.241 13.549 10.894 18.352 12.262a35.402 35.402 0 0 1 8.927 4.103s6.562 2.23 12.026 2.6c5.464.371-15.071-5.639-20.926-10.011-5.854-4.373-29.394-22.954-36.616-30.607-7.222-7.653-24.443-17.759-33.187-22.677-8.745-4.918-24.652-12.127-33.228-23.136-8.576-11.008-21.424-35.35-25.251-46.823-3.827-11.473-12.127-30.149-20.845-33.255-15.549-5.538-27.191-3.638-35.417-7.464l-7.997-3.699-5.45 4.824Z",
    fill: "url(#dV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.742 184.757s1.725-8.758 10.443-9.492c8.718-.735 23.87-.728 27.151-1.099 3.28-.37.384 4.043-2.817 7.485-3.2 3.443-8.327 6.205-15.259 5.66-6.933-.546-17.328.909-19.518-2.554Z",
    fill: "url(#dW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 220.93s2.735-11.352 10.402-12.801c7.667-1.448 17.887-1.091 27.009-1.462 9.123-.37 5.66.553 2.372 2.19-3.288 1.637-6.933 2.56-10.22 6.575-3.288 4.016-6.569 9.122-14.6 8.577-8.03-.546-13.319-.115-14.963-3.079Z",
    fill: "url(#dX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.185 188.582s-2.695 4.588-1.253 17.988c1.442 13.4 7.647 11.036 7.647 22.711 0 11.676 5.288-4.109 5.288-8.354 0-4.244 1.826-12.45-1.091-20.845-2.917-8.394-8.394-15.145-10.591-11.5Z",
    fill: "url(#dY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.076 224.035s-4.716 8.536-4.716 14.013c0 5.478-.182 13.872 4.716 18.979 4.898 5.107 6.569 4.932 7.303 6.939.735 2.008 2.736 3.463 2.736-2.378s-.364-24.085-4.198-30.317c-3.833-6.232-5.841-7.236-5.841-7.236Z",
    fill: "url(#dZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.695 255.267s12.046 1.577 19.167-.977c7.121-2.553 13.138-11.864 15.496-14.969 2.358-3.106 1.529-4.38-10.456-1.819-11.986 2.56-17.241 4.567-20.293 8.441-3.052 3.874-5.544 7.195-3.914 9.324Z",
    fill: "url(#ea)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.556 277.284s-1.631-10.78 5.881-13.69c7.512-2.91 16.466-.91 20.845-2.19 4.379-1.28 9.486-2.924 9.486-2.924s-1.28 2.924-8.395 8.038c-7.114 5.113-21.868 19.16-27.817 10.766Z",
    fill: "url(#eb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.625 260.496s-3.948 6.34-.836 12.841c3.113 6.501 13.333 12.343 16.439 15.994l3.092 3.652a14.092 14.092 0 0 0 1.226-7.544 14.088 14.088 0 0 0-2.89-7.076c-5.538-7.317-17.031-17.867-17.031-17.867Z",
    fill: "url(#ec)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.991 292.984s-7.121 4.716-3.287 15.697c3.833 10.982 10.947 18.063 10.947 22.812 0 4.75 5.296-13.144 2.924-23.58-2.371-10.435-8.051-15.293-10.584-14.929Z",
    fill: "url(#ed)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.918 280.464s-7.114 4.75-3.287 15.698c3.826 10.948 10.954 18.069 10.954 22.812 0 4.743 5.289-13.138 2.917-23.54-2.371-10.402-8.044-15.334-10.584-14.97Z",
    fill: "url(#ee)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43 307.4s4.13-9.924 9.263-12.195c5.134-2.27 12.087-4.042 15.752-6.973 3.665-2.93 5.113-4.379 3.651 0-1.462 4.38-3.308 12.963-9.135 16.062-5.828 3.099-15.887 6.939-19.531 3.106Z",
    fill: "url(#ef)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41 307.844a28.092 28.092 0 0 0 1.017 16.331c3.281 8.394 8.213 15.879 8.213 18.796s2.472 0 3.604-5.652c1.132-5.653-1.981-21.728-12.834-29.475Z",
    fill: "url(#eg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.631 341.489s10.955-3.975 17.342 1.866c6.387 5.841 13.804 14.236 17.307 17.874 3.504 3.638-4.17-.728-12.012-2.021-7.842-1.294-12.558 1.347-16.775-2.426-4.218-3.773-10.605-12.78-5.862-15.293Z",
    fill: "url(#eh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.963 325.098s10.355 1.832 19.141-2.736c8.785-4.567 8.125-12.591 12.8-15.145 4.676-2.553 5.329-2.742 0-2.189-5.329.552-24.307 3.833-28.141 8.576-3.833 4.743-7.263 9.297-3.8 11.494Z",
    fill: "url(#ei)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.867 327.297s.337 14.599 4.46 20.44c4.123 5.841 7.95 11.784 8.954 14.923 1.004 3.14 5.747-8.172 5.019-14.195-.728-6.023-17.914-29.563-18.433-21.168Z",
    fill: "url(#ej)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.227 337.387s6.892-8.684 15.677-11.393a28.408 28.408 0 0 0 13.656-9.654s1.725 4.467-2.506 10.53-9.243 9.654-15.112 10.517a46.118 46.118 0 0 1-11.715 0Z",
    fill: "url(#ek)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.508-14.934s8.085 16.028 18.13 28.425C26.667 25.887 36.375 82.43 36.759 88.63c.384 6.198 1.927 34.103 3.874 62.359s1.934 111.547 1.934 111.547-4.642 115.125-4.642 126.12c0 10.995 4.258 87.3 4.642 103.179.384 15.88-6.192 76.898-3.483 113.488 2.708 36.589 1.55 166.353 1.55 166.353l66.023 2.641s-24.644-153.283-23.33-182.388c1.313-29.104-5.653-196.597-7.66-229.272-2.008-32.675-6.327-125.864-8.267-158.849-1.94-32.985-9.917-111.836-18.972-151.93-9.055-40.092-10.955-40.59-20.01-52.104-9.054-11.514-8.165-14.553-8.165-14.553l-21.76-.155Z",
    fill: "url(#el)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.99 211.185s24.698 29.516 31.233 42.249c6.535 12.733 20.616 35.855 20.259 45.004-.358 9.149-1.18-82.267-1.18-82.267s-1.61 25.621-10.368 14.72c-8.758-10.9-40.962-43.973-40.962-43.973l1.017 24.267Z",
    fill: "url(#em)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.269 145.275s18.527 6.555 27.623 14.546c9.095 7.99 22.097 20.696 21.794 27.797-.303 7.101-.761-43.266-.761-43.266s2.533 13.138-13.178 3.78c-13.474-8.044-35.498-18.46-35.498-18.46l.02 15.603Z",
    fill: "url(#en)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.276 72.63s20.777 5.16 30.587 21.868c9.81 16.708 15.084 33.45 15.859 41.461.775 8.01.155-46.79-3.726-64.495-3.88-17.705 1.381 15.186-7.336 7.195-8.718-7.99-14.97-11.406-22.96-14.31-7.99-2.903-13.125-2.782-13.125-2.782l.701 11.062Z",
    fill: "url(#eo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.269 335.629s54.854 61.739 58.85 70.821c3.995 9.082 2.768 17.631 2.29 27.521-.478 9.89-3.746 29.772-17.55 5.848C22.516 415.895-9 378.639-9 378.639l1.731-43.01Z",
    fill: "url(#ep)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.273 304.773s21.74 16.304 30.195 30.856c8.456 14.552 15.105 21.815 16.648 30.56 1.543 8.745 2.567-57.017 2.567-57.017s-9.19-4.426-26.14-17.867c-16.951-13.44-23.27-14.532-23.27-14.532v28Z",
    fill: "url(#eq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 479.242s56.95 43.792 59.49 54.665c2.539 10.874-3.114 48.313-9.911 51.203-6.798 2.89-16.964-13.077-23.142-28.33C11.259 541.527-9 524.698-9 524.698v-45.456Z",
    fill: "url(#er)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8 25.879s-1.111-11.985 3.268-15.253c4.38-3.267 15.617-7.997 21.795-6.542 6.178 1.456 16.566 8.307 20.17 13.805 6.61 10.105 24.767 19.571 30.722 23.613l3.84-.525s-20.763-10.84-26.194-17.28C87.971 17.255 73.628 3.922 71.654 2.69 69.68 1.457 72.394.217 88.456.958c16.062.741 26.949 2.473 32.123 5.437 5.174 2.965 25.157 12.127 32.338 13.973 7.182 1.846 31.449.606 37.728 3.328s28.296 16.061 38.907 21.498c10.612 5.437 31.881 14.088 38.308 18.784 6.427 4.695 11.366 14.33 20.757 17.294 9.392 2.964 35.094 3.712 42.505 10.874 7.411 7.161 20.528 15.091 20.528 15.091s-13.346-10.382-17.793-15.078c-4.446-4.696-12.127-7.66-22.489-9.883-10.361-2.224-20.022-1.483-27.682-8.401-7.661-6.92-17.099-16.702-34.252-23.116-11.09-4.15-51.465-29.273-58.775-30.762-7.31-1.488-30.162-.491-39.001-4.716-8.84-4.224-40.962-17.55-43.435-17.55-2.472 0-2.695-5.437 19.538-2.223 22.232 3.214 47.692 7.977 54.604 6.703 6.913-1.273 14.58-6.42 25.945-3.705 11.366 2.715 54.369 13.097 57.34 14.822l12.599 3.213s-6.178-4.716-25.204-9.391c-19.026-4.676-38.308-10.874-46.709-11.615-8.401-.741-13.838 2.472-12.605 0 1.233-2.473 31.934-10.422 31.934-10.422l-10.395-.054s-22.617 7.35-30.6 10.395c-8.759 3.335-11.204 3.786-28.007.573-16.802-3.214-41.891-6.36-70.309-3.369C57.937-4.35 45.258-.262 39.801 4.933c-5.458 5.194-6.145 6.481-6.145 6.481l6.145 14.465Z",
    fill: "url(#es)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.58 239.766c-.869 1.348 2.453 3.369 3.773 4.285 5.235 3.638 17.786 13.043 23.937 23.58 7.896 13.542 18.427 26.7 30.459 34.595 12.033 7.896 33.841 18.797 42.114 24.813 8.273 6.017 22.179 12.41 28.195 19.181 6.016 6.771 20.683 12.801 33.464 18.797 12.78 5.996 18.803 5.261 30.081 10.907 11.278 5.646 24.065 10.146 31.206 16.169 7.142 6.023 22.166 16.554 27.448 19.936 5.282 3.382 8.273 4.891 8.273 4.891s-14.29-12.801-20.677-18.804c-6.386-6.002-13.912-14.66-23.687-19.537-9.776-4.878-32.339-10.524-46.251-17.295-13.912-6.77-31.206-15.805-38.146-21.821-6.939-6.017-14.471-7.142-20.11-12.801a84.949 84.949 0 0 0-18.049-13.912c-7.519-4.514-18.803-5.646-28.579-14.29-9.776-8.643-20.993-18.338-28.141-28.114-7.148-9.775-13.589-22.744-21.505-28.013-2.917-1.94-7.155-7.33-8.51-8.084-1.475-.822-1.892 1.913-2.802 3.368l-2.492 2.149Z",
    fill: "url(#et)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.189 329.994s-6.394 17.301 2.257 28.97c8.65 11.669 17.294 24.436 17.294 24.436s.755-22.556 0-30.452c-.755-7.896-15.415-28.202-15.415-28.202l-4.136 5.248Z",
    fill: "url(#eu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.17 336.206s-5.673 4.393 0 19.08c5.672 14.687 8.131 19.868 12.571 24.799 4.44 4.932 9.863 6.408 10.847 7.89.984 1.482-.984-3.699-2.958-10.605-1.974-6.905-5.463-29.825-9.883-34.507-4.42-4.683-5.895-8.88-10.577-6.657Z",
    fill: "url(#ev)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.605 357.403s-5.296 14.303 5.113 25.15c10.409 10.846 14.606 12.079 16.58 16.762 1.974 4.682.492-.741 0-8.139-.491-7.397-3.698-16.27-7.148-21.444-3.449-5.174-12.08-15.529-14.545-12.329Z",
    fill: "url(#ew)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.269 314.65s-9.614 6.185-4.682 20.353c4.932 14.168 10.382 17.874 9.755 24.031a42.811 42.811 0 0 0 0 10.106s2.574-6.905 6.023-11.345c3.45-4.44 3.948-17.517 1.233-26.625-2.715-9.109-5.915-20.468-12.329-16.52Z",
    fill: "url(#ex)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.114 302.617s-4.932 10.955 0 21.559c4.931 10.604 8.131 13.562 9.364 19.235 1.233 5.672 1.233 12.841 2.958 15.913 1.725 3.072.99-4.332 3.207-9.015 2.216-4.682 4.682-20.952 1.974-29.091-2.709-8.138-10.106-21.444-12.08-23.169-1.974-1.724-5.423 4.568-5.423 4.568Z",
    fill: "url(#ey)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.768 275.06c-2.291-3.651-7.789-3.072-9.432.903-1.826 4.366-4.42 12.76-1.308 19.996 4.44 10.308 9.123 18.446 9.123 22.906a35.278 35.278 0 0 1-1.476 9.123s8.624-10.106 8.624-23.419c0-13.312-2.466-24.402-5.424-29.333a1.087 1.087 0 0 0-.107-.176Z",
    fill: "url(#ez)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.912 245.485s6.656 3.698 14.296 1.233c7.64-2.466 13.326-16.021 15.28-18.736 1.953-2.715 5.207-8.631 0-6.657-5.208 1.974-6.192 5.174-11.117 5.424-4.925.249-14.053-1.476-18.493 3.449-4.44 4.925-4.433 11.837.034 15.287Z",
    fill: "url(#eA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.922 269.394s10.833 4.932 20.939-1.967c10.106-6.899 7.889-14.545 11.83-17.011 3.942-2.466 5.498-4.191 5.498-4.191s-17.517-1.974-24.698 3.2c-7.182 5.174-13.407 13.38-13.569 19.969Z",
    fill: "url(#eB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.859 291.585s12.572 6.158 22.186 0c9.614-6.157 6.407-11.096 12.08-14.821 5.672-3.726 7.41-5.686 7.41-5.686a31.487 31.487 0 0 0-16.519 2.23c-8.873 3.705-16.513 4.904-20.71 9.236a15.34 15.34 0 0 0-4.447 9.041Z",
    fill: "url(#eC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.196 369.73s-4.682 12.801 1.233 22.677c5.915 9.877 10.604 10.106 13.562 15.779s5.174-6.899 3.2-14.546c-1.974-7.646-14.289-33.274-17.995-23.91Z",
    fill: "url(#eD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.865 375.156s-4.191 6.656 1.233 17.254c5.423 10.597 11.588 27.622 11.83 29.583.243 1.96 3.948-14.546 3.207-22.186-.741-7.64-11.096-29.583-16.27-24.651Z",
    fill: "url(#eE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.351 385.927s-1.819 16.897 8.037 27.306c9.857 10.408 17.517 17.557 17.517 17.557s-1.88-15.819-4.932-23.419c-3.052-7.599-19.288-28.1-20.622-21.444Z",
    fill: "url(#eF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.102 376.314s1.758-10.18 14.821-10.968c13.064-.788 20.212 2.021 23.419 2.351 3.207.33-8.88-.33-11.096 3.443-2.217 3.773-8.395 9.25-16.527 7.795-8.131-1.455-10.617-2.621-10.617-2.621Z",
    fill: "url(#eG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.867 399.409s1.59-9.573 15.886-10.779c14.297-1.206 22.907 0 22.907 0s-5.673 6.164-12.329 9.641c-6.657 3.476-26.464 1.138-26.464 1.138Z",
    fill: "url(#eH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.747 406.713s-2.958 9.613 5.673 20.46c8.63 10.847 13.568 15.038 13.568 15.038s3.086 1.232 1.294-4.932c-1.792-6.165-18.143-39.534-19.41-34.023-.189.829-1.125 3.457-1.125 3.457Z",
    fill: "url(#eI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.764 353.71s-1.084-11.345 4.514-13.811c5.599-2.466 17.18-3.692 23.836-9.115 6.657-5.424.991 2.216-1.475 7.148-2.466 4.932-10.106 18.487-26.875 15.778Z",
    fill: "url(#eJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.914 330.782a58.095 58.095 0 0 1 20.346-13.562c12.929-5.174 20.845-3.611 24.038-5.625 3.194-2.015-3.462 9.883-8.145 14.781-4.682 4.898-22.037 14.68-27.946 11.992a18.049 18.049 0 0 1-8.293-7.586Z",
    fill: "url(#eK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.386 365.272s9.371-.983 15.778-6.656 8.415-12.08 11.11-15.037c2.695-2.958-3.941-6.441-12.329-2.109-8.388 4.332-14.202 7-16.284 13.798-2.082 6.797-1.219 10.557 1.725 10.004Z",
    fill: "url(#eL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.374 367.699s-1.94-6.637 7.903-12.41c9.843-5.774 14.282-11.191 14.282-11.191s3.948-.289-1.724 11.191c-5.673 11.48-7.62 12.47-11.945 14.444-4.326 1.974-7.283 2.345-8.516-2.034Z",
    fill: "url(#eM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.191 313.033s-3.942-10.847 5.181-16.762c9.122-5.915 22.427-9.863 29.825-10.847 7.397-.984 6.414-.492 2.466 2.958-3.948 3.449-9.365 16.762-15.038 19.227-5.672 2.466-18.271 11.851-22.434 5.424Z",
    fill: "url(#eN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.375 320.179s.741-14.512 13.07-20.077c12.329-5.565 26.376-1.617 28.842-2.601 2.466-.983-6.165 7.687-10.604 11.117-4.44 3.429-11.454 8.852-12.983 11.561-1.529 2.708-12.349 7.606-14.606 5.389a20.376 20.376 0 0 1-3.719-5.389Z",
    fill: "url(#eO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.837 7.406s-3.12 8.759-1.759 17.342c1.361 8.583 2.695 14.033 2.695 14.033a27.534 27.534 0 0 0 5.066-15.684c.101-9.371-6.002-15.69-6.002-15.69Z",
    fill: "url(#eP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.003 55.834s-4.958-16.088-2.149-24.557c2.81-8.469 2.924-9.547 2.924-9.547s4.675 7.21 4.291 13.839c-.383 6.629-5.066 20.265-5.066 20.265Z",
    fill: "url(#eQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.995 32.906s-3.975 2.533-2.607 9.351c1.368 6.818 4.251 8.934 2.607 17.234-1.644 8.3 4.797-7.296 4.797-12.356s-4.797-14.229-4.797-14.229Z",
    fill: "url(#eR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.641 21.732s-.303-6.791 10.995-9.742a197.093 197.093 0 0 0 20.657-6.623s-2.143 5.067-8.577 8.18c-6.434 3.112-23.075 8.185-23.075 8.185Z",
    fill: "url(#eS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35 33.612s-2.87-8.374 6.676-13.245c9.547-4.87 20.852-10.523 20.852-10.523s-7.013 12.861-12.08 15.785c-5.066 2.924-15.448 7.983-15.448 7.983Z",
    fill: "url(#eT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 11.758S90.115.533 99.594-.438c9.48-.97 18.319-2.344 18.319-2.344s-5.74 7.02-13.394 8.96c-7.653 1.94-22.785 5.579-22.785 5.579Z",
    fill: "url(#eU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.883 44.786s6.339-12.49 15.495-15.064c9.156-2.574 17.645-5.39 17.645-5.39s-4.433 7.856-11.642 11.076c-7.209 3.22-21.498 9.378-21.498 9.378Z",
    fill: "url(#eV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.055 29.242a40.778 40.778 0 0 1 10.186-13.097c6.791-5.585 19.167-8.758 19.167-8.758s-8.003 4.857-8.488 7.303c-.485 2.445-6.556 10.186-9.951 11.4-3.396 1.212-10.914 3.152-10.914 3.152Z",
    fill: "url(#eW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5 36.422s8.085-9.196 13.582-14.37c5.498-5.174 16.102-5.181 18.628-6.333 2.527-1.152-10.577 5.982-11.729 8.084-1.152 2.102-7.364 12.424-10.813 12.653-3.45.229-9.668-.034-9.668-.034Z",
    fill: "url(#eX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.328 43.234s8.28-10.577 15.179-15.179c6.899-4.601 15.644-5.517 18.19-7.471 2.547-1.954-8.758 6.65-9.897 8.441-1.138 1.792-6.669 9.843-11.5 11.683-4.83 1.839-11.972 2.526-11.972 2.526Z",
    fill: "url(#eY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.922 51.044s2.856-12.06 12.288-15.32c9.432-3.261 14.492-6.482 14.492-6.482s-11.5 7.997-11.729 10.9c-.229 2.905-8.617 10.18-15.051 10.902Z",
    fill: "url(#eZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.802 56.653s-.849-7.916 5.686-13.204c6.535-5.29 16.654-8.974 18.493-10.585 1.84-1.61-5.982 6.441-6.211 7.593-.229 1.152-11.016 14.148-14.492 15.179l-3.476 1.017Z",
    fill: "url(#fa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.711 62.22s3.625-7.087 11.985-7.95c8.361-.862 18.864 1.59 21.27 1.247 2.405-.343-8.53 2.13-9.352 2.965-.822.835-16.964 5.84-20.433 4.79l-3.47-1.051Z",
    fill: "url(#fb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.406 68.35s3.625-7.088 11.986-7.95c8.36-.863 18.864 1.59 21.269 1.246 2.405-.343-8.529 2.13-9.351 2.965-.822.835-16.964 5.84-20.434 4.79l-3.47-1.051Z",
    fill: "url(#fc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.727 56.034s4.5-7.936 11.534-10.61c7.033-2.676 15.104-2.474 17.159-3.37 2.055-.896-7.444 3.989-8.3 5.013-.856 1.024-15.165 9.567-17.779 9.257l-2.614-.29Z",
    fill: "url(#fd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.18 53.393s4.5-7.936 11.574-10.61c7.074-2.675 15.098-2.473 17.16-3.37 2.061-.895-7.452 3.99-8.301 5.013-.848 1.024-15.165 9.567-17.786 9.257l-2.647-.29Z",
    fill: "url(#fe)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.398 49.695s2.87-8.664 9.251-12.659c6.38-3.995 14.336-5.39 16.169-6.616 1.832-1.226-6.529 5.39-7.169 6.535-.64 1.146-13.009 12.33-15.637 12.538l-2.614.202Z",
    fill: "url(#ff)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.938 77.047s3.617-7.095 11.978-7.95c8.361-.856 18.864 1.59 21.269 1.246 2.406-.343-8.529 2.122-9.351 2.958-.822.835-16.964 5.848-20.427 4.797l-3.469-1.051Z",
    fill: "url(#fg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.438 85.367s3.624-7.094 11.985-7.95c8.361-.855 18.864 1.584 21.269 1.247 2.405-.337-8.543 2.122-9.351 2.971-.809.849-16.964 5.848-20.434 4.797l-3.469-1.065Z",
    fill: "url(#fh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.175 63.35s-1.455-8.913 3.368-13.69c4.824-4.776 10.355-6.38 14.95-8.448a30.652 30.652 0 0 0 8.085-5.525s-4.595 6.9-9.89 9.433c-5.296 2.533-11.043 11.365-11.043 11.365l-5.47 6.865Z",
    fill: "url(#fi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.206 70.487s-1.455-8.913 3.369-13.69c4.823-4.777 8.569-8.401 13.171-10.476a77.665 77.665 0 0 1 9.829-3.497s-6.306 4.79-9.89 9.432c-3.402 4.4-14.148 19.686-14.148 19.686l-2.331-1.455Z",
    fill: "url(#fj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.183 44.656a13.394 13.394 0 0 0-2.304 14.148 92.892 92.892 0 0 0 7.249 14.074s1.118-11.271.728-16.337c-.391-5.067-5.673-11.885-5.673-11.885Z",
    fill: "url(#fk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.354 69.693s4.143-13.804 4.372-17.254c.229-3.45-4.372-14.404-4.372-14.404s-6.475 3.941-3.814 10.894c2.661 6.953 3.814 20.764 3.814 20.764Z",
    fill: "url(#fl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.268 58.732s-3.665-22.024-7.822-27.549c-4.157-5.524-4.601 9.951-2.526 13.576 2.075 3.624 10.348 13.973 10.348 13.973Z",
    fill: "url(#fm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.403 87.288s10.16-19.888 10.106-26.8c-.054-6.913-9.621 5.26-10.106 9.431-.485 4.17 0 17.369 0 17.369Z",
    fill: "url(#fn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.622 85.484s-4.311 12.545-1.347 20.993c2.964 8.449 5.982 12.363 5.982 12.363s-1.61-11.042 0-14.263c1.611-3.22-4.635-19.093-4.635-19.093Z",
    fill: "url(#fo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.013 88.375s-4.278 8.664-1.287 16.944a54.838 54.838 0 0 0 7.822 14.263s2.068-9.203 0-14.492l-6.535-16.715Z",
    fill: "url(#fp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.63 99.988s-7.936-5.511-16.567-3.787a54.94 54.94 0 0 0-15.266 5.646s8.758 3.416 14.337 2.149l17.496-4.008Z",
    fill: "url(#fq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.56 91.626s-7.93-5.517-16.567-3.786a54.934 54.934 0 0 0-15.266 5.619s8.798 3.409 14.336 2.15l17.497-3.983Z",
    fill: "url(#fr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.648 103.195s1.173 21.128 5.087 26.188c3.914 5.059 2.991-4.373 2.297-10.584-.694-6.212-7.384-15.604-7.384-15.604Z",
    fill: "url(#fs)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.414 66.646s40.315-26.328 75.982-26.692c35.666-.364 43.205-2.91 54.847-6.529 11.642-3.617 23.236-4.803 40.032-6.103 16.796-1.3 63.666 12.376 85.4 11.27 21.734-1.104 41.023-1.953 58.357 4.043 17.335 5.996 27.502 12.983 32.945 15.927 5.444 2.944 9.196 3.483 9.196 3.483v1.118s-11.54-3.085-14.821-5.241c-3.281-2.156-14.822-8.657-19.707-10.57-4.884-1.914-19.423-6.812-30.681-6.98-11.257-.169-31.529 1.69-36.38 1.69-4.851 0-29.448-.39-42.936-2.802s-33.982-6.63-66.631.674c-32.648 7.303-45.812 9-59.96 8.367-14.148-.633-38.584 1.26-52.476 11.743L70.69 70.527s8.758 3.038 21.983 17.658c13.225 14.62 20.36 24.193 32.103 26.12 11.743 1.927 44.863 2.803 53.042 5.087 8.178 2.283 35.814 13.818 55.008 13.818 19.195 0 36.105-.674 50.024-1.793 13.919-1.118 35.794.762 45.368 3.221 9.573 2.459 24.611 8.758 36.643 15.59a209.285 209.285 0 0 0 21.33 10.664s-15.037-4.924-24.887-9.843c-9.85-4.918-25.204-13.474-42.673-15.657a153.22 153.22 0 0 0-36.664-.155c-6.609.627-38.947 2.022-46.58 1.698-7.634-.323-33.659-3.719-52.84-7.734-19.181-4.015-26.437-4.716-41.225-5.141-14.788-.424-27.858 1.112-40.598-13.912-12.74-15.024-18.729-25.001-25.965-29.926-7.235-4.925-14.95-5.861-16.997-4.608-2.049 1.253-3.437 8.502-3.437 8.502l-2.91-17.47Z",
    fill: "url(#ft)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.648 105.809s6.441-.526 10.355 4.534c3.915 5.059 4.831 17.712 8.509 22.084 3.679 4.372-9.202-6.899-10.584-10.779-1.381-3.881-8.28-15.839-8.28-15.839Z",
    fill: "url(#fu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.893 135.316s-6.878 19.7 2.426 29.705l9.304 10.004s-1.233-16.088-3.086-22.381c-1.853-6.292-8.644-17.328-8.644-17.328Z",
    fill: "url(#fv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.003 134.656s-6.879 19.7 2.425 29.711l9.304 10.005s-1.233-16.095-3.086-22.388c-1.852-6.292-8.643-17.328-8.643-17.328Z",
    fill: "url(#fw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.026 133.629s-6.879 19.699 2.425 29.711l9.304 10.004s-1.232-16.088-3.085-22.38c-1.853-6.293-8.644-17.335-8.644-17.335Z",
    fill: "url(#fx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.905 190.683s-6.878 19.699 2.406 29.738l9.304 10.011s2.108-19.848 0-26.059c-5.215-15.462-11.71-13.69-11.71-13.69Z",
    fill: "url(#fy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.592 195.493s-6.872 19.699 2.432 29.71l9.304 10.005s2.109-19.841 0-26.052c-5.241-15.449-11.736-13.663-11.736-13.663Z",
    fill: "url(#fz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.432 189.58s-4.09 20.461 6.514 29.084l10.598 8.624s-.674-19.942-3.604-25.803c-7.317-14.559-13.508-11.905-13.508-11.905Z",
    fill: "url(#fA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.719 196.545s-4.083 20.461 6.514 29.084l10.598 8.624s-.674-19.942-3.604-25.803c-7.317-14.559-13.508-11.905-13.508-11.905Z",
    fill: "url(#fB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.446 195.843s-2.728 18.5 16.466 28.721l19.194 10.22s-5.006-18.945-11.022-25.049c-14.943-15.172-24.638-13.892-24.638-13.892Z",
    fill: "url(#fC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.799 203.903s-4.089 20.468 6.508 29.091l10.598 8.624s-.674-19.942-3.598-25.804c-7.323-14.559-13.508-11.911-13.508-11.911Z",
    fill: "url(#fD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.054 204.625s-12.126 17.005-5.948 29.206l6.151 12.194s7.552-18.473 7.256-25.022c-.728-16.263-7.459-16.378-7.459-16.378Z",
    fill: "url(#fE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.043 133.629s-2.446 18.702 2.432 29.711c5.531 12.49 9.304 10.004 9.304 10.004s-1.233-16.088-3.086-22.38c-1.852-6.293-8.65-17.335-8.65-17.335Z",
    fill: "url(#fF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.125 137.152s-1.348 15.233 3.685 24.51c5.7 10.537 9.048 8.678 9.048 8.678s-1.92-13.279-3.934-18.534c-2.015-5.255-8.799-14.654-8.799-14.654Z",
    fill: "url(#fG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.807 143.207s-.444 11.972 4.46 19.538c5.565 8.596 8.449 7.296 8.449 7.296s-2.352-10.584-4.393-14.822c-2.041-4.237-8.516-12.012-8.516-12.012Z",
    fill: "url(#fH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.553 183.961s-6.778 12.315-5.693 22.691c1.233 11.776 4.911 11.844 4.911 11.844s3.146-12.249 3.274-17.719c.128-5.471-2.492-16.816-2.492-16.816Z",
    fill: "url(#fI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.742 193.082s-6.428 11.817-5.296 21.828c1.287 11.366 4.824 11.454 4.824 11.454s5.551-11.373 5.632-16.648c.081-5.275-5.16-16.634-5.16-16.634Z",
    fill: "url(#fJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.72 175.188s-8.085 6.892-6.994 17.267c1.233 11.776 6.212 17.267 6.212 17.267s3.146-12.248 3.274-17.719c.128-5.47-2.492-16.815-2.492-16.815Z",
    fill: "url(#fK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.14 161.309s-6.784 12.308-5.693 22.69c1.233 11.77 4.905 11.844 4.905 11.844s3.153-12.248 3.281-17.718c.128-5.471-2.493-16.816-2.493-16.816Z",
    fill: "url(#fL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.326 152.848s-6.777 12.315-5.693 22.69c1.233 11.777 4.912 11.844 4.912 11.844s3.146-12.248 3.274-17.718c.128-5.471-2.493-16.816-2.493-16.816Z",
    fill: "url(#fM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.635 154.506s-10.598-2.432-18.143.613c-8.563 3.463-7.869 6.238-7.869 6.238s9.816-.276 13.932-1.347c4.117-1.071 12.08-5.504 12.08-5.504Z",
    fill: "url(#fN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.104 161.81s-10.598-2.439-18.143.613c-8.563 3.463-7.869 6.231-7.869 6.231s9.816-.276 13.932-1.347 12.08-5.497 12.08-5.497Z",
    fill: "url(#fO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.058 167.501s-10.597-2.439-18.143.613c-8.563 3.463-7.862 6.232-7.862 6.232s9.809-.276 13.926-1.348c4.116-1.071 12.079-5.497 12.079-5.497Z",
    fill: "url(#fP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.372 182.694s-9.472-5.343-17.57-4.561c-9.196.882-9.318 3.739-9.318 3.739s9.486 2.526 13.744 2.654c4.258.128 13.144-1.832 13.144-1.832Z",
    fill: "url(#fQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.356 171.242s-10.712 1.873-16.486 7.606c-6.549 6.515-4.831 8.799-4.831 8.799s8.934-4.042 12.316-6.656c3.382-2.614 9.001-9.749 9.001-9.749Z",
    fill: "url(#fR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.781 186.223s1.28 10.779 6.69 16.876c6.145 6.899 8.523 5.309 8.523 5.309s-3.564-9.142-5.969-12.659c-2.406-3.517-9.244-9.526-9.244-9.526Z",
    fill: "url(#fS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.953 188.496s1.28 10.78 6.69 16.877c6.144 6.899 8.523 5.309 8.523 5.309s-3.564-9.15-5.969-12.66c-2.406-3.51-9.244-9.526-9.244-9.526Z",
    fill: "url(#fT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.469 189.762s1.273 10.779 6.683 16.876c6.144 6.899 8.523 5.309 8.523 5.309s-3.564-9.149-5.97-12.666c-2.405-3.516-9.236-9.519-9.236-9.519Z",
    fill: "url(#fU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.116 191.351s-9.432-5.39-17.564-4.595c-9.196.869-9.318 3.725-9.318 3.725s9.48 2.54 13.737 2.695c4.258.155 13.145-1.825 13.145-1.825Z",
    fill: "url(#fV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.856 171.242s-10.712 1.873-16.486 7.606c-6.549 6.515-4.831 8.799-4.831 8.799s8.941-4.042 12.316-6.656 9.001-9.749 9.001-9.749Z",
    fill: "url(#fW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.059 173.086s-10.712 1.866-16.486 7.606c-6.548 6.515-4.83 8.799-4.83 8.799s8.94-4.042 12.315-6.656 9.001-9.749 9.001-9.749Z",
    fill: "url(#fX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.035 147.346s-10.598-2.432-18.137.613c-8.569 3.463-7.869 6.238-7.869 6.238s9.81-.276 13.933-1.347c4.123-1.071 12.073-5.504 12.073-5.504Z",
    fill: "url(#fY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.266 155.812s7.411 9.433 16.061 12.006c9.809 2.944 11.157.081 11.157.081s-8.644-6.542-12.949-8.455c-4.305-1.914-14.269-3.632-14.269-3.632Z",
    fill: "url(#fZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.336 143.112s11.716 2.621 20.036-.842c9.432-3.908 8.711-6.973 8.711-6.973s-10.833.377-15.387 1.61c-4.555 1.233-13.36 6.205-13.36 6.205Z",
    fill: "url(#ga)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.961 149.842s11.689 2.62 20.029-.822c9.473-3.908 8.712-6.973 8.712-6.973s-10.834.377-15.388 1.61-13.353 6.185-13.353 6.185Z",
    fill: "url(#gb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.46 82.54s-6.825 20.985-3.207 35.127c4.11 16.041 9.183 14.222 9.183 14.222s1.839-19.006.896-26.821c-.944-7.815-6.872-22.529-6.872-22.529Z",
    fill: "url(#gc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.352 83.703s-6.818 20.986-3.2 35.121c4.103 16.048 9.183 14.229 9.183 14.229s1.832-19.006.889-26.821c-.943-7.815-6.872-22.529-6.872-22.529Z",
    fill: "url(#gd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.832 61.883s-2.83 15.616 1.758 23.155l4.581 7.546s-.592-11.803-1.387-18.48-4.952-12.221-4.952-12.221Z",
    fill: "url(#ge)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.285 216.381s8.374 1.617 14.33-2.244c5.956-3.86 8.287-9.998 10.106-12.955 1.819-2.958 7.357-12.269 9.91-14.546 2.554-2.277-4.878 0-9.91 4.319-5.033 4.318-12.477 10.907-16.365 14.094-3.887 3.187-13.137 9.257-8.071 11.332Z",
    fill: "url(#gf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.555 206.568s7.734 3.975 14.896 0c7.161-3.974 11.924-7.599 14.201-13.966 2.278-6.366 6.158-14.997 6.158-14.997s-8.435 2.069-13.885 7.061c-5.45 4.992-21.37 21.902-21.37 21.902Z",
    fill: "url(#gg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.867 200.15s6.246.411 10.854-2.088c4.608-2.5 14.384-9.52 15.974-13.394 1.59-3.874.929-12.517 1.488-15.697.56-3.18-7.168 2.499-12.854 8.637-5.686 6.137-15.462 22.542-15.462 22.542Z",
    fill: "url(#gh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.311 282.552s8.387-1.347 16.95-11.547c8.563-10.2 14.492-13.717 15.684-17.47a33.112 33.112 0 0 1 3.807-7.512s-7.074 6.3-10.274 6.994c-3.2.694-13.845 3.328-17.847 8.01-4.002 4.682-12.086 18.527-8.32 21.525Z",
    fill: "url(#gi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.076 365.231s8.664-1.475 17.833-10.584c9.169-9.108 15.381-12.362 16.749-15.65a30.182 30.182 0 0 1 4.183-6.602s-7.498 5.692-10.779 6.413c-3.281.721-14.337 3.369-18.622 7.573-4.284 4.204-13.13 16.412-9.364 18.85Z",
    fill: "url(#gj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.51 366.011s8.63 1.678 20.427-3.597c11.797-5.275 18.777-6.111 21.216-8.698a30.05 30.05 0 0 1 6.252-4.716s-9.035 2.695-12.383 2.176c-3.349-.519-14.606-1.906-20.097.492-5.491 2.398-18.063 10.732-15.415 14.343Z",
    fill: "url(#gk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.333 367.063s8.759-.741 18.669-9.041c9.91-8.301 16.385-11.016 18.029-14.148a30.049 30.049 0 0 1 4.716-6.226s-7.957 5.04-11.319 5.478c-3.362.438-14.552 2.135-19.153 5.976-4.602 3.84-14.472 15.212-10.942 17.961Z",
    fill: "url(#gl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.662 288.467s7.377-1.294 15.327-8.415c7.95-7.121 13.285-9.722 14.512-12.255a24.517 24.517 0 0 1 3.671-5.113s-6.467 4.487-9.283 5.1c-2.816.613-12.215 2.856-15.934 6.13-3.719 3.275-11.426 12.794-8.293 14.553Z",
    fill: "url(#gm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.167 290.63s7.37-1.294 15.32-8.422 13.293-9.721 14.512-12.248c1-1.857 2.234-3.578 3.672-5.12 0 0-6.468 4.494-9.284 5.107-2.816.613-12.214 2.856-15.933 6.13-3.719 3.275-11.433 12.767-8.287 14.553Z",
    fill: "url(#gn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.301 290.178s6.111 4.325 16.769 4.959c10.658.633 16.257 2.594 18.911 1.684a24.638 24.638 0 0 1 6.225-.99s-7.741-1.435-10.159-3.005c-2.419-1.57-10.632-6.67-15.57-7-4.938-.33-17.112.869-16.176 4.352Z",
    fill: "url(#go)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.062 289.011s3.194 6.738 12.168 12.558c8.974 5.821 12.881 10.254 15.643 10.78a24.574 24.574 0 0 1 5.902 2.196s-6.063-5.059-7.37-7.613c-1.307-2.553-5.976-11.029-10.106-13.75-4.13-2.722-15.32-7.667-16.237-4.171Z",
    fill: "url(#gp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.375 285.366s1.246 7.411 8.314 15.375c7.067 7.963 9.641 13.353 12.127 14.592a24.697 24.697 0 0 1 5.093 3.706s-4.447-6.495-5.04-9.318c-.592-2.823-2.782-12.235-6.063-15.967-3.281-3.732-12.625-11.507-14.431-8.388Z",
    fill: "url(#gq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.812 284.694s1.247 7.411 8.321 15.374c7.074 7.963 9.641 13.326 12.181 14.586a24.598 24.598 0 0 1 5.093 3.712s-4.453-6.495-5.046-9.317c-.593-2.823-2.776-12.235-6.03-15.974-3.254-3.739-12.706-11.507-14.519-8.381Z",
    fill: "url(#gr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.062 278.624s1.247 7.377 8.321 15.374c7.074 7.997 9.641 13.353 12.127 14.593a24.702 24.702 0 0 1 5.093 3.705s-4.453-6.494-5.046-9.317c-.593-2.823-2.776-12.235-6.063-15.967-3.288-3.732-12.646-11.507-14.432-8.388Z",
    fill: "url(#gs)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.625 285.366s1.246 7.411 8.32 15.375c7.074 7.963 9.635 13.353 12.127 14.592a24.703 24.703 0 0 1 5.094 3.706s-4.447-6.495-5.04-9.318c-.593-2.823-2.782-12.235-6.063-15.967-3.281-3.732-12.632-11.507-14.438-8.388Z",
    fill: "url(#gt)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.461 289.221s1.246 7.377 8.32 15.374c7.074 7.997 9.634 13.353 12.127 14.586a24.608 24.608 0 0 1 5.093 3.712s-4.446-6.494-5.039-9.317c-.593-2.823-2.782-12.235-6.063-15.974-3.281-3.739-12.633-11.507-14.438-8.381Z",
    fill: "url(#gu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.204 393.4s7.863 2.621 19.605-1.152c11.743-3.773 18.386-3.793 21-6.023a29.12 29.12 0 0 1 6.468-3.847s-8.812 1.57-11.885.674c-3.072-.896-13.474-3.517-18.864-1.813-5.389 1.705-18.345 8.361-16.324 12.161Z",
    fill: "url(#gv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.843 403.706s8.199 1.226 19.113-4.514 17.456-6.892 19.652-9.54a28.988 28.988 0 0 1 5.713-4.898s-8.408 3.052-11.588 2.728c-3.18-.323-13.844-1.152-18.931 1.462-5.087 2.614-16.573 11.359-13.959 14.762Z",
    fill: "url(#gw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.24 415.475s8.199 1.226 19.113-4.507 17.456-6.899 19.652-9.547a29.02 29.02 0 0 1 5.707-4.898s-8.408 3.059-11.581 2.729c-3.174-.33-13.845-1.152-18.932 1.462-5.086 2.614-16.6 11.359-13.959 14.761Z",
    fill: "url(#gx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.39 473.781s8.59 1.347 20.144-5.687c11.554-7.033 18.44-8.515 20.784-11.715a33.29 33.29 0 0 1 6.064-5.949s-8.88 3.786-12.208 3.442c-3.328-.343-14.525-1.172-19.902 2.022-5.376 3.193-17.604 13.858-14.882 17.887Z",
    fill: "url(#gy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.316 477.006s6.737 5.517 20.212 5.329c13.474-.189 20.211 2.021 23.856.451a33.19 33.19 0 0 1 8.246-2.021s-9.567-1.247-12.268-3.234c-2.702-1.987-11.918-8.374-18.19-8.347-6.273.027-22.139 2.971-21.856 7.822Z",
    fill: "url(#gz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.701 422.24s7.99 2.223 19.538-2.129c11.547-4.353 18.19-4.716 20.676-7.061a29.078 29.078 0 0 1 6.266-4.163s-8.718 2.021-11.831 1.293c-3.112-.728-13.602-2.843-18.965-.876-5.363 1.967-17.88 9.237-15.684 12.936Z",
    fill: "url(#gA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.369 465.889s7.862 2.445 20.292-6.185c12.43-8.63 19.261-10.106 22.158-14.269a44.842 44.842 0 0 1 7.007-7.58s-9.21 4.447-12.302 3.746c-3.092-.7-13.521-2.661-19.288 1.267-5.767 3.928-19.606 17.395-17.867 23.021Z",
    fill: "url(#gB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.912 382.632s7.923 2.438 19.571-1.597c11.649-4.036 18.298-4.204 20.885-6.495a29.208 29.208 0 0 1 6.374-3.988s-8.758 1.765-11.864.97c-3.106-.795-13.515-3.214-18.932-1.395-5.416 1.819-18.136 8.745-16.034 12.505Z",
    fill: "url(#gC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.024 370.068s8.084 1.825 19.403-3.079c11.318-4.905 17.921-5.585 20.306-8.085a28.944 28.944 0 0 1 6.063-4.466s-8.61 2.425-11.756 1.866c-3.147-.559-13.724-2.176-18.986.054-5.261 2.23-17.408 10.119-15.03 13.71Z",
    fill: "url(#gD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.758 321.923s3.166 18.494 12.74 26.033c9.573 7.539 14.471 12.922 19.881 15.266 5.41 2.345-2.91-2.095-4.77-6.959-1.859-4.865-6.185-17.032-10.624-24.328-4.44-7.297-14.734-13.05-17.227-10.012Z",
    fill: "url(#gE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.453 422.969s7.546 17.173 18.662 22.172c11.116 4.999 17.166 9.034 22.98 10.004 5.815.971-3.321-1.347-6.306-5.605-2.984-4.258-10.105-15.024-16.169-21.027-6.063-6.002-17.489-9.095-19.167-5.544Z",
    fill: "url(#gF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67 203.012s-9.466 10.82-4.568 21.02 8.159 21.612 9.109 25.19c.95 3.577 2.23 7.97 2.23 7.97s-.358-13.899 1.118-22.947c1.475-9.048-.505-19.019-2.486-23.708a21.51 21.51 0 0 0-5.403-7.525Z",
    fill: "url(#gG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.898 210.539s-1.348 17.085 3.698 27.481a153.542 153.542 0 0 1 7.822 19.174s2.695-21.155.863-27.09c-1.833-5.936-9.803-17.975-12.383-19.565Z",
    fill: "url(#gH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.576 218.402s-1.967 11.871 3.881 21.411c5.848 9.54 8.084 15.731 11.743 18.83a227.21 227.21 0 0 0 6.649 5.424s-3.827-5.68-4.574-9.803c-.748-4.123-.492-16.257-3.585-21.673-3.092-5.417-11.46-13.953-14.114-14.189Z",
    fill: "url(#gI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.641 224.031s7.997 9.938 10.065 19.228c2.068 9.291 3.369 18.622 5.43 22.469 2.062 3.846 3.679 11.008 3.679 11.008s-7.829-6.65-10.78-15.159c-2.951-8.509-6.245-11.985-6.919-16.701-.674-4.716-1.475-20.845-1.475-20.845Z",
    fill: "url(#gJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.536 225.332s-1.388 12.72 5.201 22.037c6.589 9.318 12.679 22.731 13.387 25.002.707 2.27 3.301-9.318.983-18.635-2.317-9.318-7.013-22.725-10.462-25.231-3.45-2.506-9.109-3.173-9.109-3.173Z",
    fill: "url(#gK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.126 227.832s10.476 4.77 13.427 11.359c2.951 6.589 2.87 13.804 4.507 19.288 1.638 5.484 5.72 16.257 5.949 18.258.229 2.001-6.818-8.334-9.088-11.008-2.27-2.675-8.637-9.432-9.998-13.32-1.361-3.887-6.407-18.668-4.797-24.577Z",
    fill: "url(#gL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.961 230.104s.229 9.176 3.409 15.839c3.18 6.663 7.498 12.895 11.366 17.954 3.867 5.06 7.936 14.613 7.936 14.613s.047-14.229-2.136-21.316c-2.183-7.087-5.39-14.889-8.313-19.174-2.924-4.285-10.894-10.645-12.262-7.916Z",
    fill: "url(#gM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.546 231.463s-3.773 10.557 2.136 23.802c5.908 13.246 17.274 27.306 17.274 27.306s2.27-2.021 0-8.839c-2.271-6.818-2.5-6.063-3.409-9.836-.91-3.773-1.031-10.106-3.018-14.674-1.988-4.568-11.824-25.035-12.983-17.759Z",
    fill: "url(#gN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.863 237.858s-.061 14.033 3.126 19.288c3.186 5.255 1.347 9.244 4.541 14.182 3.193 4.938 12.046 16.297 12.955 17.665.91 1.367 1.59-2.102 0-7.755-1.59-5.652-3.18-4.972-3.638-13.38-.458-8.408-1.624-16.593-5.807-22.044-4.184-5.45-11.359-13.157-11.177-7.956Z",
    fill: "url(#gO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.408 245.854s-1.866 15.448 1.543 24.961c3.409 9.513 21.134 32.46 21.815 35.417.68 2.958 0-6.993-.903-9.183-.903-2.189-5.228-5.814-5.228-9.432 0-3.617.674-16.472-1.59-21.868-2.264-5.397-7.505-16.56-9.546-18.379-2.042-1.819-7.182-5.08-6.091-1.516Z",
    fill: "url(#gP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.911 253.978s2.271 25.184 5.909 30.991c3.638 5.807 17.045 21.808 17.274 24.031.229 2.224 2.499-.269 1.132-5.948-1.368-5.68-6.131-12.754-7.27-18.083-1.138-5.329-.458-16.135-3.409-21.074-2.95-4.938-14.08-14.175-13.636-9.917Z",
    fill: "url(#gQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.454 262.825s-1.408 17.725 5.201 28.633c6.609 10.907 15.024 23.425 16.614 28.296 1.59 4.871 2.27-6.138.909-9.951-1.361-3.813-1.347-17.692-4.999-24.84-3.651-7.148-17.617-27.838-17.725-22.138Z",
    fill: "url(#gR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.337 275.518s-.229 21.438 6.367 32.339c6.595 10.9 12.039 17.846 13.406 21.073 1.368 3.228 2.022-2.903.91-9.155-1.112-6.252-2.729-17.847-5.457-24.665-2.729-6.818-15.226-22.105-15.226-19.592Z",
    fill: "url(#gS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.898 243.881s24.254-14.822 32.447-17.8c8.192-2.978 12.126-5.39 12.126-5.39s-8.165 14.566-16.775 19.646-13.676 6.784-19.147 7.283c-5.471.498-8.651-3.739-8.651-3.739Z",
    fill: "url(#gT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.945 252.889s15.017.903 19.538 1.091c4.521.189 15.334-5.78 20.212-7.983 4.877-2.203 9.715-5.518 12.362-5.963 2.648-.444-13.023-3.53-21.633-1.098-8.61 2.432-28.936 9.587-30.479 13.953Z",
    fill: "url(#gU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.328 281.352s.35 13.851 6.589 23.418c6.239 9.567 8.758 11.453 13.744 22.697 4.985 11.245 4.581 10.416 3.961-3.745-.619-14.162-5.834-26.033-9.371-29.779-3.537-3.746-14.923-12.591-14.923-12.591Z",
    fill: "url(#gV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.839 282.571s-.31 10.78 5.154 24.2c5.464 13.421 6.919 21.741 9.217 24.254 2.297 2.513 4.372 6.737 4.372 6.737s-3.126-10.503-3.126-14.667c0-4.163-.209-18.116-2.695-24.361-2.486-6.245-10.422-20.043-12.922-16.163Z",
    fill: "url(#gW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.202 282.438s10.625-1.988 22.563-10.173c11.938-8.186 19.773-11.38 21.727-14.148 1.954-2.769 5.673-5.707 5.673-5.707s-9.601 5.282-13.67 6.165c-4.069.882-17.658 4.042-23.236 7.815-5.579 3.773-17.369 14.431-13.057 16.048Z",
    fill: "url(#gX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.095 281.535s10.618-2.021 22.563-10.173c11.945-8.152 19.774-11.379 21.727-14.148 1.954-2.769 5.673-5.706 5.673-5.706s-9.6 5.295-13.683 6.164c-4.083.869-17.665 4.043-23.236 7.815-5.572 3.773-17.362 14.425-13.044 16.048Z",
    fill: "url(#gY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.246 285.253s7.552-1.347 15.792-8.226c8.239-6.879 13.737-9.432 15.03-11.837a24.513 24.513 0 0 1 3.841-4.905s-6.684 4.359-9.574 4.986c-2.89.626-12.524 2.917-16.371 6.063-3.847 3.146-11.884 12.282-8.718 13.919Z",
    fill: "url(#gZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.866 323.562s7.546-1.348 15.785-8.226c8.24-6.879 13.738-9.432 15.031-11.838a24.828 24.828 0 0 1 3.84-4.904s-6.683 4.359-9.567 4.985c-2.883.627-12.524 2.911-16.378 6.064-3.853 3.153-11.884 12.282-8.711 13.919Z",
    fill: "url(#ha)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.684 317.08s8.173-1.381 16.769-10.227c8.597-8.846 14.458-11.972 15.725-15.165a29.182 29.182 0 0 1 3.9-6.434s-7.04 5.518-10.159 6.198c-3.119.681-13.522 3.2-17.517 7.263-3.995 4.062-12.288 15.947-8.718 18.365Z",
    fill: "url(#hb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.294 309.554s8.172-1.347 16.769-10.22c8.596-8.873 14.457-11.972 15.724-15.172a29.207 29.207 0 0 1 3.901-6.428s-7.04 5.518-10.16 6.192c-3.119.674-13.521 3.207-17.516 7.269-3.996 4.063-12.289 15.947-8.718 18.359Z",
    fill: "url(#hc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.635 297.804s8.172-1.381 16.776-10.22c8.603-8.839 14.451-11.972 15.717-15.172a28.954 28.954 0 0 1 3.908-6.428s-7.047 5.511-10.166 6.192c-3.12.68-13.522 3.2-17.517 7.262-3.995 4.063-12.282 15.947-8.718 18.366Z",
    fill: "url(#hd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.536 289.674s8.286.283 18.48-6.649c10.193-6.933 16.566-8.833 18.446-11.709a29.096 29.096 0 0 1 5.12-5.511s-8.01 3.988-11.204 4.042c-3.193.054-13.885.424-18.641 3.598-4.757 3.173-15.213 13.144-12.201 16.229Z",
    fill: "url(#he)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.289 261.518s7.634.673 17.396-3.794c9.762-4.466 15.731-5.484 17.611-7.471a24.83 24.83 0 0 1 4.992-3.726s-7.593 2.453-10.544 2.298c-2.951-.155-12.848-.479-17.395 1.563-4.548 2.041-14.694 8.738-12.06 11.13Z",
    fill: "url(#hf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.334 277.689s7.64.674 17.395-3.793c9.756-4.466 15.732-5.484 17.611-7.478a24.635 24.635 0 0 1 4.999-3.719s-7.593 2.453-10.543 2.298c-2.951-.155-12.855-.479-17.396 1.556-4.541 2.034-14.694 8.738-12.066 11.136Z",
    fill: "url(#hg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.247 281.353s-1.246 14.721 3.369 25.42c4.615 10.698 10.826 24.651 11.453 27.359.626 2.709 2.082-2.082 1.246-8.758-.835-6.677-2.29-12.235-1.873-18.615.418-6.38-.417-12.127-4.581-17.483-4.164-5.356-8.361-11.588-9.614-7.923Z",
    fill: "url(#hh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.528 283.466s-1.246 14.728 3.369 25.426c4.615 10.699 10.826 24.652 11.453 27.353.627 2.702 2.082-2.081 1.246-8.758-.835-6.676-2.29-12.235-1.873-18.608.418-6.373-.417-12.127-4.581-17.517-4.163-5.389-8.388-11.534-9.614-7.896Z",
    fill: "url(#hi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.062 303.203s1.739 18.682 10.706 26.948c8.967 8.267 13.42 13.973 18.655 16.729 5.235 2.755-2.735-2.311-4.224-7.31-1.489-4.999-4.864-17.456-8.758-25.069-3.895-7.613-13.663-14.141-16.379-11.298Z",
    fill: "url(#hj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.969 310.504s1.738 18.682 10.712 26.948c8.974 8.267 13.434 13.987 18.648 16.749 5.215 2.762-2.735-2.318-4.217-7.31-1.482-4.992-4.864-17.456-8.758-25.069-3.895-7.613-13.663-14.155-16.385-11.318Z",
    fill: "url(#hk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.602 315.874s1.738 18.682 10.712 26.949c8.974 8.266 13.434 13.993 18.648 16.755 5.215 2.762-2.735-2.317-4.224-7.31-1.489-4.992-4.864-17.456-8.758-25.069-3.894-7.613-13.663-14.161-16.378-11.325Z",
    fill: "url(#hl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.344 321.923s3.166 18.494 12.746 26.033c9.581 7.539 14.472 12.922 19.875 15.266 5.403 2.345-2.904-2.095-4.763-6.959-1.86-4.865-6.192-17.032-10.631-24.328-4.44-7.297-14.721-13.05-17.227-10.012Z",
    fill: "url(#hm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.789 327.003s13.771 12.74 25.958 12.881c12.188.142 19.343 1.435 25.069 0 5.727-1.435-3.584.108-8.024-2.621-4.439-2.728-15.279-9.741-23.243-12.8-7.963-3.059-19.639-1.388-19.76 2.54Z",
    fill: "url(#hn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.969 323.939s5.059 18.069 15.367 24.57c10.308 6.501 15.725 11.352 21.35 13.131 5.626 1.778-3.106-1.786-5.464-6.434-2.358-4.649-7.916-16.297-13.09-23.095-5.174-6.798-16.001-11.453-18.163-8.172Z",
    fill: "url(#ho)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.002 288.526s-4.642 16.243 3.267 26.45a148.209 148.209 0 0 1 13.542 20.212c2.082 3.719 0-3.982 0-11.689 0-7.708-1.88-18.116-4.999-22.907-3.119-4.79-11.339-14.107-11.81-12.066Z",
    fill: "url(#hp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.767 295.818s-1.044 14.99 7.498 26.443c8.543 11.453 15.617 17.705 17.517 22.078 1.9 4.372-.829-16.661-2.082-19.996a67.095 67.095 0 0 0-10.106-17.571c-5.329-6.373-12.814-14.074-12.827-10.954Z",
    fill: "url(#hq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.656 195.769a8.424 8.424 0 0 1 8.9 1.266c4.379 3.591 11.271 11.359 17.301 13.475 6.03 2.115 24.981 11.756 33.362 13.474s32.339 8.516 43.691 7.519c11.352-.997 23.182-2.21 38.624 4.581 15.442 6.791 33.996 15.125 40.382 17.847 6.387 2.721 25.939 5.308 34.117 13.285 8.179 7.977 10.571 14.297 22.145 14.627 11.575.33 24.739-.135 35.707 0 10.968.134 26.376 4.574 35.707 6.346 9.331 1.772 23.742 6.562 32.521 11.75 8.778 5.187 22.549 7.714 28.531 9.843 5.983 2.129 18.352 8.468 24.342 10.186 5.989 1.718 17.954.418 22.744.97 4.791.553 31.806 4.925 31.806 4.925v-2.169s-25.547-5.114-37.606-5.114c-12.06 0-17.712-.296-23.958-3.368-6.245-3.072-16.122-6.394-24.105-9.432-7.984-3.039-25.999-10.605-29.192-12.053-3.194-1.448-19.316-7.411-26.14-9.008-6.825-1.596-16.675-4.635-22.651-4.527-5.976.108-43.07-.633-46.661-1.307-3.591-.674-7.101.222-12.868-6.063-5.767-6.286-13.677-12.754-25.022-15.61-11.345-2.857-46.062-17.045-49.471-19.269-3.409-2.223-17.517-9.27-32.54-10.179-15.024-.91-23.924 1.589-31.941 0-8.017-1.59-24.22-6.064-30.533-8.59-6.313-2.527-27.979-10.241-32.756-13.818-4.777-3.578-7.256-7.169-10.78-10.066l-3.537-2.903-10.119 3.382Z",
    fill: "url(#hr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.125 46.527s-2.837 15.617 1.751 23.163l4.588 7.539s-.599-11.804-1.387-18.48c-.789-6.677-4.952-12.222-4.952-12.222Z",
    fill: "url(#hs)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.746 51.043s-2.83 15.617 1.758 23.156l4.582 7.545s-.593-11.803-1.382-18.48c-.788-6.676-4.958-12.221-4.958-12.221Z",
    fill: "url(#ht)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.828 54.336s-2.836 15.617 1.752 23.162l4.588 7.54s-.593-11.798-1.388-18.48c-.795-6.684-4.952-12.222-4.952-12.222Z",
    fill: "url(#hu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.356 69.926s-2.829 15.617 1.752 23.162l4.588 7.539s-.593-11.797-1.388-18.48c-.795-6.683-4.952-12.221-4.952-12.221Z",
    fill: "url(#hv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.336 141.739s16.728-1.105 25.601-6.878c8.873-5.774 24.806-13.185 31.274-17.968 6.468-4.784 17.227-10.032 27.259-11.703 10.031-1.671 36.077-7.646 45.394-9.317 9.318-1.671 31.436-5.956 40.935-9.62 9.5-3.666-5.591 4.142-11.109 5.315-5.518 1.172-30.317 6.454-30.317 6.454s-43.724 8.839-48.737 11.224c-5.012 2.385-21.262 8.846-35.121 17.921-13.858 9.075-23.748 14.572-23.748 14.572h-21.431Z",
    fill: "url(#hw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.555 140.782s.842-13.521 4.325-21.848c3.483-8.327 13.555-20.508 13.555-20.508a50.696 50.696 0 0 0-4.096 12.423c-1.199 6.69-.472 16.486-2.863 20.07-2.392 3.584-10.921 9.863-10.921 9.863Z",
    fill: "url(#hx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.43 131.628a61.339 61.339 0 0 0 2.903-15.448c.64-9.318 10.915-23.176 10.915-23.176s-2.385 8.893-2.385 14.242c0 5.35 1.576 12.754-1.604 15.86-3.18 3.105-9.829 8.522-9.829 8.522Z",
    fill: "url(#hy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.969 124.249a61.286 61.286 0 0 0 2.903-15.448c.64-9.318 10.915-23.176 10.915-23.176s-2.392 8.893-2.392 14.242c0 5.35 1.583 12.761-1.597 15.866-3.18 3.106-9.829 8.516-9.829 8.516Z",
    fill: "url(#hz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.305 104.941s1.179 20.832 13.615 26.552l12.424 5.692s-7.303-14.451-11.426-19.537c-4.124-5.087-14.613-12.707-14.613-12.707Z",
    fill: "url(#hA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.242 99.414s1.024 16.749 11.864 21.323l10.867 4.575s-6.36-11.575-9.95-15.684c-3.591-4.11-12.781-10.214-12.781-10.214Z",
    fill: "url(#hB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.422 100.562s1.024 16.749 11.857 21.324l10.84 4.574s-6.36-11.574-9.95-15.684c-3.591-4.11-12.747-10.214-12.747-10.214Z",
    fill: "url(#hC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.375 103.574s1.031 16.756 11.864 21.323l10.833 4.575s-6.353-11.575-9.95-15.678c-3.598-4.102-12.747-10.22-12.747-10.22Z",
    fill: "url(#hD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.172 67.664s-14.99 7.532-14.93 19.295l.061 11.763s8.138-10.402 10.496-15.32c2.358-4.918 4.373-15.738 4.373-15.738Z",
    fill: "url(#hE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.852 64.883s-14.991 7.539-14.93 19.302l.061 11.763s8.138-10.41 10.496-15.327c2.358-4.918 4.373-15.738 4.373-15.738Z",
    fill: "url(#hF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.969 71.102s-14.997 7.538-14.93 19.295l.061 11.763s8.132-10.402 10.496-15.32c2.365-4.919 4.373-15.738 4.373-15.738Z",
    fill: "url(#hG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.586 97.394s1.031 16.749 11.864 21.324l10.833 4.574s-6.359-11.574-9.95-15.684c-3.591-4.11-12.747-10.214-12.747-10.214Z",
    fill: "url(#hH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.961 92.887s2.297 16.62 13.474 20.359l11.117 3.74s-7.216-11.056-11.11-14.876c-3.894-3.82-13.481-9.223-13.481-9.223Z",
    fill: "url(#hI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.828 91.344s2.911 16.526 14.195 19.847l11.278 3.322s-7.626-10.78-11.655-14.458c-4.029-3.679-13.818-8.711-13.818-8.711Z",
    fill: "url(#hJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.453 90.349s15.112 7.29 24.395.067l9.284-7.222s-13.205-.101-18.54 1.024c-5.336 1.125-15.139 6.13-15.139 6.13Z",
    fill: "url(#hK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.477 107.184s1.179 20.831 13.602 26.524l12.423 5.686s-7.289-14.397-11.413-19.538c-4.123-5.14-14.612-12.672-14.612-12.672Z",
    fill: "url(#hL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.318 113.543s-2.189 12.942 5.693 20.111c7.883 7.168 17.921 8.36 20.313 11.23 2.391 2.87-3.584-10.779-6.454-15.67-2.87-4.891-14.741-16.425-19.552-15.671Z",
    fill: "url(#hM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.664 112.195a61.234 61.234 0 0 0 2.904-15.441c.673-9.318 10.914-23.176 10.914-23.176s-2.385 8.893-2.385 14.242c0 5.35 1.577 12.754-1.603 15.86-3.18 3.106-9.83 8.515-9.83 8.515Z",
    fill: "url(#hN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.425 106.819s11.103-11.352 11.527-20.164l.431-8.82s-6.124 10.107-9.209 16.083c-3.086 5.975-2.749 12.901-2.749 12.901Z",
    fill: "url(#hO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.273 86.549s3.315-14.075 11.865-18.865c8.549-4.79 17.125-7.114 27.319-8.677 10.193-1.563-5.518 2.082-10.268 7.997-4.749 5.915-5.019 12.053-10.382 14.559-5.362 2.506-18.534 4.986-18.534 4.986Z",
    fill: "url(#hP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.844 38.675s2.108-10.78 7.545-14.464c5.437-3.685 10.888-5.464 17.369-6.663 6.481-1.2-3.51 1.596-6.529 6.137a39.799 39.799 0 0 1-11.803 10.968c-3.409 1.92-6.582 4.022-6.582 4.022Z",
    fill: "url(#hQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.383 39.98s2.109-10.78 7.545-14.471c5.437-3.692 10.888-5.457 17.369-6.657 6.481-1.199-3.51 1.597-6.529 6.138a39.898 39.898 0 0 1-11.803 10.968c-3.409 1.92-6.582 4.022-6.582 4.022Z",
    fill: "url(#hR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.891 39.949s2.102-10.78 7.539-14.465c5.436-3.685 10.893-5.464 17.368-6.663 6.474-1.2-3.51 1.597-6.528 6.138a39.813 39.813 0 0 1-11.804 10.968c-3.409 1.92-6.575 4.022-6.575 4.022Z",
    fill: "url(#hS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.143 3.02s-6.259 9.048-12.707 10.233c-6.447 1.186-12.167.674-18.581-.855-6.413-1.53 3.854-.054 8.435-3.005a39.805 39.805 0 0 1 15.213-5.322c3.894-.398 7.64-1.051 7.64-1.051Z",
    fill: "url(#hT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.75-13.531s10.638-2.816 16.311.478c5.672 3.295 9.661 7.41 13.562 12.727 3.9 5.315-2.965-2.46-8.368-3.2a39.746 39.746 0 0 1-15.017-5.842c-3.214-2.23-6.488-4.163-6.488-4.163Z",
    fill: "url(#hU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.148-14.879s10.423 3.537 13.327 9.432c2.903 5.895 3.954 11.52 4.278 18.103.323 6.582-1.112-3.692-5.208-7.29a39.756 39.756 0 0 1-9.291-13.164c-1.448-3.658-3.106-7.08-3.106-7.08Z",
    fill: "url(#hV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.688 15.086s9.768-5.073 16.02-3.099c6.253 1.974 11.049 5.134 16.021 9.432 4.972 4.299-3.436-1.758-8.866-1.293a39.883 39.883 0 0 1-15.933-2.419c-3.625-1.421-7.242-2.62-7.242-2.62Z",
    fill: "url(#hW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.141 43.236s4.918-9.836 11.143-11.911c6.225-2.075 11.952-2.345 18.514-1.765 6.562.579-3.807.6-7.93 4.163a39.842 39.842 0 0 1-14.317 7.411c-3.793.916-7.41 2.102-7.41 2.102Z",
    fill: "url(#hX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 219.56s6.636-13.629 14.822-16.607c8.185-2.978 9.29-3.726 17.86-3.059 8.569.667 1.401 1.159-4.043 6.144-5.443 4.986-13.885 9.109-18.864 10.47-4.978 1.361-9.775 3.052-9.775 3.052Z",
    fill: "url(#hY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.734 227.228s6.643-13.629 14.822-16.607c8.179-2.978 9.291-3.726 17.86-3.059 8.57.667 1.402 1.159-4.042 6.144-5.444 4.986-13.879 9.109-18.864 10.47-4.986 1.361-9.776 3.052-9.776 3.052Z",
    fill: "url(#hZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.93 237.048s4.716-18.433 13.656-24.133c8.94-5.699 10.106-6.905 20.38-8.212 10.274-1.307 1.92 1.078-3.369 8.576-5.288 7.499-14.283 14.667-19.854 17.591-5.572 2.924-10.813 6.178-10.813 6.178Z",
    fill: "url(#ia)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.092 259.496s-11.837-9.472-12.949-18.102c-1.112-8.631-1.59-9.884.943-18.096 2.533-8.213 1.435-1.112 5.1 5.315 3.665 6.427 5.835 15.543 6.064 20.71.229 5.168.842 10.173.842 10.173Z",
    fill: "url(#ib)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.564 74.799s-9.722-5.154-11.656-11.42c-1.933-6.265-2.021-12.012-1.347-18.554.674-6.542 2.654 2.567 8.084 6.219 4.521 3.045 2.129 12.47 2.978 16.29.849 3.82 1.941 7.465 1.941 7.465Z",
    fill: "url(#ic)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.917 83.8s-9.722-5.155-11.649-11.454c-1.927-6.3-2.061-12.006-1.347-18.554.714-6.549 2.654 2.573 8.084 6.218 4.521 3.046 2.129 12.47 2.978 16.29.849 3.82 1.934 7.5 1.934 7.5Z",
    fill: "url(#id)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.878 72.529s-10.106 4.278-16.21 1.819c-6.104-2.46-10.611-5.983-15.226-10.692-4.615-4.71 3.672-.431 9.917-2.324 5.215-1.584 11.015 6.225 14.512 7.983a120.593 120.593 0 0 0 7.007 3.214Z",
    fill: "url(#ie)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.495 70.95s-9.722-5.154-11.649-11.42c-1.926-6.265-2.061-12.005-1.347-18.553.714-6.549 2.654 2.566 8.085 6.218 4.52 3.045 2.129 12.47 2.977 16.29a124.51 124.51 0 0 0 1.934 7.465Z",
    fill: "url(#if)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.245 72.799s-9.722-5.154-11.649-11.42c-1.926-6.265-2.061-12.012-1.347-18.554.714-6.542 2.654 2.567 8.085 6.219 4.52 3.045 2.129 12.47 2.977 16.29.849 3.82 1.934 7.465 1.934 7.465Z",
    fill: "url(#ig)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.555 49.298s5.672-9.432 12.032-11.015c6.36-1.583 12.127-1.408 18.602-.316 6.474 1.09-3.847.303-8.233 3.537a39.89 39.89 0 0 1-14.822 6.272c-3.887.646-7.579 1.522-7.579 1.522Z",
    fill: "url(#ih)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.906 89.276s7.613-10.927 17.382-12.025c9.769-1.099 18.797-.088 29.145 2.155 10.348 2.244-5.989-.155-12.437 3.261-6.447 3.416-16.465 5.49-22.434 5.754a221.93 221.93 0 0 0-11.656.855Z",
    fill: "url(#ii)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.844 83.044s7.411-12.7 15.495-14.99c8.085-2.291 15.3-2.224 23.466-.964 8.165 1.26-4.858.512-10.483 4.938-5.626 4.427-14.014 7.802-18.905 8.759-4.891.956-9.573 2.257-9.573 2.257Z",
    fill: "url(#ij)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.281 84.689s3.962-14.148 11.177-18.44c7.216-4.292 14.236-6.03 22.448-6.885 8.213-.856-4.561 1.724-8.879 7.41-4.319 5.687-11.575 11.11-16.055 13.28-4.48 2.169-8.691 4.635-8.691 4.635Z",
    fill: "url(#ik)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.688 238.011s4.486-15.846 12.713-20.602c8.226-4.757 16.229-6.737 25.601-7.667 9.371-.93-5.208 1.927-10.106 8.307-4.898 6.38-13.178 12.403-18.291 14.822-5.114 2.418-9.917 5.14-9.917 5.14Z",
    fill: "url(#il)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.383 282.593s4.487-15.846 12.713-20.603c8.226-4.756 16.23-6.737 25.601-7.66 9.371-.923-5.208 1.92-10.106 8.3-4.898 6.38-13.178 12.41-18.284 14.822-5.107 2.412-9.924 5.141-9.924 5.141Z",
    fill: "url(#im)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.344 242.047s2.162-14.148 10.395-18.897c8.233-4.75 14.822-4.656 21.317-13.576 5.531-7.626 1.394 6.131-3.524 12.511-4.918 6.38-13.171 12.41-18.285 14.822-5.113 2.412-9.903 5.14-9.903 5.14Z",
    fill: "url(#in)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.016 241.308s10.146-10.106 19.591-9.015c9.446 1.092 14.701 5.087 25.211 1.766 8.98-2.844-2.527 5.76-10.268 7.963-7.741 2.203-17.974 2.142-23.519 1.044-5.545-1.098-11.015-1.758-11.015-1.758Z",
    fill: "url(#io)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.156 93.609s11.797-.721 21.559-1.82c9.762-1.097 22.145 8.126 32.493 10.376 10.349 2.25-9.391-3.416-15.839 0-6.447 3.416-16.411.532-22.38.795-5.97.263-15.833-9.351-15.833-9.351Z",
    fill: "url(#ip)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.164 57.383s5.154-8.01 11.325-9.123c6.171-1.111 11.817-.673 18.244.546 6.428 1.22-3.759.095-7.922 2.735-4.164 2.641-10.537 4.447-14.297 4.838-3.759.39-7.35 1.004-7.35 1.004Z",
    fill: "url(#iq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.417 93.61a53.596 53.596 0 0 0-20.933-8.92c-12.228-2.237-41.42-2.972-55.312 3.2-13.892 6.17-15.367 9.917-15.367 9.917h2.358s13.42-11.454 29.764-12.289c16.345-.835 29.226-.856 38.139 1.064 8.914 1.92 21.351 7.027 21.351 7.027Z",
    fill: "url(#ir)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.617 165.887s30.425-22.267 48.508-23.425c18.082-1.159 46.217-2.608 52.435-3.692 6.218-1.085 39.123-11.588 50.919-15.577 11.797-3.988 39.952-8.684 54.295-7.599 14.344 1.084 30.843 2.257 38.26 1.684 8.86-.674 27.879-12.908 66.624-7.478 38.746 5.43 50.333 12.672 53.594 15.206 3.261 2.533 13.475 8.333 20.885 9.849 4.326.876 22.907 8.375 28.701 13.811 5.794 5.437 15.205 14.25 18.601 16.587a73.669 73.669 0 0 0 10.106 5.457s-8.085-2.23-13.225-7.04c-5.141-4.81-12.37-10.308-15.981-13.232-3.611-2.924-13.568-9.297-17.867-10.921-4.298-1.623-15.738-3.51-21.943-6.77-6.205-3.261-16.843-9.432-20.959-11.339s-26.45-7.04-36.381-7.411c-9.93-.371-32.459-1.61-41.575.168-9.708 1.894-22.333 9.278-33.584 9.79-11.251.512-25.77-.856-25.77-.856s-32.81.168-42.606 4.467c-9.796 4.298-44.849 15.313-52.064 17.402-7.216 2.088-29.893 7.411-47.76 7.411-17.867 0-40.423 8.246-50.367 15.461-9.944 7.216-20.825 21.074-20.825 21.074l-2.02-23.027Z",
    fill: "url(#is)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6 111.859s-1.826 18.898 4.123 30.318c6.737 12.969 10.834 10.617 10.834 10.617s-2.143-16.425-4.508-22.906c-2.364-6.481-10.449-18.029-10.449-18.029Z",
    fill: "url(#it)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.982 126.457s-3.106 19.538 1.125 30.836c4.81 12.801 8.536 10.052 8.536 10.052s-.532-16.715-2.062-23.189c-1.529-6.475-7.599-17.699-7.599-17.699Z",
    fill: "url(#iu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.552 134.605s-3.106 19.572 1.125 30.843c4.81 12.801 8.536 10.045 8.536 10.045s-.532-16.708-2.061-23.189c-1.53-6.481-7.6-17.699-7.6-17.699Z",
    fill: "url(#iv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.277 152.977s-3.106 19.571 1.132 30.842c4.804 12.801 8.529 10.045 8.529 10.045s-.532-16.708-2.061-23.189c-1.53-6.481-7.6-17.698-7.6-17.698Z",
    fill: "url(#iw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.638 139.616s-20.886-7.074-35.081-3.625c-16.095 3.921-14.336 9.014-14.336 9.014s18.978 2.062 26.807 1.213c7.828-.849 22.61-6.602 22.61-6.602Z",
    fill: "url(#ix)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.922 166.585s19.625 10.106 34.157 8.792c16.5-1.489 15.496-6.784 15.496-6.784s-18.467-4.858-26.329-5.181c-7.862-.324-23.324 3.173-23.324 3.173Z",
    fill: "url(#iy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.985 126.656s-21.559-4.878-35.269 0c-15.603 5.552-13.326 10.443-13.326 10.443s19.086.094 26.787-1.557c7.7-1.65 21.808-8.886 21.808-8.886Z",
    fill: "url(#iz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.202 115.457s-21.558-4.878-35.275 0c-15.604 5.558-13.326 10.443-13.326 10.443s19.093.094 26.793-1.557c7.701-1.65 21.808-8.886 21.808-8.886Z",
    fill: "url(#iA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.379 113.578s-3.106 19.538 1.132 30.836c4.803 12.801 8.529 10.045 8.529 10.045s-.532-16.708-2.062-23.182c-1.529-6.475-7.599-17.699-7.599-17.699Z",
    fill: "url(#iB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.977 116.554s7.821-16.081 17.449-19.605c9.627-3.523 18.473-4.096 28.559-3.321 10.085.774-5.875 1.064-12.316 6.952-6.441 5.889-16.351 10.78-22.233 12.37-5.881 1.59-11.459 3.604-11.459 3.604Z",
    fill: "url(#iC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.336 121.191s6.643-13.623 14.822-16.607c8.179-2.985 15.684-3.463 24.253-2.796 8.57.667-4.992.896-10.456 5.881-5.463 4.986-13.878 9.109-18.864 10.477-4.985 1.367-9.755 3.045-9.755 3.045Z",
    fill: "url(#iD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.156 152.081s12.087-7.977 19.989-6.656c7.903 1.32 14.007 4.352 20.367 8.799 6.36 4.446-4.359-1.55-11.15 0-6.791 1.549-15.496 1.03-20.05-.142s-9.156-2.001-9.156-2.001Z",
    fill: "url(#iE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.323 196.254s-14.397-1.563-19.639-7.62c-5.241-6.057-8.01-12.295-10.065-19.773-2.055-7.479 2.365 3.975 8.576 7.128 6.212 3.153 12.558 9.068 15.341 12.901 2.782 3.834 5.787 7.364 5.787 7.364Z",
    fill: "url(#iF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.539 111.678s7.829-16.081 17.456-19.605c9.627-3.524 18.467-4.103 28.559-3.322 10.092.782-5.875 1.065-12.316 6.947-6.44 5.881-16.351 10.779-22.232 12.369-5.882 1.59-11.467 3.611-11.467 3.611Z",
    fill: "url(#iG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.918 156.661s10.557 10.631 20.683 14.579c10.126 3.948 24.82 12.861 31.058 18.682 6.239 5.821 22.011 22.448 30.546 28.572 8.536 6.124 17.221 13.05 27.407 15.691 6.919 1.799 22.408 4.561 36.159 6.064 5.707.695 11.45 1.061 17.2 1.098 14.437-.196.673-1.179.673-1.179s-13.205-.148-20.103-1.206c-6.899-1.058-28.91-4.285-33.895-6.259-4.986-1.974-17.288-10.618-20.804-13.164-3.517-2.547-31.079-28.66-35.802-31.914-4.722-3.254 9.507 2.082 18.784 1.846 9.277-.236 30.317.431 30.317.431a118.676 118.676 0 0 0-18.858-1.819c-9.472-.074-14.1.209-17.328-.411-3.227-.62-16.344-2.419-25.042-8.199-8.697-5.781-14.943-8.401-22.232-13.077-7.29-4.676-11.083-6.481-15.859-11.197-4.777-4.716-33.902-41.771-36.866-43.313-2.964-1.543-6.737-.506-6.737-.506s12.625 11.642 20.076 21.761c7.452 10.12 20.623 23.52 20.623 23.52Z",
    fill: "url(#iH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.993 549.93s25.251-44.148 84.821-65.04c59.57-20.892 106.447-8.011 130.701-4.002 24.254 4.008 53.223 13.023 96.9-4.043 43.677-17.065 120.043-44.283 144.526-54.658 24.483-10.375 58.613-31.079 67.654-34.023 9.041-2.944 39.466-3.516 39.466-3.516l-2.95-5.444s-41.265-2.331-48.845 4.217c-7.579 6.549-44.647 22.233-71.683 29.806-27.036 7.572-57.131 14.7-77.686 26.564-20.555 11.864-65.303 25.19-82.092 26.585-16.789 1.395-63.195-5.693-88.176-10.443-24.982-4.749-73.152-10.691-127.4 8.422-54.248 19.113-66.698 40.968-66.698 40.968l1.462 44.607Z",
    fill: "url(#iI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.208 379.034s-3.827 18.366 2.324 28.889c6.151 10.524 8.758 17.321 12.908 21.485 4.15 4.164-1.933-3.012-1.886-8.226.047-5.215.478-18.116-.984-26.524-1.462-8.408-8.933-17.537-12.362-15.624Z",
    fill: "url(#iJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.192 450.46s-8.812 16.809-2.54 29.098c6.272 12.288 8.428 19.78 13.265 25.224 4.838 5.443-2.021-3.578-.936-8.678 1.085-5.1 4.217-17.631 3.894-26.355-.323-8.725-8.651-20.07-13.683-19.289Z",
    fill: "url(#iK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.513 464.737s-3.288 18.689 6.42 28.492c9.708 9.802 14.054 16.29 20.313 19.989 6.259 3.698-3.025-2.789-3.537-7.977-.512-5.188-1.348-18.083-4.299-26.275-2.95-8.192-14.363-16.506-18.897-14.229Z",
    fill: "url(#iL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.362 466.941s-3.281 18.682 6.427 28.491c9.708 9.81 14.047 16.291 20.306 19.989 6.259 3.699-3.025-2.789-3.53-7.983-.506-5.194-1.348-18.076-4.305-26.275-2.958-8.199-14.344-16.499-18.898-14.222Z",
    fill: "url(#iM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.645 475.085s-3.288 18.682 6.427 28.491c9.715 9.809 14.047 16.29 20.306 19.989 6.259 3.699-3.025-2.789-3.53-7.977-.506-5.187-1.348-18.082-4.305-26.275-2.958-8.192-14.344-16.519-18.898-14.228Z",
    fill: "url(#iN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.432 439.755s-3.281 18.689 6.427 28.498c9.709 9.81 14.047 16.291 20.306 19.989 6.259 3.699-3.025-2.795-3.53-7.983-.505-5.188-1.348-18.076-4.298-26.275-2.951-8.199-14.344-16.499-18.905-14.229Z",
    fill: "url(#iO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.04 370.841s-3.82 18.365 2.331 28.882c6.151 10.517 8.758 17.321 12.908 21.491 4.15 4.171-1.94-3.018-1.886-8.226.053-5.207.478-18.116-.984-26.531-1.462-8.414-8.967-17.536-12.369-15.616Z",
    fill: "url(#iP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.786 394.167s-3.827 18.372 2.324 28.889 8.758 17.321 12.908 21.492c4.15 4.17-1.933-3.019-1.886-8.226.047-5.208.478-18.117-.984-26.531-1.462-8.415-8.933-17.537-12.362-15.624Z",
    fill: "url(#iQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.129 403.989s-3.826 18.366 2.325 28.882c6.151 10.517 8.758 17.322 12.908 21.492 4.15 4.17-1.933-3.018-1.886-8.226.047-5.208.478-18.116-.984-26.531s-8.933-17.537-12.363-15.617Z",
    fill: "url(#iR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.152 412.735s-3.827 18.366 2.331 28.882c6.157 10.517 8.758 17.322 12.908 21.492 4.15 4.17-1.94-3.018-1.893-8.226.047-5.208.478-18.116-.984-26.531s-8.933-17.537-12.362-15.617Z",
    fill: "url(#iS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.122 417.058s-3.827 18.366 2.324 28.889c6.151 10.524 8.758 17.322 12.908 21.485 4.15 4.164-1.933-3.011-1.886-8.226.047-5.214.478-18.109-.984-26.524s-8.933-17.557-12.362-15.624Z",
    fill: "url(#iT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.989 423.062s-3.827 18.372 2.324 28.889c6.151 10.516 8.758 17.321 12.915 21.491 4.157 4.17-1.94-3.018-1.893-8.226.047-5.208.478-18.116-.984-26.531s-8.953-17.537-12.362-15.623Z",
    fill: "url(#iU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.322 404.719s-49.377 61.16-61.389 83.615c-12.012 22.454-15.01 39.836-6.4 60.701 8.61 20.865 9.58 29.853 19.942 30.223 10.361.371.053-8.603-8.085-21.7-8.138-13.097-10.813-23.951-7.411-36.3 3.402-12.349 12.127-34.723 27.589-53.466 15.462-18.743 37.634-39.702 37.634-39.702l-1.88-23.371Z",
    fill: "url(#iV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.586 369.557s-45.139 13.73-46.937 36.057c-1.799 22.327-5.922 47.646-2.055 50.475 3.867 2.83 8.32 2.318 8.495 6.178l.175 3.867s18.817 2.102 27.899 0 23.695-5.908 23.695-5.908-18.292-5.424-24.214-5.68c-5.922-.256 2.062-16.741 6.953-18.284 4.891-1.543 30.748-5.026 30.748-5.026s19.215-4.858 30.803-12.922c11.588-8.064 12.874-6.003 12.874-6.003s23.237 15.549 23.756 15.368c.518-.182 25.176-5.471 25.176-5.471l-11.338-2.695-13.838-13.649s3.301-22.705-10.106-33.241c-13.407-10.537-47.706-14.896-64.913-8.981l-17.173 5.915Z",
    fill: "url(#iW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.728 395.683s-1.772 17.921 5.329 27.622c7.101 9.702 7.862 13.232 7.862 13.232s9.358 4.123 10.907 9.863l1.543 5.74 18.393-7.256s-6.495-.256-8.274-7.613c-1.778-7.357-.249-24.092-.249-24.092l-2.021-25.601",
    fill: "url(#iX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.731 360.681s5.066-19.012 19.733-19.733c14.667-.721 22.314 13.744 21.903 18.082a31.74 31.74 0 0 1-2.069 8.26l2.897 6.832s-6.198 12.497-14.875 13.474c-8.678.977-24.173-2.695-26.242-11.723-2.068-9.028-1.347-15.192-1.347-15.192Z",
    fill: "url(#iY)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.154 354.964s-9.297-2.89-9.499 2.507c-.203 5.396 4.716 6.865 4.716 6.865l3.718.869 1.065-10.241Z",
    fill: "url(#iZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.162 359.698s11.157-5.154 7.647-10.105c-3.51-4.952-9.911 2.257-9.911 2.257l2.264 7.848Z",
    fill: "url(#ja)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.633 364.282s4.136-8.671 9.088-6.192c4.952 2.48 6.273 6.192 6.273 6.192l-4.285 8.084s-3.059 3.753-6.34 1.462c-3.281-2.29-4.736-9.546-4.736-9.546Z",
    fill: "url(#jb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.164 365.899s2.062-12.363 8.469-8.86c6.407 3.504 5.389 4.325 6.407 6.805 1.017 2.479-3.308 8.879-3.308 8.879l-6.198-2.607-5.37-4.217Z",
    fill: "url(#jc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.364 364.78s-2.236-1.024-3.294 1.758c-1.058 2.783-2.695 7.768-2.695 7.768s.552 6.65 1.347 8.011c.795 1.361-.128-8.044 3.201-8.86 3.328-.815 6.501-.815 7.41.674.91 1.489 1.584 6.448 1.584 6.448s.384-7.661 0-9.628c-.384-1.967-4.157-6.265-4.912-6.38-.885-.024-1.77.046-2.641.209Z",
    fill: "#758063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.26 374.32s5.14-1.819 6.501 0c1.361 1.819-1.812 4.46-1.812 4.46h-3.78s-3.698-3.773-.909-4.46Z",
    fill: "#2E2624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.336 437.144s12.726-2.075 18.702 0c5.976 2.075 20.313 2.021 30.466 3.524 10.153 1.502 21.121 4.527 35.646 9.007 14.525 4.48 24.685 11.144 35.141 14.681 10.456 3.537 36.616 2.694 36.616 2.694s30.587-3.57 37.728 1.611c7.142 5.18 23.581 7.572 23.581 7.572s-15.934-4.339-20.367-9.183c-4.433-4.844-26.349-2.694-26.349-2.694s-28.592-.944-37.836-1.84c-9.243-.896-15.206-5.389-34.918-13.144-19.713-7.754-47.726-13.151-47.726-13.151l-26.572-2.284-6.912-3.281-17.2 6.488Z",
    fill: "url(#jd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-16.89 829.792.276 71.38h32.917l105.161-121.303v-17.9l-138.355 67.823Z",
    fill: "url(#je)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.413 832.191-37.304 69.817 47.558-2.237 95.742-120.736v-17.894l-105.996 71.05Z",
    fill: "url(#jf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.715 761.599s9.924 134.898 8.226 137.161c-1.698 2.264-48.191 1.139-48.191 1.139h-44.688l47.113-162.224 15.624-27.683 24.341 41.184-2.425 10.423Z",
    fill: "url(#jg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.964 778.61s59.354 117.9 57.657 120.15c-1.698 2.251-48.191 1.139-48.191 1.139h-44.688l47.113-162.224 15.624-27.683-27.515 68.618Z",
    fill: "url(#jh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.885 769.084s-36.731 123.175-38.402 125.439a52.906 52.906 0 0 0-3.369 5.389h-61.2l96.24-153.694 9.594-16.257-.438 28.707-2.425 10.416Z",
    fill: "url(#ji)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.994 803.503s43.388 92.38 60.736 96.395h53.897s-46.486-54.571-57.333-83.54c-10.847-28.97-62.191-71.987-62.191-71.987h-27.939l32.83 59.132Z",
    fill: "url(#jj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.754 814.923s57.549 80.961 74.897 84.976h83.265s-49.727-53.331-68.921-83.541c-16.581-26.113-92.798-71.986-92.798-71.986l-22.064-3.692 25.621 74.243Z",
    fill: "url(#jk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.087 730.088-112.8 124.638-43.576 45.32h42.936s88.364-72.242 110.179-98.517c21.815-26.275 50.044-75.624 50.044-75.624l-34.36-15.772-12.423 19.955Z",
    fill: "url(#jl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.578 752.211s34.232 60.331 44.991 86.175c10.759 25.844 24.341 61.51 24.341 61.51l-63.969-1.138-5.363-146.547Z",
    fill: "url(#jm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.89 760.417s49.592-42.767 76.58-55.966c26.99-13.198 68.639-18.634 85.185-15.919 16.547 2.715 35.66 14.148 35.66 14.148L138.3 729.972s-5.673-4.305-35.842-4.716c-30.169-.411-89.55 47.611-89.55 47.611l-29.536 20.67-.263-33.12Z",
    fill: "url(#jn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.633 793.503s49.33-44.385 76.319-57.583c26.989-13.198 68.638-18.635 85.184-15.92 16.547 2.715 35.66 14.148 35.66 14.148l-42.235 27.266s-5.673-4.305-35.842-4.716c-30.169-.411-89.55 47.591-89.55 47.591l-29.536 20.669v-31.455Z",
    fill: "url(#jo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.528 511.307s17.517 13.313 31.187 27.764c13.67 14.451 49.821 63.895 57.05 74.162 7.229 10.268 50.953 78.353 50.953 78.353s-1.125-.525 11.803.236c12.929.761 50.192 3.564 23.58-7.842-8.569-3.672-19.396-27.764-39.937-50.966-20.542-23.203-47.16-57.435-62.75-73.435-15.59-16.001-41.097-34.609-44.883-36.509-3.786-1.9-28.525-17.092-27.003-11.763Z",
    fill: "url(#jp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 539.148s64.488 87.085 74.412 100.862c9.924 13.778 38.934 49.801 46.486 56.768 7.553 6.966 35.229-4.959 35.229-4.959s-38.752-50.724-56.39-72.761c-17.638-22.037-74.93-77.154-99.737-79.91Z",
    fill: "url(#jq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.966 499.891s17.516 13.313 31.186 27.764c13.67 14.451 49.855 63.902 57.05 74.17 7.196 10.267 50.967 78.346 50.967 78.346a21.566 21.566 0 0 0 17.874 11.413c12.928.761 17.112 4.945 15.212-4.184-1.9-9.129-17.112-42.599-37.654-65.802-20.541-23.203-47.16-57.427-62.756-73.435-15.597-16.007-41.097-34.609-44.877-36.515-3.78-1.907-28.525-17.079-27.002-11.757Z",
    fill: "url(#jr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.872 657.352s2.284-74.163 16.358-106.495c14.074-32.331 20.158-42.942 29.643-52.091 9.486-9.149 14.822-25.5 14.822-25.5s-4.184 23.202-6.845 27.386c-2.661 4.184-17.88 35.37-18.257 54.766-.378 19.397-4.946 69.602-3.423 76.07 1.523 6.467 2.661 23.964 2.661 30.047 0 6.084-1.9 27.003-4.568 29.644-2.667 2.641-24.098 2.021-24.098 2.021s-7.532-13.501-6.293-35.848Z",
    fill: "url(#js)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.829 644.039s23.58-57.427 31.186-74.162c7.607-16.736 24.342-44.499 35.37-57.812 11.029-13.313 24.726-27.003 24.726-27.003s-20.886 47.922-23.964 58.951c-3.079 11.028-12.552 46.021-17.874 61.981-5.322 15.961-18.258 52.483-28.525 61.612-10.268 9.129-30.432 23.58-30.432 23.58s-3.422-22.806 9.513-47.147Z",
    fill: "url(#jt)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.797 695.769s27.521-28.525 76.062-25.52c48.542 3.005 105.585 43.536 121.606 56.545s26.524 22.522 38.537 33.531a1907.492 1907.492 0 0 1 21.013 19.538s-4.501 9.007-39.534-15.018c-35.033-24.024-60.547-31.092-83.069-39.075-22.522-7.984-47.039-12.983-47.039-12.983l-72.559-5.504-15.017-11.514Z",
    fill: "url(#ju)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.898 703.778s36.536-17.517 76.07 3.496c39.533 21.013 96.577 63.572 131.603 76.069 35.027 12.498 109.594 55.043 109.594 55.043s-27.522-7.505-42.034-10.011c-14.511-2.507-77.066-25.015-77.066-25.015l-64.555-18.521-78.906-30.526-46.197-24.018-8.509-26.517Z",
    fill: "url(#jv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.805 719.32s75.564 19.538 121.605 64.057c46.042 44.519 88.068 98.578 88.068 98.578l24.025 25.022s-34.029-15.01-57.549-30.021c-23.519-15.01-81.351-45.038-81.351-45.038s-45.759-46.54-54.261-53.048c-8.502-6.508-28.026-17.011-28.026-17.011l-12.511-42.539Z",
    fill: "url(#jw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.634 820.378s25.716-7.801 67.762-43.279c42.047-35.478 103.753-97.238 145.974-90.009 42.222 7.229 29.698 11.79 29.698 11.79s-115.886 84.767-136.913 94.644c-21.026 9.877-72.512 30.796-72.512 30.796s-30.398 12.8-34.016 13.11l.007-17.052Z",
    fill: "url(#jx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.96 693.769s-7.411-2.769-27.414 25.749c-20.002 28.519-55.049 85.562-77.066 131.611-22.017 46.048-26.02 52.549-26.02 52.549h23.022s43.596-58.081 69.837-94.111c26.241-36.03 42.754-64.555 46.257-81.068 3.504-16.513 11.811-38.84-8.616-34.73Z",
    fill: "url(#jy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9 902.004s-24.617-84.133-24.617-104.149c0-20.016-2.5-68.558 0-87.583 2.499-19.026 5.005-24.517 14.512-20.515 9.506 4.002 15.01 29.556 15.01 29.556s21.518 66.024 22.017 96.045c.499 30.021 5.922 86.64 5.922 86.64l-32.844.006Z",
    fill: "url(#jz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.102 901.158s23.728-48.966 52.509-73.199c28.781-24.234 43.926-37.87 67.654-57.562 23.729-19.693 28.782-30.796 46.487-41.905 17.705-11.11 26.76-14.148 39.379-30.318 12.618-16.169 20.582-30.802 31.752-39.89l11.163-9.089s-17.166 18.682-20.696 25.244c-3.531 6.562-14.148 31.813-20.212 38.402-6.063 6.589-53.52 50.488-69.676 67.655-16.155 17.166-35.343 34.838-53.519 52.004-18.177 17.166-45.443 53.52-49.983 62.103l-3.894 6.555h-30.964Z",
    fill: "url(#jA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.758 526.836s11.043 22.603 5.451 37.324c-5.592 14.72-9.911 40.881-7.93 59.287 1.981 18.406-7.411 51.115-18.588 66.482-11.177 15.367-43.374 41.636-54.773 57.003-11.399 15.367-31.725 42.134-47.092 51.054-15.368 8.92-52.55 64.441-52.55 64.441l-25.359 38.846-43.886-.101s38.584-65.862 89.113-102.121c50.528-36.26 66.024-71.832 104.055-97.224 38.031-25.393 34.083-52.051 34.359-70.889.277-18.837-6.137-25.345 4.272-47.618 10.409-22.273 12.875-16.627 15.367-29.704 2.493-13.077-2.439-26.78-2.439-26.78Z",
    fill: "url(#jB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.101 778.682s17.348-13.387 32.217-35.707c14.868-22.32 45.603-44.122 45.603-44.122s37.176-13.38 59.483-25.278c22.306-11.897 35.195-13.878 35.195-13.878s-7.728-1.489-22.455 0c-14.728 1.489-31.577 15.859-45.456 18.338-13.878 2.48-36.131 4.588-58.391 24.928-22.259 20.339-44.748 44.815-55.245 57.757-10.496 12.943-17.199 23.405-37.054 37.783-19.854 14.377-42.531 49.989-42.531 49.989L587.883 900.2H623.9s28.713-52.139 42.093-67.5c13.38-15.36 49.108-54.018 49.108-54.018Z",
    fill: "url(#jC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.867 900.477s52.914-77.605 80.913-92.461c28-14.855 98.962-26.8 121.518-30.452 22.556-3.651 44.008-8.603 59.961-8.603h50.347s-38.099 5.841-42.848 11.723c-4.75 5.881-77.586 18.534-77.586 18.534s-66.313 22.549-78.427 31.354c-12.113 8.806-41.817 31.355-47.315 46.204-5.497 14.848-10.456 23.701-10.456 23.701h-56.107Z",
    fill: "url(#jD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.384 787.348s33.013-31.355 51.708-35.754c18.696-4.399 70.41-31.537 84.713-35.848 14.303-4.312 39.918-3.207 55.44-2.109 15.523 1.098 73.28 13.757 78.784 13.757 5.505 0-77.012-3.853-91.315 0-14.303 3.854-57.212 15.947-73.711 26.403-16.499 10.456-51.721 30.257-51.721 30.257l-51.115 39.075-62.763 78.151H616.32s35.707-57.939 51.627-75.51c15.92-17.57 42.437-38.422 42.437-38.422Z",
    fill: "url(#jE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.583 784.563s71.528-27.191 88.068-33.982c16.539-6.791 22.131-11.251 36.01-13.124 13.878-1.873 37.89-2.627 46.89-2.627 9.001 0 48.019 5.248 63.779 3.752 15.75-1.495 13.87-3.752 13.87-3.752s-19.88 3.752-31.88 0c-12.01-3.753-38.405-11.224-83.295-10.78-44.889.445-72.431 6.064-93.08 13.933s-37.425 13.743-52.065 25.729c-14.64 11.985-38.402 20.312-46.783 29.643a58.05 58.05 0 0 1-18.331 13.562s44.701-15.259 51.707-16.883c7.007-1.624 25.11-5.471 25.11-5.471Z",
    fill: "url(#jF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.398 180.317s16.729-1.104 25.568-6.885c8.839-5.78 24.806-13.185 31.274-17.961 6.467-4.777 17.227-10.039 27.258-11.709 10.032-1.671 36.078-7.647 45.395-9.318 9.318-1.671 31.436-5.955 40.935-9.62 9.5-3.665-5.578 4.129-11.076 5.322-5.497 1.192-30.317 6.447-30.317 6.447s-43.724 8.839-48.736 11.231c-5.013 2.392-21.27 8.839-35.121 17.921-13.852 9.082-23.749 14.572-23.749 14.572h-21.431Z",
    fill: "url(#jG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.617 179.359s.836-13.521 4.325-21.848c3.49-8.327 13.556-20.515 13.556-20.515a50.835 50.835 0 0 0-4.097 12.423c-1.199 6.69-.471 16.486-2.863 20.07-2.392 3.585-10.921 9.87-10.921 9.87Z",
    fill: "url(#jH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5 170.195a61.288 61.288 0 0 0 2.904-15.448c.64-9.317 10.914-23.169 10.914-23.169s-2.385 8.893-2.385 14.242c0 5.35 1.576 12.754-1.603 15.86-3.18 3.106-9.83 8.515-9.83 8.515Z",
    fill: "url(#jI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.031 162.827a60.927 60.927 0 0 0 2.904-15.448c.674-9.318 10.921-23.176 10.921-23.176s-2.392 8.893-2.392 14.242c0 5.35 1.583 12.754-1.596 15.86-3.18 3.106-9.837 8.522-9.837 8.522Z",
    fill: "url(#jJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.367 143.512s1.179 20.831 13.602 26.524l12.424 5.686s-7.276-14.397-11.413-19.504c-4.137-5.107-14.613-12.706-14.613-12.706Z",
    fill: "url(#jK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.312 137.984s1.025 16.756 11.858 21.323l10.84 4.575s-6.36-11.574-9.951-15.677-12.747-10.221-12.747-10.221Z",
    fill: "url(#jL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.469 139.137s1.024 16.748 11.857 21.323l10.84 4.568s-6.339-11.575-9.897-15.678c-3.557-4.103-12.8-10.213-12.8-10.213Z",
    fill: "url(#jM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.445 142.148s1.031 16.749 11.864 21.324l10.834 4.574s-6.36-11.574-9.951-15.684c-3.591-4.11-12.747-10.214-12.747-10.214Z",
    fill: "url(#jN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.242 106.234s-14.99 7.539-14.929 19.302l.06 11.757s8.139-10.403 10.497-15.321c2.358-4.918 4.372-15.738 4.372-15.738Z",
    fill: "url(#jO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.924 103.457s-14.997 7.539-14.916 19.275l.061 11.756s8.138-10.402 10.496-15.32c2.358-4.918 4.359-15.711 4.359-15.711Z",
    fill: "url(#jP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.031 109.676s-14.99 7.539-14.929 19.302l.067 11.756s8.132-10.402 10.49-15.32c2.358-4.918 4.372-15.738 4.372-15.738Z",
    fill: "url(#jQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.656 135.965s1.031 16.748 11.864 21.323l10.834 4.574s-6.36-11.574-9.951-15.677-12.747-10.22-12.747-10.22Z",
    fill: "url(#jR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.031 131.492s2.298 16.621 13.475 20.36l11.15 3.739s-7.223-11.062-11.11-14.882c-3.887-3.82-13.515-9.217-13.515-9.217Z",
    fill: "url(#jS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.914 129.914s2.911 16.526 14.189 19.848l11.284 3.321s-7.626-10.779-11.655-14.451c-4.029-3.672-13.818-8.718-13.818-8.718Z",
    fill: "url(#jT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.516 128.923s15.118 7.283 24.402.061l9.283-7.216s-13.204-.107-18.54 1.024c-5.336 1.132-15.145 6.131-15.145 6.131Z",
    fill: "url(#jU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.547 145.762s1.179 20.831 13.602 26.517l12.424 5.7s-7.297-14.404-11.413-19.538c-4.117-5.134-14.613-12.679-14.613-12.679Z",
    fill: "url(#jV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.373 152.121s-2.19 12.942 5.693 20.104c7.882 7.162 17.921 8.367 20.306 11.231 2.385 2.863-3.578-10.78-6.448-15.671-2.87-4.891-14.727-16.418-19.551-15.664Z",
    fill: "url(#jW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.734 150.773a61.304 61.304 0 0 0 2.904-15.449c.64-9.317 10.914-23.176 10.914-23.176s-2.385 8.893-2.385 14.243c0 5.349 1.577 12.753-1.603 15.859-3.18 3.106-9.83 8.523-9.83 8.523Z",
    fill: "url(#jX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.495 145.389s11.11-11.345 11.527-20.164l.432-8.819s-6.124 10.106-9.21 16.089c-3.086 5.982-2.749 12.894-2.749 12.894Z",
    fill: "url(#jY)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 714.714,
    y1: 401.464,
    x2: 718.662,
    y2: 49.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ACD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACD9E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1048.19,
    y1: 510.103,
    x2: 1099.81,
    y2: 508.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 963.607,
    y1: 291.705,
    x2: 1054.31,
    y2: 250.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5C703E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#517343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4D7445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31614C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#395053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1070.93,
    y1: 271.517,
    x2: 1181.59,
    y2: 339.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 977.302,
    y1: 457.944,
    x2: 1046.67,
    y2: 480.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#435242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#42574D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#425A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#425B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#354C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#263829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 954.112,
    y1: 613.218,
    x2: 1059.87,
    y2: 722.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#486956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3E5E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#38574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#365549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 950.392,
    y1: 779.825,
    x2: 1064.04,
    y2: 893.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#657349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#505D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#485527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3F593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#395B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#355D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 1037.75,
    y1: 454.336,
    x2: 1105.15,
    y2: 452.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#628451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5A7B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#577744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4B6A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3D5A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#334E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1031.56,
    y1: 646.463,
    x2: 1120.53,
    y2: 652.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#455E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2B4B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 1046.57,
    y1: 832.893,
    x2: 1129.55,
    y2: 837.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#40594A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 715.898,
    y1: 796.126,
    x2: 807.462,
    y2: 857.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 822.028,
    y1: 815.23,
    x2: 885.283,
    y2: 857.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1166.49,
    y1: 864.79,
    x2: 691.043,
    y2: 741.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F5949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#354A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#37453A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#354939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 1293.3,
    y1: 864.784,
    x2: 817.929,
    y2: 741.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F5949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#354A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#37453A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#354939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 1048.93,
    y1: 856.566,
    x2: 665.137,
    y2: 756.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F5949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#354A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#37453A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#354939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1027.26,
    y1: 874.587,
    x2: 1261.34,
    y2: 728.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#37503F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#435B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 1045.26,
    y1: 910.233,
    x2: 1445.37,
    y2: 660.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#37503F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#435B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 1128.22,
    y1: 991.94,
    x2: 284.657,
    y2: 490.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4C6C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#415D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 1084.3,
    y1: 816.222,
    x2: 978.801,
    y2: 885.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#446047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#385140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#344935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 736.554,
    y1: 584.512,
    x2: 1142.43,
    y2: 1526.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 736.564,
    y1: 615.988,
    x2: 1142.43,
    y2: 1557.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 944.366,
    y1: 496.712,
    x2: 772.832,
    y2: 707.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 747.718,
    y1: 412.331,
    x2: 907.672,
    y2: 799.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 972.03,
    y1: 482.497,
    x2: 796.803,
    y2: 698.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 1050.34,
    y1: 500.546,
    x2: 969.457,
    y2: 693.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 1151.09,
    y1: 575.302,
    x2: 916.53,
    y2: 623.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 1158.18,
    y1: 666.481,
    x2: 1130.27,
    y2: 834.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#42623E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#345332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#344F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 1225.84,
    y1: 713.116,
    x2: 1089.2,
    y2: 979.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#42623E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#345332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#344F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 1164.87,
    y1: 787.706,
    x2: 1136.34,
    y2: 843.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#446047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#385140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#344935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 684.756,
    y1: 668.875,
    x2: 1700.46,
    y2: 1349.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 976.41,
    y1: 855.094,
    x2: 743.91,
    y2: 708.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#476448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C5541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#374D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#354A3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 1071.26,
    y1: 758.679,
    x2: 921.126,
    y2: 857.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#446047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#385140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#344935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 1440.09,
    y1: 411.993,
    x2: 1155.87,
    y2: 437.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0B100E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0F1410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#20281A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#211F16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#182017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39461D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 1265.86,
    y1: 445.467,
    x2: 1221.39,
    y2: 425.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 1230.5,
    y1: 452.56,
    x2: 1201.35,
    y2: 439.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 1267.12,
    y1: 538.019,
    x2: 1237.97,
    y2: 524.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 1282.49,
    y1: 439.731,
    x2: 1253.33,
    y2: 426.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 1303.11,
    y1: 443.208,
    x2: 1268.25,
    y2: 427.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 1334.43,
    y1: 517.944,
    x2: 1299.56,
    y2: 502.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 1314.85,
    y1: 518.991,
    x2: 1282.22,
    y2: 499.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 1290.27,
    y1: 529.994,
    x2: 1257.64,
    y2: 510.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 1336.21,
    y1: 435.41,
    x2: 1306.15,
    y2: 412.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 1382.72,
    y1: 497.419,
    x2: 1345.62,
    y2: 489.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 1335.12,
    y1: 433.765,
    x2: 1180.2,
    y2: 312.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 1357.14,
    y1: 519.719,
    x2: 1202.22,
    y2: 398.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 1356.52,
    y1: 509.009,
    x2: 1185.7,
    y2: 412.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#32381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5B6824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 1245.22,
    y1: 438.687,
    x2: 1243.96,
    y2: 241.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 1227.3,
    y1: 443.472,
    x2: 1190.19,
    y2: 251.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 1303.05,
    y1: 455.568,
    x2: 1246.63,
    y2: 158.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 1389.22,
    y1: 510.861,
    x2: 1233.98,
    y2: 254.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 1368.89,
    y1: 524.624,
    x2: 1213.66,
    y2: 267.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 1352.28,
    y1: 529.951,
    x2: 1197.05,
    y2: 273.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 1198.84,
    y1: 447.282,
    x2: 1183.24,
    y2: 365.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 1329.48,
    y1: 365.143,
    x2: 1295.78,
    y2: 378.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1252.16,
    y1: 472.863,
    x2: 1231.38,
    y2: 502.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1271.42,
    y1: 463.956,
    x2: 1250.65,
    y2: 493.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 1346.5,
    y1: 364.637,
    x2: 1312.55,
    y2: 377.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 1427.79,
    y1: 388.481,
    x2: 1413.34,
    y2: 394.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 1408.31,
    y1: 381.905,
    x2: 1390.13,
    y2: 388.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2C311B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#41491F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#546023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5B6824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#748053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 1360.33,
    y1: 313.011,
    x2: 1240.28,
    y2: 423.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7A5716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7E5614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#876815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8B7016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 1418.1,
    y1: 371.769,
    x2: 1284.53,
    y2: 383.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#121410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0B100E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0F1410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#211F16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#182017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39461D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 1359.86,
    y1: 531.013,
    x2: 1233.08,
    y2: 353.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#121410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0B100E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1F2714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#323E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#39461D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 1416.99,
    y1: 84.461,
    x2: 1362.17,
    y2: 138.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0B100E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#192417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3B4B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#516425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 1426.89,
    y1: 15.371,
    x2: 1370.46,
    y2: 63.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3B4B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#516425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 1410.49,
    y1: 99.928,
    x2: 1392,
    y2: 223.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3B4B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#516425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 1406.91,
    y1: 268.205,
    x2: 1389.76,
    y2: 382.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#262F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F341D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 1376.56,
    y1: 81.698,
    x2: 1374.31,
    y2: 96.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1E3323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 1355.26,
    y1: 84.299,
    x2: 1353,
    y2: 99.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1E3323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 1345.4,
    y1: 136.846,
    x2: 1363.06,
    y2: 140.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1E3323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 1336.27,
    y1: 119.214,
    x2: 1349.46,
    y2: 121.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 1340.34,
    y1: 87.559,
    x2: 1338.08,
    y2: 102.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1E3323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 1327.4,
    y1: 97.063,
    x2: 1325.91,
    y2: 106.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1E3323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 1317.5,
    y1: 106.81,
    x2: 1316.69,
    y2: 112.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1E3323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 1331.37,
    y1: 134.073,
    x2: 1341.06,
    y2: 137.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 1315.81,
    y1: 133.6,
    x2: 1330.45,
    y2: 139.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 1305.19,
    y1: 137.728,
    x2: 1316.56,
    y2: 141.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 1286.53,
    y1: 106.214,
    x2: 1322.57,
    y2: 119.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 1373.96,
    y1: 131.251,
    x2: 1385.13,
    y2: 135.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 1448.39,
    y1: 86.588,
    x2: 1377.88,
    y2: 92.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 1452.39,
    y1: 131.113,
    x2: 1353.82,
    y2: 139.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 1429.15,
    y1: 130.073,
    x2: 1349.37,
    y2: 137.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 1412.88,
    y1: 130.362,
    x2: 1337.53,
    y2: 137.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 1411.6,
    y1: 82.087,
    x2: 1325.43,
    y2: 89.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 1427.78,
    y1: 80.519,
    x2: 1341.24,
    y2: 88.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 1313.27,
    y1: 134.264,
    x2: 1232.74,
    y2: 141.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 1441.35,
    y1: 156.946,
    x2: 1386.62,
    y2: 161.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 1401.78,
    y1: 174.961,
    x2: 1360.05,
    y2: 178.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 1383.05,
    y1: 181.235,
    x2: 1329.94,
    y2: 186.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 1367.8,
    y1: 184.382,
    x2: 1307.78,
    y2: 189.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 1363.63,
    y1: 177.236,
    x2: 1269.72,
    y2: 185.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 1365.85,
    y1: 169.24,
    x2: 1256.68,
    y2: 179.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 1441.41,
    y1: 116.058,
    x2: 1342.25,
    y2: 124.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 1429.9,
    y1: 121.266,
    x2: 1297.5,
    y2: 133.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 1415.85,
    y1: 129.3,
    x2: 1279.91,
    y2: 141.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 1397.12,
    y1: 138.683,
    x2: 1274.18,
    y2: 149.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 1379.91,
    y1: 150.834,
    x2: 1257.68,
    y2: 161.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1C2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 1351.11,
    y1: 268.784,
    x2: 1343.56,
    y2: 276.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#24321C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#33431F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#4C5E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 1374.86,
    y1: 260.133,
    x2: 1357.54,
    y2: 277.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#24321C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#33431F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#4C5E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 1388.74,
    y1: 330.95,
    x2: 1366.88,
    y2: 306.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 1385.83,
    y1: 330.717,
    x2: 1343.47,
    y2: 284.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 1348.88,
    y1: 302.098,
    x2: 1347.36,
    y2: 284.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 1389.65,
    y1: 334.453,
    x2: 1382.14,
    y2: 316.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 1406.17,
    y1: 320.994,
    x2: 1382.57,
    y2: 263.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 1390,
    y1: 306.833,
    x2: 1369.92,
    y2: 257.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 1420.33,
    y1: 330.68,
    x2: 1395.98,
    y2: 270.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 1437.12,
    y1: 343.872,
    x2: 1408.55,
    y2: 273.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1F2C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2E3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3C4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#596D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 492.243,
    y1: 673.886,
    x2: 612.832,
    y2: 831.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9BC060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#79A55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#62935D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#47744D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 515.901,
    y1: 626.431,
    x2: 638.025,
    y2: 791.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9BC060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#79A55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#62935D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#47744D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 603.569,
    y1: 620.5,
    x2: 606.284,
    y2: 860.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5C8F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#619862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5A8D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4B7652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#466E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 632.53,
    y1: 688.504,
    x2: 671.309,
    y2: 800.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5C8F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#619862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5A8D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4B7652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#466E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 588.382,
    y1: 625.156,
    x2: 720.397,
    y2: 884.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 716.933,
    y1: 683.64,
    x2: 734.166,
    y2: 733.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 48.742,
    y1: 579.6,
    x2: 3.554,
    y2: 582.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#373E34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 61.489,
    y1: 306.769,
    x2: 35.6,
    y2: 306.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#353934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 117.692,
    y1: 182.324,
    x2: 40.632,
    y2: 60.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#515445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#454D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#353934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 30.818,
    y1: 690.141,
    x2: 12.554,
    y2: 650.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#373E34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 77.918,
    y1: 33.211,
    x2: 15.853,
    y2: -4.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#353934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 88.405,
    y1: 121.041,
    x2: 11.157,
    y2: 85.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#515445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#454D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#353934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 104.312,
    y1: 60.532,
    x2: 78.801,
    y2: 4.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#353934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 83.365,
    y1: 694.776,
    x2: 12.143,
    y2: 690.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46473B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3D4134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#373F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 165.704,
    y1: 608.258,
    x2: -38.37,
    y2: 773.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3F3F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#494A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 16.653,
    y1: 602.22,
    x2: 28.775,
    y2: 670.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#373D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#414531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4D4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 8.707,
    y1: 381.09,
    x2: 226.983,
    y2: 493.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: -22.811,
    y1: 482.002,
    x2: 94.404,
    y2: 377.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 4.928,
    y1: 525.678,
    x2: 43.927,
    y2: 388.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 25.997,
    y1: 501.456,
    x2: 186.681,
    y2: 578.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 18.455,
    y1: 1.496,
    x2: -72.468,
    y2: 79.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#373C37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 33.831,
    y1: 116.998,
    x2: -50.772,
    y2: 189.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#373C37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 471.015,
    y1: 590.249,
    x2: 516.212,
    y2: 587.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#373E34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 461.57,
    y1: 721.286,
    x2: 477.967,
    y2: 721.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#353934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 497.642,
    y1: 475.693,
    x2: 516.031,
    y2: 515.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3A413A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#373E34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 436.209,
    y1: 475.494,
    x2: 507.424,
    y2: 479.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46473B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3D4134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#373F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 353.872,
    y1: 562.015,
    x2: 557.939,
    y2: 396.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#545A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3F3F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#494A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 538.506,
    y1: 576.142,
    x2: 521.999,
    y2: 482.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#373D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#414531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4D4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 510.866,
    y1: 789.181,
    x2: 292.596,
    y2: 676.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 562.19,
    y1: 696.99,
    x2: 428.914,
    y2: 815.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 554.9,
    y1: 643.437,
    x2: 506.488,
    y2: 813.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 493.635,
    y1: 668.679,
    x2: 332.951,
    y2: 591.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B433B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 513.362,
    y1: 606.987,
    x2: 900.654,
    y2: 500.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 644.037,
    y1: 485.637,
    x2: 778.039,
    y2: 411.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4D564B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#46564C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 770.708,
    y1: 398.809,
    x2: 964.495,
    y2: 534.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4D564B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#46564C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 629.413,
    y1: 448.981,
    x2: 851.139,
    y2: 395.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5A695E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#404E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#36413D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 485.157,
    y1: 338.694,
    x2: 845.237,
    y2: 592.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#364643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#303F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 629.946,
    y1: 539.872,
    x2: 852.286,
    y2: 533.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: -4.009,
    y1: 695.929,
    x2: 383.277,
    y2: 589.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 126.662,
    y1: 574.576,
    x2: 260.664,
    y2: 500.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4D564B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#46564C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 253.337,
    y1: 487.753,
    x2: 447.125,
    y2: 623.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4D564B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#46564C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 112.045,
    y1: 537.926,
    x2: 333.764,
    y2: 484.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5A695E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#404E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#36413D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: -32.225,
    y1: 427.635,
    x2: 327.862,
    y2: 681.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#364643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#303F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 112.572,
    y1: 628.813,
    x2: 334.911,
    y2: 622.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F5E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#334441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2C3A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 696.355,
    y1: 418.398,
    x2: 727.242,
    y2: 417.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 645.741,
    y1: 287.706,
    x2: 700.012,
    y2: 263.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5C703E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#517343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4D7445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31614C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#395053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 709.969,
    y1: 275.629,
    x2: 776.184,
    y2: 316.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 653.938,
    y1: 387.185,
    x2: 695.451,
    y2: 400.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#435242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#42574D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#425A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#425B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#354C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#263829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 640.055,
    y1: 480.095,
    x2: 703.342,
    y2: 545.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#486956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3E5E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#38574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#365549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 637.84,
    y1: 579.79,
    x2: 705.846,
    y2: 647.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#657349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#505D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#485527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3F593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#395B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#355D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 690.11,
    y1: 385.023,
    x2: 730.442,
    y2: 383.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#628451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5A7B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#577744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4B6A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3D5A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#334E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 686.404,
    y1: 499.995,
    x2: 739.639,
    y2: 503.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#455E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2B4B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 694.114,
    y1: 632.612,
    x2: 744.073,
    y2: 635.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#40594A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 563.917,
    y1: 581.175,
    x2: 594.803,
    y2: 580.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 513.305,
    y1: 450.48,
    x2: 567.576,
    y2: 425.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5C703E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#517343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4D7445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31614C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#395053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 577.525,
    y1: 438.404,
    x2: 643.74,
    y2: 479.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 521.497,
    y1: 549.96,
    x2: 563.009,
    y2: 563.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#435242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#42574D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#425A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#425B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#354C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#263829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 507.619,
    y1: 642.87,
    x2: 570.906,
    y2: 708.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#486956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3E5E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#38574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#365549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 505.396,
    y1: 742.568,
    x2: 573.402,
    y2: 810.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#657349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#505D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#485527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3F593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#395B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#355D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 557.674,
    y1: 547.798,
    x2: 598.005,
    y2: 546.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#628451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5A7B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#577744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4B6A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3D5A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#334E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 553.968,
    y1: 662.767,
    x2: 607.203,
    y2: 666.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#455E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2B4B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 561.67,
    y1: 795.389,
    x2: 611.629,
    y2: 798.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#40594A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 1234.54,
    y1: 428.35,
    x2: 1286.15,
    y2: 426.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 1149.96,
    y1: 209.944,
    x2: 1240.65,
    y2: 168.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5C703E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#517343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4D7445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31614C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#395053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 1257.29,
    y1: 189.753,
    x2: 1367.94,
    y2: 257.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 1163.65,
    y1: 376.19,
    x2: 1233.03,
    y2: 399.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#435242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#42574D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#425A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#425B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#354C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#263829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 1140.46,
    y1: 531.461,
    x2: 1246.22,
    y2: 640.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#486956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3E5E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#38574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#365549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 1136.74,
    y1: 698.072,
    x2: 1250.39,
    y2: 811.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#657349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#505D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#485527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3F593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#395B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#355D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 1224.1,
    y1: 372.583,
    x2: 1291.5,
    y2: 370.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#628451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5A7B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#577744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4B6A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3D5A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#334E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 1217.9,
    y1: 564.708,
    x2: 1306.88,
    y2: 570.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#455E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2B4B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 1230.79,
    y1: 786.337,
    x2: 1314.28,
    y2: 791.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#40594A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 834.735,
    y1: 463.079,
    x2: 856.872,
    y2: 462.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 798.462,
    y1: 369.418,
    x2: 837.363,
    y2: 351.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5C703E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#517343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4D7445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31614C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#395053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 844.49,
    y1: 360.752,
    x2: 891.945,
    y2: 390.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#365753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#32595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#315A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#2A4842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#233729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 804.34,
    y1: 440.711,
    x2: 834.088,
    y2: 450.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#435242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#42574D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#425A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#425B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#354C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#263829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#203120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 794.393,
    y1: 507.291,
    x2: 839.753,
    y2: 554.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#486956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3E5E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#38574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#365549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 792.802,
    y1: 578.746,
    x2: 841.537,
    y2: 627.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#657349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#505D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#485527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3F593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#395B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#355D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 830.266,
    y1: 439.158,
    x2: 859.171,
    y2: 438.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#628451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5A7B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#577744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4B6A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3D5A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#334E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 827.607,
    y1: 521.551,
    x2: 865.763,
    y2: 524.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#455E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2B4B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 833.128,
    y1: 616.6,
    x2: 868.932,
    y2: 618.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#50725B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#40594A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 168.643,
    y1: 347.081,
    x2: 220.102,
    y2: 347.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2C2A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 109.948,
    y1: 343.57,
    x2: 156.778,
    y2: 343.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2C2A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 561.81,
    y1: 607.478,
    x2: 625.004,
    y2: 779.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 484.551,
    y1: 593.875,
    x2: 570.517,
    y2: 675.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 584.984,
    y1: 650.354,
    x2: 668.154,
    y2: 829.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 602.608,
    y1: 673.482,
    x2: 708.085,
    y2: 898.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 386.097,
    y1: 583.213,
    x2: 368.432,
    y2: 765.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 393.361,
    y1: 609.034,
    x2: 404.403,
    y2: 819.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 394.17,
    y1: 650.004,
    x2: 435.832,
    y2: 885.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 268.382,
    y1: 800.324,
    x2: 544.962,
    y2: 800.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 268.375,
    y1: 827.777,
    x2: 551.342,
    y2: 827.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 606.33,
    y1: 716.958,
    x2: 722.391,
    y2: 924.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#40654B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 547.552,
    y1: 763.27,
    x2: 452.962,
    y2: 808.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 428.039,
    y1: 579.479,
    x2: 513.035,
    y2: 579.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 49.298,
    y1: 371.779,
    x2: 131.384,
    y2: 205.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2C2725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#383834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#41433E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#464A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 608.355,
    y1: 268.167,
    x2: 727.523,
    y2: 325.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 638.042,
    y1: 280.553,
    x2: 757.211,
    y2: 338.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 507.936,
    y1: 262.927,
    x2: 638.458,
    y2: 283.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 528.194,
    y1: 343.491,
    x2: 654.432,
    y2: 428.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 315.276,
    y1: 581.116,
    x2: 297.308,
    y2: 91.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#292120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#393935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#434742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 285.35,
    y1: 75.875,
    x2: 425.617,
    y2: 64.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2D3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#393C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1D1515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 379.219,
    y1: 64.847,
    x2: 390.518,
    y2: 80.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 387.388,
    y1: 68.501,
    x2: 398.688,
    y2: 84.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 394.334,
    y1: 73.086,
    x2: 402.581,
    y2: 90.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 398.024,
    y1: 80.183,
    x2: 406.268,
    y2: 97.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 368.665,
    y1: 102.061,
    x2: 390.104,
    y2: 101.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 348.047,
    y1: 95.004,
    x2: 369.482,
    y2: 94.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 332.952,
    y1: 90.017,
    x2: 354.387,
    y2: 89.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 368.966,
    y1: 57.708,
    x2: 366.714,
    y2: 78.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 352.912,
    y1: 54.182,
    x2: 350.66,
    y2: 74.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 385.633,
    y1: 244.77,
    x2: 537.846,
    y2: 244.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 567.565,
    y1: 254.198,
    x2: 589.873,
    y2: 271.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 546.881,
    y1: 250.768,
    x2: 569.19,
    y2: 268.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 496.458,
    y1: 240.055,
    x2: 518.766,
    y2: 257.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: 70.805,
    y1: 281.665,
    x2: 629.968,
    y2: 281.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#393F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4C5955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: 245.843,
    y1: 196.089,
    x2: 417.6,
    y2: 196.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2D3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#393C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1D1515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: 296.081,
    y1: 160.853,
    x2: 318.506,
    y2: 168.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: 267.967,
    y1: 164.742,
    x2: 290.401,
    y2: 172.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 319.753,
    y1: 166.724,
    x2: 336.683,
    y2: 173.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 334.295,
    y1: 166.87,
    x2: 350.328,
    y2: 175.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: 349.183,
    y1: 170.022,
    x2: 367.474,
    y2: 179.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: 363.557,
    y1: 177.771,
    x2: 381.853,
    y2: 186.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: 387.922,
    y1: 179.979,
    x2: 406.211,
    y2: 189.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: 427.388,
    y1: 250.248,
    x2: 573.706,
    y2: 250.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx",
    x1: 398.323,
    y1: 389.968,
    x2: 544.641,
    y2: 390.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dy",
    x1: 559.889,
    y1: 442.781,
    x2: 560.051,
    y2: 296.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: 422.788,
    y1: 389.105,
    x2: 569.099,
    y2: 389.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dA",
    x1: 442.098,
    y1: 386.44,
    x2: 594.991,
    y2: 386.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dB",
    x1: 465.248,
    y1: 393.822,
    x2: 618.141,
    y2: 393.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dC",
    x1: 473.832,
    y1: 268.501,
    x2: 567.669,
    y2: 235.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dD",
    x1: 493.027,
    y1: 273.371,
    x2: 586.864,
    y2: 240.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dE",
    x1: 509.83,
    y1: 288.159,
    x2: 557.885,
    y2: 200.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dF",
    x1: 514.259,
    y1: 271.362,
    x2: 608.095,
    y2: 238.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dG",
    x1: 224.848,
    y1: -0.65,
    x2: 200.285,
    y2: 23.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dH",
    x1: 237.239,
    y1: -9.721,
    x2: 212.669,
    y2: 14.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dI",
    x1: 242.504,
    y1: -15.118,
    x2: 224.311,
    y2: 1.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dJ",
    x1: 260.207,
    y1: -15.451,
    x2: 242.008,
    y2: 1.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dK",
    x1: 281.174,
    y1: 24.293,
    x2: 264.764,
    y2: 34.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dL",
    x1: 466.173,
    y1: 119.104,
    x2: 488.464,
    y2: 102.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dM",
    x1: 344.533,
    y1: 117.907,
    x2: 350.854,
    y2: 132.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dN",
    x1: 327.948,
    y1: 113.692,
    x2: 334.269,
    y2: 127.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dO",
    x1: 305.356,
    y1: 111.373,
    x2: 311.677,
    y2: 125.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dP",
    x1: 283.112,
    y1: 117.245,
    x2: 288.343,
    y2: 133.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dQ",
    x1: 263.44,
    y1: 122.174,
    x2: 266.581,
    y2: 139.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dR",
    x1: 176.968,
    y1: 50.054,
    x2: 175.998,
    y2: 36.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2D3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#425557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#697F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dS",
    x1: 215.655,
    y1: 286.155,
    x2: 210.966,
    y2: 170.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#393F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4C5955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dT",
    x1: 78.076,
    y1: 276.736,
    x2: 96.367,
    y2: 276.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dU",
    x1: 325.284,
    y1: 421.763,
    x2: 364.541,
    y2: 421.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2E3E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4D673B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dV",
    x1: 111.053,
    y1: 303.896,
    x2: 301.613,
    y2: 194.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#191513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#677E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5F7354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dW",
    x1: 149.601,
    y1: 157.997,
    x2: 159.403,
    y2: 195.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dX",
    x1: 167.427,
    y1: 193.948,
    x2: 183.859,
    y2: 233.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dY",
    x1: 131.508,
    y1: 210.538,
    x2: 145.433,
    y2: 210.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dZ",
    x1: 148.333,
    y1: 244.88,
    x2: 163.115,
    y2: 244.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea",
    x1: 180.602,
    y1: 231.317,
    x2: 199.371,
    y2: 262.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb",
    x1: 209.357,
    y1: 248.92,
    x2: 226.719,
    y2: 280.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec",
    x1: 173.59,
    y1: 276.739,
    x2: 195.641,
    y2: 276.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed",
    x1: 220.572,
    y1: 312.623,
    x2: 236.188,
    y2: 312.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 198.499,
    y1: 300.103,
    x2: 214.115,
    y2: 300.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 245.43,
    y1: 297.24,
    x2: 274.642,
    y2: 297.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eg",
    x1: 241.648,
    y1: 325.994,
    x2: 255.466,
    y2: 325.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh",
    x1: 297.954,
    y1: 351.413,
    x2: 335.15,
    y2: 351.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2E3E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4D673B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ei",
    x1: 265.535,
    y1: 315.12,
    x2: 302.704,
    y2: 315.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: 263.867,
    y1: 344.355,
    x2: 282.374,
    y2: 344.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: 287.227,
    y1: 327.052,
    x2: 316.897,
    y2: 327.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "el",
    x1: -1.508,
    y1: 379.695,
    x2: 106.624,
    y2: 379.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2C2A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "em",
    x1: 10.584,
    y1: 250.726,
    x2: 44.97,
    y2: 210.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 13.933,
    y1: 165.17,
    x2: 29.88,
    y2: 136.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#353739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#434E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eo",
    x1: 13.32,
    y1: 103.135,
    x2: 35.99,
    y2: 64.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#353739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#434E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: 3.316,
    y1: 407.211,
    x2: 50.651,
    y2: 369.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eq",
    x1: 8.417,
    y1: 332.281,
    x2: 36.404,
    y2: 295.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: 7.23,
    y1: 543.595,
    x2: 41.852,
    y2: 498.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#383833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es",
    x1: 188.449,
    y1: 2.501,
    x2: 186.004,
    y2: -30.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2D3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#425557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#697F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "et",
    x1: 181.361,
    y1: 346.422,
    x2: 231.04,
    y2: 306.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#191513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5F7354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eu",
    x1: 168.841,
    y1: 357.563,
    x2: 190.266,
    y2: 351.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ev",
    x1: 192.65,
    y1: 361.909,
    x2: 218.851,
    y2: 361.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: 216.257,
    y1: 378.935,
    x2: 240.295,
    y2: 378.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: 137.115,
    y1: 348.626,
    x2: 180.872,
    y2: 330.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#5F7354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ey",
    x1: 126.272,
    y1: 331.984,
    x2: 144.139,
    y2: 324.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ez",
    x1: 96.832,
    y1: 303.801,
    x2: 118.176,
    y2: 295.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eA",
    x1: 96.425,
    y1: 215.747,
    x2: 115.673,
    y2: 245.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eB",
    x1: 114.181,
    y1: 241.61,
    x2: 137.99,
    y2: 271.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eC",
    x1: 128.859,
    y1: 282.571,
    x2: 170.522,
    y2: 282.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eD",
    x1: 244.445,
    y1: 388.655,
    x2: 264.952,
    y2: 388.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eE",
    x1: 268.322,
    y1: 398.298,
    x2: 286.236,
    y2: 398.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eF",
    x1: 287.223,
    y1: 407.701,
    x2: 312.892,
    y2: 407.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2E3E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4D673B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eG",
    x1: 286.102,
    y1: 372.191,
    x2: 324.881,
    y2: 372.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH",
    x1: 314.867,
    y1: 394.168,
    x2: 353.68,
    y2: 394.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2E3E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4D673B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI",
    x1: 313.262,
    y1: 422.477,
    x2: 334.841,
    y2: 422.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2E3E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4D673B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eJ",
    x1: 223.683,
    y1: 341.489,
    x2: 255.24,
    y2: 341.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eK",
    x1: 195.914,
    y1: 325.096,
    x2: 241.134,
    y2: 325.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eL",
    x1: 247.516,
    y1: 352.397,
    x2: 277.887,
    y2: 352.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eM",
    x1: 269.219,
    y1: 357.62,
    x2: 292.893,
    y2: 357.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eN",
    x1: 159.956,
    y1: 283.901,
    x2: 191.755,
    y2: 310.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eO",
    x1: 180.375,
    y1: 311.595,
    x2: 222.718,
    y2: 311.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#354E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eP",
    x1: 70.653,
    y1: 29.268,
    x2: 85.05,
    y2: 10.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#467555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eQ",
    x1: 84.105,
    y1: 45.769,
    x2: 100.402,
    y2: 24.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#467555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eR",
    x1: 98.441,
    y1: 53.212,
    x2: 112.104,
    y2: 35.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eS",
    x1: 101.895,
    y1: -0.898,
    x2: 113.194,
    y2: 28.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eT",
    x1: 104.626,
    y1: 13.421,
    x2: 134.196,
    y2: 31.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eU",
    x1: 94.05,
    y1: -12.847,
    x2: 104.358,
    y2: 18.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eV",
    x1: 135.824,
    y1: 18.431,
    x2: 151.263,
    y2: 47.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eW",
    x1: 213.602,
    y1: 10.931,
    x2: 242.35,
    y2: 31.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eX",
    x1: 228.022,
    y1: 16.817,
    x2: 254.761,
    y2: 42.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#425742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eY",
    x1: 238.075,
    y1: 20.361,
    x2: 265.448,
    y2: 48.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#425742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ",
    x1: 248.179,
    y1: 27.585,
    x2: 270.721,
    y2: 53.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#425742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: 259.849,
    y1: 35.822,
    x2: 287.619,
    y2: 55.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: 197.648,
    y1: 46.537,
    x2: 209.897,
    y2: 78.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 208.383,
    y1: 52.705,
    x2: 220.629,
    y2: 84.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd",
    x1: 188.399,
    y1: 35.291,
    x2: 202.994,
    y2: 57.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe",
    x1: 174.816,
    y1: 32.658,
    x2: 189.408,
    y2: 54.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: 155.435,
    y1: 26.975,
    x2: 174.106,
    y2: 45.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fg",
    x1: 218.935,
    y1: 61.448,
    x2: 231.191,
    y2: 93.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: 229.468,
    y1: 69.819,
    x2: 241.724,
    y2: 102.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fi",
    x1: 271.006,
    y1: 35.997,
    x2: 298.002,
    y2: 63.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj",
    x1: 275.898,
    y1: 39.954,
    x2: 312.771,
    y2: 77.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#274942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fk",
    x1: 231.907,
    y1: 62.26,
    x2: 243.825,
    y2: 46.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fl",
    x1: 209.672,
    y1: 54.433,
    x2: 234.889,
    y2: 52.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm",
    x1: 208.046,
    y1: 47.319,
    x2: 218.663,
    y2: 33.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#467555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fn",
    x1: 250.393,
    y1: 73.809,
    x2: 267.073,
    y2: 69.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#467555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fo",
    x1: 306.18,
    y1: 103.331,
    x2: 329.814,
    y2: 101.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp",
    x1: 320.672,
    y1: 104.477,
    x2: 341.517,
    y2: 103.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fq",
    x1: 363.98,
    y1: 89.358,
    x2: 361.728,
    y2: 110.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fr",
    x1: 352.91,
    y1: 80.993,
    x2: 350.657,
    y2: 101.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs",
    x1: 342.885,
    y1: 116.804,
    x2: 360.867,
    y2: 117.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ft",
    x1: 51.414,
    y1: 94.073,
    x2: 408.173,
    y2: 94.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2D3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#393C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1D1515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: 358.461,
    y1: 120.826,
    x2: 366.565,
    y2: 110.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv",
    x1: 228.461,
    y1: 157.075,
    x2: 252.674,
    y2: 153.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fw",
    x1: 262.564,
    y1: 156.415,
    x2: 286.784,
    y2: 152.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fx",
    x1: 286.561,
    y1: 155.39,
    x2: 310.774,
    y2: 151.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fy",
    x1: 277.824,
    y1: 212.675,
    x2: 309.244,
    y2: 208.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fz",
    x1: 248.516,
    y1: 217.462,
    x2: 279.935,
    y2: 212.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fA",
    x1: 310.489,
    y1: 212.606,
    x2: 340.985,
    y2: 203.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fB",
    x1: 332.779,
    y1: 219.571,
    x2: 363.274,
    y2: 210.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fC",
    x1: 406.615,
    y1: 216.955,
    x2: 440.898,
    y2: 193.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fD",
    x1: 348.854,
    y1: 226.934,
    x2: 379.35,
    y2: 218.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fE",
    x1: 369.768,
    y1: 220.042,
    x2: 401.096,
    y2: 224.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fF",
    x1: 314.501,
    y1: 155.023,
    x2: 334.55,
    y2: 152.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fG",
    x1: 331.775,
    y1: 154.804,
    x2: 349.604,
    y2: 150.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fH",
    x1: 347.407,
    y1: 158.831,
    x2: 362.361,
    y2: 154.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fI",
    x1: 426.682,
    y1: 194.429,
    x2: 444.349,
    y2: 197.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fJ",
    x1: 446.785,
    y1: 203.573,
    x2: 469.122,
    y2: 207.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fK",
    x1: 411.132,
    y1: 184.403,
    x2: 433.003,
    y2: 188.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fL",
    x1: 391.392,
    y1: 171.955,
    x2: 409.057,
    y2: 175.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fM",
    x1: 379.632,
    y1: 163.567,
    x2: 397.294,
    y2: 166.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fN",
    x1: 420.379,
    y1: 149.731,
    x2: 421.72,
    y2: 163.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fO",
    x1: 431.86,
    y1: 157.153,
    x2: 433.199,
    y2: 171.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fP",
    x1: 442.822,
    y1: 162.911,
    x2: 444.167,
    y2: 176.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fQ",
    x1: 458.489,
    y1: 179.515,
    x2: 455.85,
    y2: 193.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fR",
    x1: 470.561,
    y1: 168.791,
    x2: 477.214,
    y2: 181.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fS",
    x1: 477.609,
    y1: 201.589,
    x2: 490.321,
    y2: 195.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fT",
    x1: 461.686,
    y1: 203.864,
    x2: 474.398,
    y2: 197.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fU",
    x1: 494.396,
    y1: 205.176,
    x2: 507.115,
    y2: 199.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fV",
    x1: 512.187,
    y1: 188.941,
    x2: 509.547,
    y2: 202.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fW",
    x1: 485.007,
    y1: 168.81,
    x2: 491.664,
    y2: 181.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fX",
    x1: 498.203,
    y1: 170.659,
    x2: 504.86,
    y2: 182.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fY",
    x1: 408.787,
    y1: 142.469,
    x2: 410.125,
    y2: 156.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fZ",
    x1: 381.246,
    y1: 168.85,
    x2: 389.717,
    y2: 155.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ga",
    x1: 360.379,
    y1: 146.419,
    x2: 358.68,
    y2: 130.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gb",
    x1: 374.057,
    y1: 153.242,
    x2: 372.358,
    y2: 137.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc",
    x1: 449.013,
    y1: 103.258,
    x2: 473.889,
    y2: 103.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gd",
    x1: 427.925,
    y1: 104.438,
    x2: 452.795,
    y2: 105.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ge",
    x1: 184.727,
    y1: 77.83,
    x2: 192.367,
    y2: 76.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gf",
    x1: 239.582,
    y1: 192.039,
    x2: 271.657,
    y2: 209.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6745"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gg",
    x1: 227.075,
    y1: 184.821,
    x2: 257.911,
    y2: 201.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gh",
    x1: 215.566,
    y1: 177.945,
    x2: 239.88,
    y2: 192.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gi",
    x1: 616.869,
    y1: 372.317,
    x2: 570.959,
    y2: 162.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gj",
    x1: 529.689,
    y1: 442.384,
    x2: 491.596,
    y2: 263.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1D2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2C3936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gk",
    x1: 534.233,
    y1: 448.584,
    x2: 507.419,
    y2: 272.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#324639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1D2A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl",
    x1: 510.238,
    y1: 440.875,
    x2: 437.638,
    y2: 278.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#324639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1D2A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gm",
    x1: 646.475,
    y1: 346.412,
    x2: 616.911,
    y2: 211.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn",
    x1: 658.997,
    y1: 348.477,
    x2: 629.424,
    y2: 213.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go",
    x1: 605.398,
    y1: 354.259,
    x2: 681.899,
    y2: 237.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp",
    x1: 570.235,
    y1: 331.422,
    x2: 693.994,
    y2: 266.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gq",
    x1: 529.377,
    y1: 317.657,
    x2: 664.838,
    y2: 289.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr",
    x1: 495.005,
    y1: 317,
    x2: 630.464,
    y2: 289.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gs",
    x1: 469.408,
    y1: 310.927,
    x2: 604.867,
    y2: 283.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt",
    x1: 513.713,
    y1: 317.665,
    x2: 649.174,
    y2: 290.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gu",
    x1: 549.349,
    y1: 321.513,
    x2: 684.808,
    y2: 293.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gv",
    x1: 653.528,
    y1: 311.143,
    x2: 748.331,
    y2: 394.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gw",
    x1: 668.174,
    y1: 324.197,
    x2: 775.426,
    y2: 389.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gx",
    x1: 699.402,
    y1: 336.048,
    x2: 806.654,
    y2: 401.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gy",
    x1: 681,
    y1: 376.664,
    x2: 799.9,
    y2: 440.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gz",
    x1: 740.867,
    y1: 386.04,
    x2: 810.07,
    y2: 502.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gA",
    x1: 729.286,
    y1: 338.231,
    x2: 828.273,
    y2: 416.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gB",
    x1: 653.798,
    y1: 336.935,
    x2: 769.821,
    y2: 401.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gC",
    x1: 630.263,
    y1: 298.834,
    x2: 726.896,
    y2: 379.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gD",
    x1: 598.678,
    y1: 286.89,
    x2: 700.633,
    y2: 359.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gE",
    x1: 554.765,
    y1: 368.001,
    x2: 699.041,
    y2: 319.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gF",
    x1: 695.356,
    y1: 481.673,
    x2: 823.592,
    y2: 399.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gG",
    x1: 201.694,
    y1: 230.102,
    x2: 216.071,
    y2: 230.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gH",
    x1: 220.729,
    y1: 233.87,
    x2: 233.907,
    y2: 233.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gI",
    x1: 237.839,
    y1: 243.734,
    x2: 259.849,
    y2: 238.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gJ",
    x1: 253.641,
    y1: 250.38,
    x2: 272.821,
    y2: 250.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gK",
    x1: 269.929,
    y1: 251.176,
    x2: 288.853,
    y2: 242.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gL",
    x1: 285.393,
    y1: 256.505,
    x2: 307.976,
    y2: 247.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gM",
    x1: 303.467,
    y1: 258.791,
    x2: 323.625,
    y2: 248.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gN",
    x1: 321.398,
    y1: 259.517,
    x2: 341.993,
    y2: 252.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A2A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#394A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gO",
    x1: 335.509,
    y1: 265.736,
    x2: 356.468,
    y2: 260.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gP",
    x1: 354.524,
    y1: 278.953,
    x2: 378.185,
    y2: 274.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gQ",
    x1: 378.891,
    y1: 281.351,
    x2: 403.65,
    y2: 281.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gR",
    x1: 396.163,
    y1: 295.722,
    x2: 418.679,
    y2: 288.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gS",
    x1: 420.091,
    y1: 305.182,
    x2: 440.579,
    y2: 299.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gT",
    x1: 345.363,
    y1: 245.565,
    x2: 421.365,
    y2: 224.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4A673E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#557949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gU",
    x1: 371.367,
    y1: 211.657,
    x2: 435.862,
    y2: 269.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gV",
    x1: 380.241,
    y1: 246.763,
    x2: 494.308,
    y2: 348.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gW",
    x1: 390.556,
    y1: 309.742,
    x2: 534.421,
    y2: 309.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gX",
    x1: 492.857,
    y1: 339.641,
    x2: 462.811,
    y2: 198.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gY",
    x1: 522.823,
    y1: 338.814,
    x2: 492.77,
    y2: 197.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gZ",
    x1: 531.537,
    y1: 338.923,
    x2: 503.918,
    y2: 210.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha",
    x1: 667.32,
    y1: 377.413,
    x2: 639.701,
    y2: 249.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hb",
    x1: 618.371,
    y1: 391.976,
    x2: 581.25,
    y2: 216.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hc",
    x1: 601.004,
    y1: 384.388,
    x2: 563.884,
    y2: 208.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hd",
    x1: 571.39,
    y1: 372.522,
    x2: 534.27,
    y2: 196.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "he",
    x1: 532.562,
    y1: 370.067,
    x2: 530.554,
    y2: 190.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hf",
    x1: 419.88,
    y1: 321.175,
    x2: 427.444,
    y2: 190.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hg",
    x1: 438.921,
    y1: 337.459,
    x2: 446.485,
    y2: 206.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hh",
    x1: 413.86,
    y1: 307.507,
    x2: 540,
    y2: 307.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hi",
    x1: 432.141,
    y1: 309.627,
    x2: 558.281,
    y2: 309.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hj",
    x1: 478.7,
    y1: 344.721,
    x2: 626.272,
    y2: 307.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hk",
    x1: 498.606,
    y1: 352.028,
    x2: 646.177,
    y2: 314.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hl",
    x1: 515.24,
    y1: 357.397,
    x2: 662.81,
    y2: 320.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hm",
    x1: 535.357,
    y1: 368.002,
    x2: 679.632,
    y2: 319.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hn",
    x1: 621.837,
    y1: 399.995,
    x2: 707.222,
    y2: 273.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ho",
    x1: 577.051,
    y1: 375.791,
    x2: 715.532,
    y2: 312.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp",
    x1: 441.28,
    y1: 312.113,
    x2: 587.591,
    y2: 312.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hq",
    x1: 439.333,
    y1: 339.454,
    x2: 632.359,
    y2: 301.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr",
    x1: 420.635,
    y1: 334.878,
    x2: 414.538,
    y2: 183.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#393F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4C5955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hs",
    x1: 129.02,
    y1: 62.481,
    x2: 136.653,
    y2: 61.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ht",
    x1: 146.641,
    y1: 66.99,
    x2: 154.281,
    y2: 65.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hu",
    x1: 160.723,
    y1: 70.29,
    x2: 168.356,
    y2: 69.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hv",
    x1: 197.238,
    y1: 85.879,
    x2: 204.878,
    y2: 84.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hw",
    x1: 202.66,
    y1: 137.32,
    x2: 199.608,
    y2: 91.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hx",
    x1: 115.711,
    y1: 124.296,
    x2: 155.79,
    y2: 115.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hy",
    x1: 134.994,
    y1: 112.946,
    x2: 172.594,
    y2: 111.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hz",
    x1: 150.526,
    y1: 105.567,
    x2: 188.133,
    y2: 104.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hA",
    x1: 207.76,
    y1: 127.888,
    x2: 228.814,
    y2: 115.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hB",
    x1: 235.516,
    y1: 118.325,
    x2: 254.124,
    y2: 107.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hC",
    x1: 227.695,
    y1: 119.474,
    x2: 246.303,
    y2: 108.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hD",
    x1: 218.655,
    y1: 122.485,
    x2: 237.256,
    y2: 111.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hE",
    x1: 232.309,
    y1: 76.275,
    x2: 249.762,
    y2: 89.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hF",
    x1: 243.994,
    y1: 73.497,
    x2: 261.438,
    y2: 86.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hG",
    x1: 212.106,
    y1: 79.721,
    x2: 229.556,
    y2: 92.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hH",
    x1: 246.866,
    y1: 116.306,
    x2: 265.467,
    y2: 105.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hI",
    x1: 260.129,
    y1: 110.803,
    x2: 277.849,
    y2: 98.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hJ",
    x1: 272.24,
    y1: 109.964,
    x2: 289.48,
    y2: 96.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hK",
    x1: 292.59,
    y1: 98.479,
    x2: 292.068,
    y2: 76.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hL",
    x1: 197.932,
    y1: 130.13,
    x2: 218.985,
    y2: 117.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hM",
    x1: 184.213,
    y1: 137.898,
    x2: 211.816,
    y2: 121.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hN",
    x1: 171.228,
    y1: 93.52,
    x2: 208.828,
    y2: 92.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hO",
    x1: 205.673,
    y1: 95,
    x2: 198.737,
    y2: 91.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hP",
    x1: 422.16,
    y1: 64.282,
    x2: 449.742,
    y2: 82.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hQ",
    x1: 340.611,
    y1: 22.762,
    x2: 356.861,
    y2: 33.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hR",
    x1: 356.143,
    y1: 24.067,
    x2: 372.393,
    y2: 35.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hS",
    x1: 322.651,
    y1: 24.036,
    x2: 338.901,
    y2: 34.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hT",
    x1: 290.486,
    y1: 15.282,
    x2: 279.981,
    y2: -1.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hU",
    x1: 285.57,
    y1: -15.283,
    x2: 282.803,
    y2: 4.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hV",
    x1: 277.132,
    y1: -7.04,
    x2: 264.108,
    y2: 7.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hW",
    x1: 289.777,
    y1: 8.016,
    x2: 291.312,
    y2: 27.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4A6159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hX",
    x1: 374.936,
    y1: 29.479,
    x2: 387.659,
    y2: 44.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hY",
    x1: 491.258,
    y1: 202.803,
    x2: 505.273,
    y2: 218.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hZ",
    x1: 504.559,
    y1: 210.489,
    x2: 518.576,
    y2: 226.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ia",
    x1: 522.005,
    y1: 214.255,
    x2: 542.744,
    y2: 229.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib",
    x1: 475.251,
    y1: 242.92,
    x2: 493.603,
    y2: 232.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic",
    x1: 364.95,
    y1: 64.745,
    x2: 381.158,
    y2: 51.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id",
    x1: 383.305,
    y1: 73.747,
    x2: 399.513,
    y2: 60.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie",
    x1: 421.767,
    y1: 76.994,
    x2: 421.754,
    y2: 56.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "if",
    x1: 342.879,
    y1: 60.893,
    x2: 359.092,
    y2: 47.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig",
    x1: 314.633,
    y1: 62.74,
    x2: 330.84,
    y2: 49.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ih",
    x1: 391.745,
    y1: 35.331,
    x2: 403.296,
    y2: 51.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ii",
    x1: 487.781,
    y1: 72.258,
    x2: 500.813,
    y2: 97.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ij",
    x1: 471.756,
    y1: 66.929,
    x2: 487.102,
    y2: 86.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ik",
    x1: 453.149,
    y1: 66.643,
    x2: 473.055,
    y2: 81.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il",
    x1: 534.214,
    y1: 213.864,
    x2: 556.523,
    y2: 231.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "im",
    x1: 604.805,
    y1: 258.307,
    x2: 627.113,
    y2: 275.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "in",
    x1: 557.763,
    y1: 217.732,
    x2: 574.661,
    y2: 230.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "io",
    x1: 574.594,
    y1: 228.584,
    x2: 580.381,
    y2: 249.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ip",
    x1: 494.056,
    y1: 79.774,
    x2: 517.81,
    y2: 125.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iq",
    x1: 407.072,
    y1: 46.036,
    x2: 416.988,
    y2: 61.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ir",
    x1: 392.805,
    y1: 90.416,
    x2: 484.417,
    y2: 90.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2D3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#393C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1D1515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "is",
    x1: 288.025,
    y1: 212.514,
    x2: 278.654,
    y2: 70.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "it",
    x1: 374.501,
    y1: 131.533,
    x2: 396.214,
    y2: 127.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iu",
    x1: 423.159,
    y1: 148.71,
    x2: 442.637,
    y2: 146.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iv",
    x1: 445.672,
    y1: 156.84,
    x2: 465.145,
    y2: 154.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iw",
    x1: 476.343,
    y1: 175.185,
    x2: 495.82,
    y2: 173.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix",
    x1: 494.254,
    y1: 128.632,
    x2: 493.363,
    y2: 153.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iy",
    x1: 520.074,
    y1: 180.965,
    x2: 524.763,
    y2: 156.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iz",
    x1: 472.95,
    y1: 119.96,
    x2: 474.586,
    y2: 144.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iA",
    x1: 452.141,
    y1: 108.812,
    x2: 453.785,
    y2: 133.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iB",
    x1: 393.627,
    y1: 135.864,
    x2: 413.102,
    y2: 133.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iC",
    x1: 418.817,
    y1: 93.642,
    x2: 439.287,
    y2: 116.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iD",
    x1: 429.819,
    y1: 102.703,
    x2: 447.192,
    y2: 121.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iE",
    x1: 499.676,
    y1: 139.947,
    x2: 504.889,
    y2: 163.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iF",
    x1: 511.33,
    y1: 190.613,
    x2: 522.278,
    y2: 169.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iG",
    x1: 397.34,
    y1: 88.766,
    x2: 417.808,
    y2: 111.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#416250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#325942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iH",
    x1: 356.259,
    y1: 176.199,
    x2: 566.559,
    y2: 176.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iI",
    x1: 374.62,
    y1: 538.208,
    x2: 268.233,
    y2: -17.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2C2725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#383834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#41433E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#464A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iJ",
    x1: 566.335,
    y1: 400.731,
    x2: 718.354,
    y2: 408.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iK",
    x1: 489.952,
    y1: 448.096,
    x2: 694.101,
    y2: 503.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iL",
    x1: 528.83,
    y1: 493.506,
    x2: 740.444,
    y2: 485.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iM",
    x1: 555.635,
    y1: 495.684,
    x2: 767.25,
    y2: 487.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iN",
    x1: 604.805,
    y1: 503.771,
    x2: 816.42,
    y2: 495.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iO",
    x1: 442.994,
    y1: 468.596,
    x2: 654.608,
    y2: 460.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iP",
    x1: 543.14,
    y1: 392.534,
    x2: 695.158,
    y2: 400.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iQ",
    x1: 589.916,
    y1: 415.867,
    x2: 741.934,
    y2: 423.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iR",
    x1: 616.258,
    y1: 425.689,
    x2: 768.277,
    y2: 433.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iS",
    x1: 634.282,
    y1: 434.432,
    x2: 786.3,
    y2: 442.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iT",
    x1: 651.247,
    y1: 438.763,
    x2: 803.265,
    y2: 446.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iU",
    x1: 669.115,
    y1: 444.773,
    x2: 821.134,
    y2: 452.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1F2F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2F4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#446B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iV",
    x1: 245.255,
    y1: 452.761,
    x2: 390.164,
    y2: 546.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#291A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3C2C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4A3A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4F3F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iW",
    x1: 383.787,
    y1: 345.02,
    x2: 432.847,
    y2: 505.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2B1C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#332920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2D201B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iX",
    x1: 400.955,
    y1: 377.466,
    x2: 434.229,
    y2: 486.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2B1C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#332920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2D201B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iY",
    x1: 442.284,
    y1: 434.204,
    x2: 435.52,
    y2: 249.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#29201F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#372A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3C2E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iZ",
    x1: 418.125,
    y1: 376.335,
    x2: 416.522,
    y2: 332.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#29201F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#372A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3C2E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ja",
    x1: 463.901,
    y1: 371.05,
    x2: 462.23,
    y2: 325.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#29201F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#372A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3C2E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jb",
    x1: 434.297,
    y1: 391.17,
    x2: 431.871,
    y2: 324.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#241E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#261E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#251C17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jc",
    x1: 450.959,
    y1: 372.865,
    x2: 450.353,
    y2: 356.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#20181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#261E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#251C17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jd",
    x1: 497.336,
    y1: 453.455,
    x2: 715.256,
    y2: 453.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261E1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "je",
    x1: 3.745,
    y1: 798.976,
    x2: 76.183,
    y2: 847.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jf",
    x1: 91.334,
    y1: 815.887,
    x2: 139.936,
    y2: 848.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jg",
    x1: 383.566,
    y1: 852.038,
    x2: -12.33,
    y2: 749.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F5949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#354A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#37453A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#354939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jh",
    x1: 489.225,
    y1: 852.032,
    x2: 93.377,
    y2: 749.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F5949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#354A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#37453A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#354939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ji",
    x1: 273.506,
    y1: 843.698,
    x2: -21.299,
    y2: 767.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F5949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#354A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#37453A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#354939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jj",
    x1: 265.941,
    y1: 860.762,
    x2: 443.37,
    y2: 750.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#37503F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#435B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jk",
    x1: 284.519,
    y1: 887.927,
    x2: 592.05,
    y2: 696.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#37503F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#435B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jl",
    x1: 312.011,
    y1: 936.993,
    x2: -287.549,
    y2: 580.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#547860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4C6C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#415D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jm",
    x1: 319.832,
    y1: 808.513,
    x2: 213.298,
    y2: 878.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#446047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#385140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#344935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jn",
    x1: 15.475,
    y1: 593.8,
    x2: 380.42,
    y2: 1440.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jo",
    x1: 15.47,
    y1: 625.269,
    x2: 380.414,
    y2: 1472.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jp",
    x1: 226.651,
    y1: 471.019,
    x2: 22.394,
    y2: 722.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jq",
    x1: 21.404,
    y1: 419.497,
    x2: 172.377,
    y2: 784.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jr",
    x1: 251.413,
    y1: 456.248,
    x2: 41.469,
    y2: 714.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "js",
    x1: 290.85,
    y1: 498.436,
    x2: 211.459,
    y2: 687.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jt",
    x1: 370.637,
    y1: 572.942,
    x2: 165.059,
    y2: 615.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#476043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3D513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#354033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#30352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2E322D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ju",
    x1: 375.432,
    y1: 659.369,
    x2: 345.587,
    y2: 839.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#42623E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#345332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#344F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv",
    x1: 425.114,
    y1: 727.108,
    x2: 328.746,
    y2: 914.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#42623E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#345332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#344F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jw",
    x1: 382.699,
    y1: 779.975,
    x2: 351.519,
    y2: 840.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#446047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#385140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#344935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jx",
    x1: -12.457,
    y1: 687.474,
    x2: 768.13,
    y2: 1210.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F7D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#506A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#435B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2E4031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jy",
    x1: 216.459,
    y1: 838.874,
    x2: 33.114,
    y2: 723.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#476448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C5541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#374D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#354A3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jz",
    x1: 313.637,
    y1: 754.569,
    x2: 159.511,
    y2: 856.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5C8056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#446047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#385140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#344935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jA",
    x1: 596.61,
    y1: 715.132,
    x2: 747.852,
    y2: 912.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9BC060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#79A55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#62935D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#47744D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jB",
    x1: 626.274,
    y1: 655.617,
    x2: 779.443,
    y2: 862.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9BC060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#79A55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#62935D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#47744D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jC",
    x1: 736.235,
    y1: 648.176,
    x2: 739.644,
    y2: 949.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5C8F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#619862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5A8D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4B7652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#466E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jD",
    x1: 772.554,
    y1: 734.46,
    x2: 821.189,
    y2: 875.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5C8F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#619862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5A8D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4B7652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#466E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jE",
    x1: 717.182,
    y1: 654.013,
    x2: 882.761,
    y2: 979.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jF",
    x1: 878.404,
    y1: 727.372,
    x2: 900.023,
    y2: 789.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5A8C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#689860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#71A062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5C8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#47734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3F6B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jG",
    x1: 248.723,
    y1: 175.898,
    x2: 245.671,
    y2: 129.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#28221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#261E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#474C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jH",
    x1: 161.773,
    y1: 162.873,
    x2: 201.853,
    y2: 153.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jI",
    x1: 181.064,
    y1: 151.513,
    x2: 218.664,
    y2: 150.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jJ",
    x1: 196.595,
    y1: 144.145,
    x2: 234.202,
    y2: 142.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jK",
    x1: 253.822,
    y1: 166.458,
    x2: 274.876,
    y2: 153.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jL",
    x1: 281.586,
    y1: 156.896,
    x2: 300.194,
    y2: 145.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jM",
    x1: 273.762,
    y1: 158.048,
    x2: 292.37,
    y2: 147.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jN",
    x1: 264.725,
    y1: 161.06,
    x2: 283.327,
    y2: 150.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jO",
    x1: 278.381,
    y1: 114.851,
    x2: 295.831,
    y2: 127.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jP",
    x1: 290.066,
    y1: 112.064,
    x2: 307.512,
    y2: 124.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jQ",
    x1: 258.174,
    y1: 118.288,
    x2: 275.627,
    y2: 131.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jR",
    x1: 292.936,
    y1: 154.876,
    x2: 311.538,
    y2: 143.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jS",
    x1: 306.497,
    y1: 149.323,
    x2: 324.224,
    y2: 136.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jT",
    x1: 318.312,
    y1: 148.54,
    x2: 335.551,
    y2: 135.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jU",
    x1: 338.656,
    y1: 137.05,
    x2: 338.137,
    y2: 115.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jV",
    x1: 244.002,
    y1: 168.708,
    x2: 265.049,
    y2: 156.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#82A95B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jW",
    x1: 230.282,
    y1: 176.476,
    x2: 257.884,
    y2: 160.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#324640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#416539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jX",
    x1: 217.299,
    y1: 132.09,
    x2: 254.899,
    y2: 130.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3D4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jY",
    x1: 251.848,
    y1: 133.567,
    x2: 244.912,
    y2: 130.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#487D4C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-59 -43)",
    d: "M0 0h1512.52v954.48H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientAuthBackground);
export default __webpack_public_path__ + "static/media/client-auth-background.af1e82aef30a27b93c8a320c85881a28.svg";
export { ForwardRef as ReactComponent };